export default {
  'studio.business_bank_setting.title1': '個人／事業者資訊',
  'studio.business_bank_setting.guide1': '審查遊戲年齡分級時<br/>必不可少！',
  'studio.business_bank_setting.guide1_1': '請務必準備下列資料。',
  'studio.business_bank_setting.guide1_2': '個人（無事業者登記）：住民登錄謄本或護照',
  'studio.business_bank_setting.guide1_4': '事業者（個人／法人）：營業執照',
  'studio.business_bank_setting.title2': '銀行資訊',
  'studio.business_bank_setting.guide2': '將結算商品銷售款項至<br/>所輸入的帳號資訊！',
  'studio.business_bank_setting.bank_component_guide2_1': '請準備存摺影本並填寫相關資訊。',
  'studio.business_bank_setting.group_settings': '團隊設定',
  'studio.business_bank_setting.group_history': '管理紀錄',
  'studio.business_bank_setting.group_discontinue': '刪除團隊',
  'studio.business_bank_setting.guide2_1': '為什麼需要個人／事業者的資訊？ ',
  'studio.business_bank_setting.guide2_2': '遊戲上市前，必須收集個人／事業者資訊才可進行使用等級審查。<br/>由於審查最多需要3個工作天，建議提前申請。',
  'studio.business_bank_setting.guide2_3': '憑證資料的用途為何？',
  'studio.business_bank_setting.guide2_4': '用來確認輸入的資訊是否與實際的資料相符。',
  'studio.business_bank_setting.guide2_5': '遊戲製造（發行）業申報編號是什麼？',
  'studio.business_bank_setting.guide2_6':
    '想在韓國製作並販售或發行遊戲就必須進行遊戲製造（發行）業申報。此非必要項目，不適用於該情況時，可選擇不填寫！',
  'studio.business_bank_setting.guide2_7': '什麼是通訊販賣業申報編號？',
  'studio.business_bank_setting.guide2_8':
    '想在韓國透過網路向消費者販售商品就必須進行通訊販賣業申報喔！<br/>此非必要項目，不適用於該情況時，可選擇不填寫！',
  'studio.business_bank_setting.guide2_9': '營業執照編號／TAX ID',
  'studio.business_bank_setting.guide2_10': '可輸入公司的營業執照編號或TAX ID。<br/>必須輸入營業執照編號或TAX ID的其中一種。',
  'studio.business_bank_setting.guide2_11': '什麼是大韓民國遊戲製造（發行）業申報編號？',
  'studio.business_bank_setting.guide2_12':
    '想在韓國製作並販售或發行遊戲就必須進行遊戲製造（發行）業申報。此非必要項目，不適用於該情況時，可選擇不填寫！',
  'studio.business_bank_setting.guide2_13': '什麼是大韓民國通訊販賣業申報編號？',
  'studio.business_bank_setting.guide2_14':
    '想在韓國透過網路向消費者販售商品就必須進行通訊販賣業申報喔！<br/>此非必要項目，不適用於該情況時，可選擇不填寫！',
  'studio.business_bank_setting.guide2_15': '什麼是大韓民國營業執照編號？',
  'studio.business_bank_setting.guide2_16': '如已在韓國進行事業者登記，請附上大韓民國的營業執照及營業執照編號。<br/>不適用於該情況時，可選擇不填寫！',
  'studio.business_bank_setting.guide2_17': '顯示範例',
  'studio.business_bank_setting.in_review_guide1': '正在審查中',
  'studio.business_bank_setting.in_review_guide1_1': '審查需要3個工作天，可能視情況有所變動。<br/>審查完成時將透過電子郵件、通知來告知審查結果。 ',
  'studio.business_bank_setting.btn_details': '審查紀錄',
  'studio.business_bank_setting.btn_info': '提交內容',
  'studio.business_bank_setting.in_review_guide2': '正在審查中',
  'studio.business_bank_setting.in_review_guide2_1': '審查需要3個工作天，可能視情況有所變動。<br/>審查完成時將透過電子郵件、通知來告知審查結果。 ',
  'studio.business_bank_setting.reject1': '審查已被退回',
  'studio.business_bank_setting.reject2': '圖片未上傳成功。<br/>請確認後再重新上傳。',
  'studio.business_bank_setting.btn_modify': '修改',
  'studio.business_bank_setting.business_info1': '國家與地區',
  'studio.business_bank_setting.business_info2': '代表人姓名',
  'studio.business_bank_setting.business_info3': '代表人生日',
  'studio.business_bank_setting.business_info4': '營業執照編號',
  'studio.business_bank_setting.business_info5': '種類',
  'studio.business_bank_setting.business_info6': '事業者名稱',
  'studio.business_bank_setting.business_info7': '代表理事姓名',
  'studio.business_bank_setting.bank_info1': '國家與地區',
  'studio.business_bank_setting.bank_info2': '銀行名稱',
  'studio.business_bank_setting.bank_info3': '戶名',
  'studio.business_bank_setting.bank_info4': '帳號',
  'studio.business_bank_setting.bank_info5': 'SWIFT CODE',
  'studio.business_bank_setting.individual.question1': '您有營業執照嗎？',
  'studio.business_bank_setting.individual.question1_msg1': '請檢查必填的值。',
  'studio.business_bank_setting.individual.select_y': '是的，有。',
  'studio.business_bank_setting.individual.select_n': '不，沒有。',
  'studio.business_bank_setting.license_yn_select_req_msg': '請選擇是否具營業執照。',
  'studio.business_bank_setting.individual.quide1': '為什麼需要個人／事業者資訊？ ',
  'studio.business_bank_setting.individual.quide2':
    '遊戲上市前，必須收集個人／事業者資訊才可進行使用等級審查。<br/>由於審查最多需要3個工作天，建議提前申請。',
  'studio.business_bank_setting.individual.quide3': '憑證資料的用途為何？',
  'studio.business_bank_setting.individual.quide4': '用來確認輸入的資訊是否與實際的資料相符。',
  'studio.business_bank_setting.individual.question2': '請選擇國家與地區。',
  'studio.business_bank_setting.individual.question2_checkmsg': '與目前納稅的國家與地區相同',
  'studio.business_bank_setting.individual.input_name': '代表人姓名',
  'studio.business_bank_setting.individual.input_name_place_holder': '請輸入代表人姓名',
  'studio.business_bank_setting.individual.input_name_msg1': '請輸入代表人姓名。',
  'studio.common.def_key.exceed': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.select_gender': '代表人性別',
  'studio.business_bank_setting.individual.select_gender_male': '男性',
  'studio.business_bank_setting.individual.select_gender_female': '女性',
  'studio.business_bank_setting.individual.select_birth': '代表人生日',
  'studio.business_bank_setting.individual.select_birth_place_holder': 'YYYY-MM-DD',
  'studio.business_bank_setting.individual.select_birth_msg1': '請輸入代表人的生日。',
  'studio.business_bank_setting.individual.select_mobile_no': '代表人聯絡方式',
  'studio.business_bank_setting.individual.select_mobile_no_place_holder': '請輸入電話號碼',
  'studio.business_bank_setting.individual.select_mobile_no_msg1': '請輸入電話號碼。',
  'studio.common.def_key.number_only_y': '僅能輸入數字。 ',
  'studio.business_bank_setting.individual.select_ceo_email': '代表人電子信箱',
  'studio.business_bank_setting.individual.select_ceo_email_place_holder': '請輸入代表人的電子信箱',
  'studio.business_bank_setting.individual.select_ceo_email_msg1': '請輸入代表人的電子信箱。',
  'studio.business_bank_setting.individual.select_ceo_email_msg2': '電子信箱格式不正確。',
  'studio.business_bank_setting.individual.question3': '請選擇納稅的國家與地區',
  'studio.business_bank_setting.individual.question3_msg1': '有銷售額時，將以所選的國家為基準處理稅金。',
  'studio.business_bank_setting.individual.info_view_b_adress': '代表人地址',
  'studio.business_bank_setting.individual.info_global_adress_no': '郵遞區號',
  'studio.business_bank_setting.individual.info_global_adress_no_place_holder': '郵遞區號',
  'studio.business_bank_setting.individual.info_global_adress_no_required_n': '請搜尋郵遞區號。',
  'studio.business_bank_setting.individual.info_global_o_adress_place_holder': '請輸入地址',
  'studio.business_bank_setting.individual.info_global_o_adress_msg1': '請輸入地址。',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_place_holder': '請輸入詳細地址',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg1': '請輸入詳細地址。',
  'studio.business_bank_setting.individual.upload_resident': '住民登錄謄本',
  'studio.business_bank_setting.individual.upload_guide': '{info}以下',
  'studio.business_bank_setting.individual.upload_resident_guide': '請上傳住民登錄謄本',
  'studio.business_bank_setting.individual.btn_attach': '搜尋檔案',
  'studio.business_bank_setting.individual.info_global_street_place_holder': '請輸入街道名稱',
  'studio.business_bank_setting.individual.info_global_street_required_n': '請輸入街道名稱。',
  'studio.business_bank_setting.individual.info_global_building_place_holder': '請輸入建築物名稱',
  'studio.business_bank_setting.individual.info_global_building_required_n': '請輸入建築物名稱。',
  'studio.business_bank_setting.individual.info_global_city_place_holder': '請輸入城市名稱',
  'studio.business_bank_setting.individual.info_global_city_required_n': '請輸入城市名稱。',
  'studio.business_bank_setting.individual.info_global_county_place_holder': '請輸入州名',
  'studio.business_bank_setting.individual.info_global_county_required_n': '請輸入州名。',
  'studio.business_bank_setting.individual.review_officer_info': '審議負責人資訊',
  'studio.business_bank_setting.individual.review_officer_info_name': '姓名',
  'studio.business_bank_setting.individual.review_officer_info_name_place_holder': '請輸入姓名',
  'studio.business_bank_setting.individual.review_officer_info_name_msg2': '請輸入姓名。',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no': '聯絡方式',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_place_holder': '請輸入聯絡方式',
  'studio.business_bank_setting.individual.review_officer_info_mobile_no_msg1': '請輸入聯絡方式。',
  'studio.business_bank_setting.individual.review_officer_info_email': '電子信箱',
  'studio.business_bank_setting.individual.review_officer_info_email_place_holder': '請輸入電子信箱',
  'studio.business_bank_setting.individual.review_officer_info_email_msg1': '電子信箱格式不正確。',
  'studio.business_bank_setting.individual.review_officer_info_email_msg2': '請輸入電子信箱。',
  'studio.business_bank_setting.individual.settlement_officer_info': '合約／結算負責人資訊',
  'studio.business_bank_setting.individual.settlement_officer_info_guide1': '請輸入可查看合約及結算相關審議資訊的團隊主要負責人資訊',
  'studio.business_bank_setting.individual.settlement_officer_info_name': '姓名',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg2': '請輸入姓名。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_place_holder': '請輸入姓名',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no': '聯絡方式',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_place_holder': '請輸入聯絡方式',
  'studio.business_bank_setting.individual.settlement_officer_info_mobile_no_msg1': '請輸入聯絡方式。',
  'studio.business_bank_setting.individual.settlement_officer_info_email': '電子信箱',
  'studio.business_bank_setting.individual.settlement_officer_info_email_place_holder': '請輸入電子信箱',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg1': '電子信箱格式不正確。',
  'studio.business_bank_setting.individual.settlement_officer_info_email_msg2': '請輸入電子信箱。',
  'studio.business_bank_setting.individual.info_view_o_adress': '事業者地址',
  'studio.business_bank_setting.individual.question4': '營業執照編號（個人／法人）',
  'studio.business_bank_setting.individual.question4_place_holder': '請輸入營業執照編號',
  'studio.business_bank_setting.individual.enter_no_msg1': '請輸入營業執照編號。',
  'studio.business_bank_setting.individual.enter_no_msg3': '發生問題<br/>請稍後再重新嘗試。',
  'studio.business_bank_setting.individual.enter_no_msg4': '找不到該營業執照編號。 ',
  'studio.business_bank_setting.individual.info_view_b_name': '事業者名稱',
  'studio.business_bank_setting.individual.info_view_b_name_place_holder': '請輸入事業者名稱',
  'studio.business_bank_setting.individual.info_view_r_name': '代表理事姓名',
  'studio.business_bank_setting.individual.info_view_r_name_kr_place_holder': '請輸入代表理事的姓名',
  'studio.business_bank_setting.individual.info_view_b_type': '產業',
  'studio.business_bank_setting.individual.info_view_b_type_place_holder': '請輸入產業',
  'studio.business_bank_setting.individual.info_view_b_items': '種類',
  'studio.business_bank_setting.individual.info_view_b_items_place_holder': '請輸入種類',
  'studio.business_bank_setting.individual.info_view_adress': '事業者地址',
  'studio.business_bank_setting.individual.info_view_adress_place_holder': '請輸入事業者地址',
  'studio.business_bank_setting.individual.question5': '事業者聯絡方式',
  'studio.business_bank_setting.individual.question5_kr_place_holder': '請輸入事業者聯絡方式',
  'studio.business_bank_setting.individual.select_enter_kr_no_msg1': '請輸入事業者聯絡方式。',
  'studio.business_bank_setting.individual.b_email': '事業者電子信箱',
  'studio.business_bank_setting.individual.b_email_place_holder': '請輸入電子信箱',
  'studio.business_bank_setting.individual.b_email_msg1': '請輸入電子信箱。',
  'studio.business_bank_setting.individual.b_email_msg2': '電子信箱格式不正確。',
  'studio.business_bank_setting.individual.upload_buisiness': '營業執照',
  'studio.business_bank_setting.individual.upload_buisiness_guide': '請上傳營業執照',
  'studio.business_bank_setting.individual.upload_buisiness_req_msg': '請上傳營業執照。',
  'studio.business_bank_setting.individual.biz_reg_num': '營業執照編號（個人／法人）',
  'studio.business_bank_setting.individual.biz_reg_num_place_holder': '請輸入營業執照編號',
  'studio.business_bank_setting.individual.biz_reg_num_required': '請輸入營業執照編號。',
  'studio.business_bank_setting.individual.enter_no_msg5': '發生問題。<br/>請稍後再重新嘗試。<br/>如欲手動輸入事業者資訊，請點擊[手動輸入]。',
  'studio.business_bank_setting.individual.enter_no_msg5_manual': '手動輸入',
  'studio.business_bank_setting.individual.enter_no_msg5_close': '下次再說',
  'studio.business_bank_setting.individual.info_view_no': '營業執照編號',
  'studio.business_bank_setting.individual.info_view_no_place_holder': '請輸入營業執照編號',
  'studio.business_bank_setting.individual.info_view_type': '種類',
  'studio.business_bank_setting.individual.info_view_type1': '個人事業者',
  'studio.business_bank_setting.individual.info_view_type2': '法人事業者',
  'studio.business_bank_setting.individual.manual_info_view_no_required': '請輸入營業執照編號。',
  'studio.business_bank_setting.individual.manual_info_view_b_name_required': '請輸入事業者名稱。',
  'studio.business_bank_setting.individual.manual_info_view_r_name_kr_required': '請輸入代表理事的姓名。',
  'studio.business_bank_setting.individual.manual_info_view_b_type_required': '請輸入產業。',
  'studio.business_bank_setting.individual.manual_info_view_b_items_required': '請輸入種類。',
  'studio.business_bank_setting.individual.manual_info_view_adress_required': '請輸入事業者地址。',
  'studio.business_bank_setting.individual.question6': '選擇遊戲業類型',
  'studio.business_bank_setting.individual.question6_guide': '如同時進行遊戲開發及發行，請選擇仲介事業者（發行商）。',
  'studio.business_bank_setting.individual.question6_select1': '遊戲開發商',
  'studio.business_bank_setting.individual.question6_select2': '仲介事業者（發行商）',
  'studio.business_bank_setting.individual.question6_select3': '以上皆非',
  'studio.business_bank_setting.individual.question7': '選擇追加資訊',
  'studio.business_bank_setting.individual.question7_guide': '如欲提交其他資訊，請查看以下內容並選擇。若無追加資訊，則不需選擇。',
  'studio.business_bank_setting.individual.question7_select1': '遊戲製造（發行）業',
  'studio.business_bank_setting.individual.question7_select2': '通訊販賣業',
  'studio.business_bank_setting.individual.game_production_no_guide': '請上傳遊戲製造（發行）業登記證',
  'studio.business_bank_setting.individual.game_production_no_place_holder': '請輸入遊戲製造（發行）業申報編號',
  'studio.business_bank_setting.individual.game_production_no_msg1': '請輸入遊戲製造（發行）業申報編號。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide': '請上傳通訊販賣業登記證',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder': '請輸入通訊販賣業申報編號',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1': '請輸入通訊販賣業申報編號。',
  'studio.common.popup_case_save_btn': '儲存',
  'studio.business_bank_setting.individual.btn_save_alert1':
    '將依填寫的訊息提出審查請求，<br/>最多需要一～三個工作天。<br/> <br/>審查完成後，將透過電子郵件或通知<br/>另行告知。',
  'studio.common.popup_case_cf_btn': '確認',
  'studio.common.popup_case_cancel_btn': '取消',
  'studio.business_bank_setting.individual.btn_save_alert2': '已申請審查。 ',
  'studio.business_bank_setting.individual.btn_save_alert3': '個人／事業者資訊已正在審查中。<br/>請再次確認審查申請內容。',
  'studio.business_bank_setting.individual.settlement_officer_info_name_msg1': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_view': '事業者資訊',
  'studio.business_bank_setting.individual.info_view_b_name_msg1': '請輸入事業者名稱',
  'studio.business_bank_setting.individual.info_view_b_name_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_place_holder': '如有兩名以上，請以「、」區隔',
  'studio.business_bank_setting.individual.info_view_r_name_non_kr_msg1': '如有兩名以上，請以「、」區隔。',
  'studio.business_bank_setting.individual.info_view_r_name_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.question5_non_kr_place_holder': '請輸入電話號碼',
  'studio.business_bank_setting.individual.select_enter_non_kr_no_msg1': '請輸入電話號碼。',
  'studio.business_bank_setting.individual.info_global_adress_no_msg1': '請輸入郵遞區號。',
  'studio.business_bank_setting.individual.info_global_o_adress': '地址',
  'studio.business_bank_setting.individual.info_global_o_adress_msg2': '請輸入地址。',
  'studio.business_bank_setting.individual.info_global_o_adress_msg3': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_global_o_adress_detail': '詳細地址',
  'studio.business_bank_setting.individual.info_global_o_adress_detail_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.busuness_no': '營業執照編號',
  'studio.business_bank_setting.individual.busuness_no_place_holder': '請輸入營業執照編號',
  'studio.business_bank_setting.individual.busuness_no_msg1': '請輸入營業執照編號。',
  'studio.business_bank_setting.individual.info_view_tax': 'TAX ID',
  'studio.business_bank_setting.individual.info_view_tax_place_holder': '請輸入TAX ID（選填）',
  'studio.business_bank_setting.individual.info_view_tax_msg1': '請輸入TAX ID。',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder1': '郡、省',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder2': '縣市、鄉鎮市區',
  'studio.business_bank_setting.individual.info_global_street': '街道名稱',
  'studio.business_bank_setting.individual.info_global_street_msg1': '請輸入街道名稱。',
  'studio.business_bank_setting.individual.info_global_street_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_global_building': '建築物名稱',
  'studio.business_bank_setting.individual.info_global_building_msg1': '請輸入建築物名稱。',
  'studio.business_bank_setting.individual.info_global_building_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_global_city': '城市名稱',
  'studio.business_bank_setting.individual.info_global_city_msg1': '請輸入城市名稱。',
  'studio.business_bank_setting.individual.info_global_city_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.info_global_county': '州名',
  'studio.business_bank_setting.individual.info_global_county_msg1': '請輸入州名。',
  'studio.business_bank_setting.individual.info_global_county_msg2': '不得超過{length}個字。',
  'studio.business_bank_setting.individual.question6_select1_kr': '大韓民國遊戲製造（發行）業',
  'studio.business_bank_setting.individual.question6_select2_kr': '大韓民國通訊販賣業',
  'studio.business_bank_setting.individual.question6_select3_kr': '韓國營業執照',
  'studio.business_bank_setting.individual.game_production_no_kr_guide': '請上傳大韓民國遊戲製造（發行）業登記證',
  'studio.business_bank_setting.individual.game_production_no_place_holder_kr': '請輸入大韓民國遊戲製造（發行）業申報編號',
  'studio.business_bank_setting.individual.game_production_no_msg1_kr': '請輸入大韓民國遊戲製造（發行）業申報編號。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_guide': '請上傳大韓民國通訊販賣業登記證',
  'studio.business_bank_setting.individual.telecom_sales_no_place_holder_kr': '請輸入大韓民國通訊販賣業申報編號',
  'studio.business_bank_setting.individual.telecom_sales_no_msg1_kr': '請輸入大韓民國通訊販賣業申報編號。',
  'studio.business_bank_setting.individual.game_business_no_kr_guide': '請上傳韓國營業執照',
  'studio.business_bank_setting.individual.game_business_no_place_holder_kr': '請輸入韓國營業執照編號',
  'studio.business_bank_setting.individual.game_business_no_msg1_kr': '請輸入韓國營業執照編號。',
  'studio.business_bank_setting.account.question1': '銀行所在國家與地區',
  'studio.business_bank_setting.account.question2': '帳號資訊',
  'studio.business_bank_setting.account.question3_place_holder': '請選擇銀行',
  'studio.business_bank_setting.account.question3_msg1': '請選擇銀行。',
  'studio.business_bank_setting.account.question4_place_holder': '請輸入帳號',
  'studio.business_bank_setting.account.question4_msg1': '請輸入帳號。',
  'studio.business_bank_setting.account.question5_place_holder': '請輸入戶名',
  'studio.business_bank_setting.account.question5_msg1': '請輸入戶名。',
  'studio.business_bank_setting.account.question5_btn': '確認戶名',
  'studio.business_bank_setting.account.question6': '存摺影本',
  'studio.business_bank_setting.account.upload_guide': '{info}以下',
  'studio.business_bank_setting.account.question6_guide': '請上傳存摺影本 ',
  'studio.business_bank_setting.account.btn_attach': '搜尋檔案',
  'studio.business_bank_setting.account.question5_btn_msg2': '發生問題。<br/>請稍後再重新試。<br/>如欲手動輸入帳號資訊，請點擊[手動輸入]。',
  'studio.business_bank_setting.account.question5_btn_msg2_btn1': '手動輸入',
  'studio.business_bank_setting.account.question5_btn_msg2_btn2': '下次再說',
  'studio.business_bank_setting.account.question5_btn_msg3': '資訊不正確。',
  'studio.business_bank_setting.account.question5_btn_msg4': '帳號持有人資訊一致。 ',
  'studio.business_bank_setting.account.question5_btn_msg4_retry_btn': '重新查詢',
  'studio.business_bank_setting.info_review_req_btn': '申請審查',
  'studio.business_bank_setting.account.btn_save_alert1':
    '將依填寫的資訊申請審查。<br/>最多需要5個工作天。<br/> <br/>審查完成後，將透過電子郵件通知或另行通知。',
  'studio.business_bank_setting.account.btn_save_alert2': '請完成帳號持有人資訊的查詢。',
  'studio.business_bank_setting.account.question3': '銀行資訊',
  'studio.business_bank_setting.account.question3_usa_place_holder': '請輸入銀行名稱',
  'studio.business_bank_setting.account.question3_usa_msg1': '請輸入銀行名稱。',
  'studio.business_bank_setting.account.question7': '分行名稱',
  'studio.business_bank_setting.account.question7_usa_place_holder': '請輸入分行名稱（選填）',
  'studio.business_bank_setting.account.question7_usa_msg1': '請輸入分行名稱。',
  'studio.business_bank_setting.account.question8': '銀行地址',
  'studio.business_bank_setting.account.question8_usa_place_holder': '請輸入銀行地址',
  'studio.business_bank_setting.account.question8_usa_msg1': '請輸入銀行地址。',
  'studio.business_bank_setting.account.question9': 'undefined',
  'studio.business_bank_setting.account.question9_usa_place_holder': '請輸入SWIFT CODE',
  'studio.business_bank_setting.account.question9_usa_msg1': '請輸入SWIFT CODE。',
  'studio.business_bank_setting.account.question10': '分行代碼',
  'studio.business_bank_setting.account.question10_usa_place_holder': '請輸入分行代碼',
  'studio.business_bank_setting.account.question10_usa_msg1': '請輸入分行代碼。',
  'studio.business_bank_setting.account.question4': '帳號',
  'studio.business_bank_setting.account.question5': '戶名',
  'studio.business_bank_setting.account.question5_place_holder1': '姓名',
  'studio.business_bank_setting.account.question5_msg11': '請輸入姓名。',
  'studio.business_bank_setting.account.question5_place_holder2': '姓氏',
  'studio.business_bank_setting.account.question5_msg12': '請輸入姓氏',
  'studio.business_bank_setting.account.question11': 'IBAN CODE',
  'studio.business_bank_setting.account.question11_eu_place_holder': '請輸入IBAN CODE ',
  'studio.business_bank_setting.account.question10_eu_msg1': '請輸入IBAN CODE。 ',
  'studio.business_bank_setting.account.question12': 'undefined',
  'studio.business_bank_setting.account.question12_ca_place_holder': '請輸入CC CODE',
  'studio.business_bank_setting.account.question12_ca_msg1': '請輸入CC CODE。',
  'studio.business_bank_setting.list_name': '個人／事業者資訊審查紀錄',
  'studio.business_bank_setting.list_title1': '狀態',
  'studio.business_bank_setting.list_title2': '個人／事業者類型',
  'studio.business_bank_setting.list_title3': '代表人姓名／事業者名稱',
  'studio.business_bank_setting.list_title4': '申請日期',
  'studio.business_bank_setting.list_title5': '完成日期',
  'studio.business_bank_setting.list_no_data': '查無紀錄',
  'studio.business_bank_setting.account_list_name': '銀行資訊審查紀錄',
  'studio.business_bank_setting.account_list_title1': '狀態',
  'studio.business_bank_setting.account_list_title2': '銀行名稱',
  'studio.business_bank_setting.account_list_title3': '帳號',
  'studio.business_bank_setting.account_list_title4': '申請日期',
  'studio.business_bank_setting.account_list_title5': '完成日期',
  'studio.business_bank_setting.account_list_no_data': '查無紀錄',
  'studio.gnb.common_language_ko': '한국어',
  'studio.gnb.common_language_us': 'English (US)',
  'studio.gnb.common_language_zh_cn': '简体中文',
  'studio.gnb.common_language_zh_tw': '繁體中文',
  'studio.gnb.common_language_ja': '日本語',
  'studio.gnb.common_product_key': '商品key',
  'studio.gnb.common_1depth_product_home': '商品首頁',
  'studio.gnb.common_2depth_plan': '上市現況',
  'studio.gnb.common_1depth_product_management': '商品頁面管理',
  'studio.gnb.common_2depth_setting': '商品設定',
  'studio.gnb.common_2depth_product_page': '商品頁面',
  'studio.gnb.common_2depth_sale': '購買條件',
  'studio.gnb.common_2depth_early_access': '搶先體驗字句設定',
  'studio.gnb.common_2depth_price': '價格',
  'studio.gnb.common_2depth_discount': '折扣',
  'studio.gnb.common_1depth_product_data': '商品資料管理',
  'studio.gnb.common_2depth_build': '管理組建',
  'studio.gnb.common_2depth_execution': '執行設定',
  'studio.gnb.common_2depth_tier_review': '使用等級及組建審查',
  'studio.gnb.common_2depth_condition': '商品條款',
  'studio.gnb.common_2depth_stats': '統計值',
  'studio.gnb.common_2depth_ranking': '排名',
  'studio.gnb.common_2depth_challenges': '挑戰課題',
  'studio.gnb.common_2depth_cloud': '雲端儲存',
  'studio.gnb.common_2depth_match': '配對',
  'studio.gnb.common_1depth_marketing': '商品行銷管理',
  'studio.gnb.common_2depth_banner': '橫幅圖片',
  'studio.gnb.common_1depth_in_app_purchase': '遊戲內商店',
  'studio.gnb.common_2depth_in_app_setting': '遊戲內付款設定',
  'studio.gnb.common_2depth_in_app_shop': '遊戲內商店',
  'studio.gnb.common_2depth_in_app_product': '遊戲內商品',
  'studio.gnb.common_2depth_in_app_discount': '遊戲內折扣商品',
  'studio.gnb.common_2depth_in_app_payment_history': '遊戲內付款紀錄',
  'studio.lnb.common_1depth_studio_group': 'Studio團隊',
  'studio.lnb.common_2depth_studio_home': '首頁',
  'studio.lnb.common_2depth_product_management': '專案商品管理',
  'studio.lnb.common_2depth_collection': '組合',
  'studio.lnb.common_2depth_store_community': '商店論壇',
  'studio.lnb.common_2depth_studio_metrics': '指標',
  'studio.lnb.common_2depth_studio_settlement': '結算',
  'studio.lnb.common_2depth_member_management': '成員管理',
  'studio.lnb.common_2depth_business_info': '事業者銀行資訊',
  'studio.lnb.common_2depth_game_check': '遊戲維護',
  'studio.lnb.common_1depth_studio_support': '支援',
  'studio.lnb.common_2depth_creator_news': '製作人消息',
  'studio.lnb.common_2depth_creator_benefit': '製作人支援優惠',
  'studio.lnb.common_2depth_creator_community': '製作人論壇',
  'studio.lnb.common_2depth_team_community': '團隊論壇',
  'studio.lnb.common_2depth_discord': 'Discord頻道',
  'studio.lnb.common_2depth_studio_dev_guide': '開發者指南',
  'studio.lnb.common_2depth_studio_noti': 'Studio公告事項',
  'studio.common.popup_case_a': 'A.確認儲存視窗',
  'studio.common.popup_case_a_without_saving': '有修改的內容。<br/>要不儲存直接離開嗎？',
  'studio.common.popup_case_a_without_saving_exit_btn': '離開',
  'studio.common.popup_case_b': 'B.錯誤說明視窗',
  'studio.common.popup_case_b_error_retry': '請重新整理或稍後再試。 ',
  'studio.common.popup_case_c': 'C.儲存完成及套用方法說明視窗',
  'studio.common.popup_case_c_plan': '已儲存。<br/>請在上市中進行套用。',
  'studio.common.popup_case_d': 'D.儲存完成說明視窗',
  'studio.common.popup_case_d_complete_save': '已儲存。',
  'studio.common.popup_case_e': 'E.儲存完成及客戶端測試說明視窗',
  'studio.common.popup_case_e_after_testing': '已儲存。<br/>請在PC客戶端中測試後再套用為最新版本。',
  'studio.common.popup_case_f': 'D.刪除完成說明視窗',
  'studio.common.popup_case_f_complete_del': '已刪除。',
  'studio.common.popup_case_g_not_view': '您沒有查詢權限。<br/>請向團隊管理員詢問。',
  'studio.common.popup_case_h_not_edit': '您沒有編輯權限。<br/>請向團隊管理員詢問。',
  'studio.common.live_apply_btn': '套用為最新版本',
  'studio.common.popup_case_i_release_guide': '如欲套用，請輸入「RELEASE」。',
  'studio.common.popup_case_i_release_place_holder': 'RELEASE',
  'studio.common.popup_case_i_release_msg1': '請輸入大寫「RELEASE」。',
  'studio.common.popup_case_apply_btn': '套用',
  'studio.ai_translation.title1_settings': '多國語言設定',
  'studio.ai_translation.base_lang': '基準語言',
  'studio.ai_translation.base_lang_tool_tip': '翻譯成多國語言時的基本語言。<br/>只有團隊代表可於團隊首頁點擊語言按鈕後更改。',
  'studio.ai_translation.base_lang_en': '英文',
  'studio.ai_translation.base_lang_ja': '日文',
  'studio.ai_translation.base_lang_zh_cn': '簡體中文',
  'studio.ai_translation.base_lang_zh_tw': '繁體中文',
  'studio.ai_translation.progress_wait_msg': 'AI正在翻譯中。<br/>請稍候。',
  'studio.ai_translation.all_btn': '用AI翻譯全文',
  'studio.common.popup_case_ai_overwrite': '有已輸入的內容。<br/>確定要用AI翻譯全文嗎？<br/>進行翻譯時，原先內容將被覆蓋。',
  'studio.common.popup_case_translation_in_progress_btn': '進行翻譯',
  'studio.common.popup_case_ai_not_entered': '多國語言設定中有尚未輸入的內容。<br/>輸入多國語言後即可上市。',
  'studio.common.popup_case_ai_modified': '已修改多國語言設定的目標項目。<br/>確定要不修改多國語言直接儲存嗎？',
  'studio.ai_translation.title2_product': '商品名稱',
  'studio.ai_translation.title3_creator': '製作人名稱',
  'studio.ai_translation.title4_distributor': '發行商名稱',
  'studio.ai_translation.title5_tagline': '單行介紹文',
  'studio.ai_translation.title6_product_des': '商品說明',
  'studio.ai_translation.title7_absence': '前置標籤',
  'studio.ai_translation.title8_link': '連結',
  'studio.ai_translation.title9_terms': '條款內容',
  'studio.ai_translation.title10_early': '搶先體驗說明',
  'studio.ai_translation.title11_option': '執行選項{optionNo}',
  'studio.prj_prod.this_prod.stt_product_page_upcoming': '商品頁面即將開放',
  'studio.prj_prod.this_prod.stt_product_page_released': '商品頁面開放',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn': '商品頁面暫停開放',
  'studio.prj_prod.this_prod.stt_pre_order_period': '預購中',
  'studio.prj_prod.this_prod.stt_official_released': '正式上市',
  'studio.prj_prod.this_prod.stt_release_sale_suspended': '停售',
  'studio.prj_prod.this_prod.stt_del_req_completed': '申請刪除',
  'studio.prj_prod.this_prod.stt_del_req_rejected': '申請刪除退回',
  'studio.prj_prod.this_prod.stt_restriction_display_user_report': '限制顯示（使用者檢舉）',
  'studio.prj_prod.this_prod.stt_restriction_install': '限制執行',
  'studio.prj_prod.this_prod.stt_restriction_for_sales': '限制購買',
  'studio.prj_prod.this_prod.stt_restriction_display_operator_stove': '限制顯示',
  'studio.prj_prod_mngmt.review_restricted_case': '限制審議',
  'studio.prj_prod.status_in_review': '審查中',
  'studio.prj_prod.status_review_completed': '審查完成',
  'studio.prj_prod.this_prod.stt_restriction_for_collection': '限制購買組合',
  'studio.prj_prod.this_prod.stt_product_page_review_requested': '申請審查商品頁面',
  'studio.prj_prod.this_prod.stt_product_page_in_review': '商品頁面審查中',
  'studio.prj_prod.this_prod.stt_product_page_in_review_declined': '商品頁面審查退回',
  'studio.prj_prod.this_prod.stt_product_page_in_review_approved': '商品頁面審查完成',
  'studio.prj_prod.this_prod.stt_product_page_display_suspended': '商品頁面暫停顯示',
  'studio.prj_prod.this_prod.stt_product_page_display_resumed': '商品頁面恢復顯示',
  'studio.prj_prod.this_prod.stt_product_deletion_request': '申請刪除商品',
  'studio.prj_prod.this_prod.stt_product_deletion_declined': '商品刪除申請退回',
  'studio.prj_prod.this_prod.stt_price_review_requested': '申請價格審查',
  'studio.prj_prod.this_prod.stt_price_in_review': '價格審查中',
  'studio.prj_prod.this_prod.stt_price_review_declined': '價格審查退回',
  'studio.prj_prod.this_prod.stt_price_review_approved': '價格審查完成',
  'studio.prj_prod.this_prod.stt_build_rating_review_requested': '申請組建及使用等級審查',
  'studio.prj_prod.this_prod.stt_build_rating_in_review': '組建及使用等級審查中',
  'studio.prj_prod.this_prod.stt_build_rating_review_approved': '組建及使用等級審查完成',
  'studio.prj_prod.this_prod.stt_build_rating_review_declined': '組建及使用等級審查退回',
  'studio.prj_prod.this_prod.stt_release_review_requested': '申請正式上市審查',
  'studio.prj_prod.this_prod.stt_release_in_review': '正式上市審查中',
  'studio.prj_prod.this_prod.stt_release_declined': '正式上市審查退回',
  'studio.prj_prod.this_prod.stt_release_approved': '正式上市審查完成',
  'studio.prj_prod.this_prod.stt_release_upcoming': '待上市',
  'studio.prj_prod.this_prod.stt_pre_order_started': '開始預購',
  'studio.prj_prod.this_prod.stt_pre_order_ended': '預購結束',
  'studio.prj_prod.this_prod.stt_release_sale_resumed': '恢復販售',
  'studio.loading_ui.msg': '正在處理中。<br/>請稍候。',
  'studio.page_not_found.msg1': '回到首頁',
  'studio.page_not_found.msg2': '上一頁',
  'studio.page_not_found.msg3': '找不到您要的頁面。',
  'studio.page_not_found.msg4': '請返回上一頁並重新嘗試。',
  'studio.page_not_found.home_dir_btn': '5秒後將返回上一頁。 ',
  'studio.stu_logged_in.pre_grp_join.nickname': 'Studio暱稱',
  'studio.stu_logged_in.pre_grp_join.btn_my_info': '我的資訊',
  'studio.stu_logged_in.pre_grp_join.btn_logout': '登出',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg1': '如果您是團隊代表',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg2': '創建新團隊',
  'studio.stu_logged_in.pre_grp_join.btn_create_new_grp': '創建新團隊',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide1': '請輸入團隊名稱。',
  'studio.stu_logged_in.pre_grp_join.create_grp_guide2': '這將用於在Studio中管理團隊，請輸入開發商或發行商名稱。團隊名稱可隨時修改。',
  'studio.stu_logged_in.pre_grp_join.create_grp_name_place_holder': '請輸入團隊名稱',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg2': '請輸入團隊名稱。 ',
  'studio.stu_logged_in.pre_grp_join.create_grp_val_msg3': '已有相同的團隊名稱。請輸入其他團隊名稱。',
  'studio.stu_logged_in.pre_grp_join.btn_create_grp': '創建',
  'studio.stu_logged_in.pre_grp_join.create_over_10grp_msg': '最多可創建10個團隊。',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg1': '如果您是團隊成員',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg2': '確認團隊加入狀態',
  'studio.stu_logged_in.pre_grp_join.grp_join_stt_msg3':
    '已經收到團隊邀請碼並申請加入了嗎？<br/>該團隊的代表批准後才能前往團隊空間。<br/>請確認團隊加入狀態。',
  'studio.stu_logged_in.pre_grp_join.btn_chk_grp_join_stt': '確認加入狀態',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg1': '加入邀請碼已過期。',
  'studio.stu_logged_in.pre_grp_join.invitation_expired_msg2': '請團隊代表人重新分享邀請碼後，再申請加入。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg1': '已申請加入團隊。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_done_msg2': '請在登入的狀態下確認申請是否已被核准。',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_msg': '已被批准加入團隊。',
  'studio.stu_logged_in.pre_grp_join.grp_go_to_grp_pg_guide': '前往團隊頁面。',
  'studio.stu_logged_in.pre_grp_join.btn_go_to_grp_pg': '前往團隊',
  'studio.stu_logged_in.pre_grp_join.grp_join_req_accepted_noti': '已核准加入{grpName}。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_title': '團隊創建完畢',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg1': '歡迎加入STOVE Studio。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg2': 'Studio中有一個名為團隊的空間，用於開發及營運遊戲。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_msg3': '在您創建的團隊中生成邀請碼，並將成員加至團隊中使用Studio服務。',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_name': '團隊名稱：',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_create_date': '創建日期： ',
  'studio.stu_logged_in.pre_grp_join.email_grp_create_done_grp_pg_dir_btn': '立即前往Studio團隊',
  'studio.gnb.group_myinfo.email': '電子信箱',
  'studio.gnb.group_myinfo.nickname': '暱稱',
  'studio.gnb.group_myinfo.nickname_edit1': '暱稱',
  'studio.gnb.group_myinfo.nickname_edit2': '請輸入欲修改的暱稱',
  'studio.gnb.group_myinfo.btn_nickname_edit_save': '修改',
  'studio.gnb.group_myinfo.nickname_edit_place_holder': '請輸入欲修改的暱稱',
  'studio.gnb.group_myinfo.nickname_edit_val_msg1': '請輸入2個字以上，20個字以下。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg2': '請輸入欲修改的暱稱。',
  'studio.gnb.group_myinfo.nickname_edit_val_msg3': '無法使用重複的暱稱，<br/>請輸入其他暱稱。',
  'studio.gnb.group_myinfo.registration_time': 'Studio註冊日期',
  'studio.gnb.group_myinfo.my_group': '我的團隊',
  'studio.gnb.group_myinfo.my_group_role_type': '職務類別 ',
  'studio.gnb.group_myinfo.my_group_role_type_owner': '團隊代表',
  'studio.gnb.group_myinfo.my_group_role_type_mem': '團隊成員',
  'studio.gnb.group_myinfo.waitlist': '等待清單 ',
  'studio.gnb.group_myinfo.my_group_group_name': '團隊名稱',
  'studio.gnb.group_myinfo.my_group_join_date_time': '加入日期',
  'studio.gnb.group_myinfo.my_group_none': '尚未加入任何團隊',
  'studio.gnb.group_myinfo.terms_agreement': '同意紀錄',
  'studio.gnb.group_myinfo.terms_agreement.term1': 'Studio使用條款({date})',
  'studio.gnb.group_myinfo.terms_agreement.term_agree_time': '已於{time}同意',
  'studio.gnb.group_myinfo.terms_agreement.btn_view_term1': '查看條款 ',
  'studio.gnb.group_myinfo.terms_agreement.term2': '同意收集及使用個人資訊({date})',
  'studio.gnb.group_myinfo.terms_agreement_btn_view_term2': '查看條款 ',
  'studio.gnb.group_myinfo.terms_agreement_mkt': '同意接收廣告訊息',
  'studio.gnb.group_myinfo.terms_agreement_mkt1': '無論同意與否，均會發送主要公告事項及活動參與通知等內容。',
  'studio.gnb.group_myinfo.terms_agreement_mkt_checkbox': '同意',
  'studio.gnb.group_myinfo.terms_agreement_mkt_agree_time': '已於{dateTime}同意',
  'studio.gnb.group_myinfo.terms_agreement_mkt_reject_time': '已於{dateTime}拒絕接收',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb1': '我的資訊 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_breadcrumb2': '團隊資訊',
  'studio.gnb.group_myinfo.my_group.detailed_group_join_time': '已於{dateTime}加入',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission': '我的團隊選單權限',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_edit': '編輯',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_by_menu': '編輯權限',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_menu_name': '選單',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_grp_home': '團隊儀表板',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_prj_prod': '專案及商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_collection': '組合',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_store_comm': '商店論壇',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_mem_mgmt': '成員管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_biz_bank_info': '事業者銀行資訊設定',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr': '編輯權限內容',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr1': '儀表板設定',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr2': '創建、修改、刪除專案<br/>創建、刪除商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr3': '建立、修改、刪除組合',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr4': '建立、修改、刪除論壇',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr5': '邀請成員、建立職務、修改、驅逐',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr6': '事業者資訊登錄、修改、審核<br/>登錄銀行資訊、修改審查',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_view': '查詢',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_by_menu': '選單 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_home': '團隊儀表板',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_prj_prod': '專案及商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_collection': '組合',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_store_comm': '商店論壇',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_mem_mngmt': '成員管理',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_statistics': '指標',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_bill_settlement': '結算',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_biz_bank_info': '事業者銀行資訊',
  'studio.gnb.group_myinfo.my_group.detailed_group_per_overall_maint': '遊戲維護',
  'studio.gnb.group_myinfo.my_group.detailed_group_collapse_all_btn': '全部收起 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_expand_all_btn': '全部展開',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_name': '商品',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_role': '職務 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_permission_given_date': '權限賦予日期',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_name': '專案',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_group': '退出團隊',
  'studio.gnb.group_myinfo.my_group.detailed_group_product_num': '商品數量 ',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_num_none': '沒有列表',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_group_msg': '確定要退出團隊嗎？',
  'studio.gnb.group_myinfo.my_group.detailed_group_btn_leave_cf': '退出',
  'studio.gnb.group_myinfo.my_group.detailed_group_leave_done_msg': '已退出團隊',
  'studio.gnb.group_myinfo.my_group.detailed_group_click_error_msg': '請重新整理或<br/>重新嘗試。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_uncheck_msg': '已解除同意接收廣告訊息。',
  'studio.gnb.group_myinfo.my_group.detailed_group_mkt_check_msg': '已設為同意接收廣告訊息。',
  'studio.gnb.group_myinfo.join_req_waitlist': '等待清單',
  'studio.gnb.group_myinfo.join_req_group_name': '團隊名稱',
  'studio.gnb.group_myinfo.join_req_date_time': '申請加入日期',
  'studio.gnb.group_myinfo.join_req_status': '狀態',
  'studio.gnb.group_myinfo.join_req_none': '沒有列表',
  'studio.gnb.grp_myinfo.join_req_stt_rejected': '拒絕',
  'studio.gnb.group_myinfo.join_req_stt_waiting': '等待中',
  'studio.gnb.group_myinfo_terms1_popup_usage_term': 'STOVE Studio使用條款',
  'studio.gnb.group_myinfo_terms1_popup_usage_term_title': 'STOVE Studio使用條款',
  'studio.gnb.group_myinfo_terms1_popup_btn_close': '關閉',
  'studio.gnb.group_myinfo_terms2_popup_usage_term': '同意收集及使用個人資訊',
  'studio.gnb.group_myinfo_terms2_popup_btn_close': '關閉鍵 ',
  'studio.gnb.group_myinfo_terms2_popup_usage_term_title': '同意收集及使用個人資訊',
  'studio.notice.none_guide': '沒有登錄的公告事項。',
  'studio.notice.see_more_btn': '查看詳情',
  'studio.lnb.notice': 'Studio公告事項',
  'studio.group.home.btn_create_new_group': '創建新團隊',
  'studio.group.home.group_lnb_title': 'Studio團隊',
  'studio.group.home.title_group_name': '{grpName}團隊',
  'studio.group.home.title_group_name_change_title1': '請輸入團隊名稱。',
  'studio.group.home.title_group_name_change_title2': '這將用於在Studio中管理團隊，可隨時修改。',
  'studio.group.home.title_group_name_change_place_holder': '請輸入團隊名稱',
  'studio.group.home.title_group_name_change_val_msg1': '請輸入團隊名稱。',
  'studio.group.home.title_group_name_change_msg2': '已有相同的團隊名稱。請輸入其他團隊名稱。',
  'studio.group.home.title_group_name_change_btn_modify': '修改',
  'studio.group.home.language_tool_tip': '翻譯成多國語言時的基本語言。<br/>只有團隊代表可於團隊首頁點擊語言按鈕後更改。',
  'studio.group.home.language_standard_setting': '設定基準語言',
  'studio.group.home.language_standard_guide1': '團隊內的所有商品會套用所選語言的AI翻譯。 ',
  'studio.group.home.language_standard_guide2': '非必要時請勿變更。變更語言後，請確認AI翻譯是否正常套用。',
  'studio.basic_lang_setting.us': '英文',
  'studio.basic_lang_setting.ko': '韓文',
  'studio.basic_lang_setting.ja': '日文',
  'studio.basic_lang_setting.zh_cn': '簡體中文',
  'studio.basic_lang_setting.zh_tw': '繁體中文',
  'studio.group.home.language_standard_change': '變更',
  'studio.group.home.join_req_accepted_popup': '已被批准加入團隊。<br/>前往團隊頁面。',
  'studio.group.home.join_req_accepted_popup_close_btn': '關閉',
  'studio.group.home.join_req_accepted_grp_dir_btn': '前往團隊',
  'studio.group.home.join_req_accepted_noti': '已核准加入{grpName}。',
  'studio.group.home.board_type1': '專案商品管理',
  'studio.group.home.board_type1_no_data1': '未持有專案',
  'studio.group.home.board_type1_no_data2': '要去登錄專案嗎？',
  'studio.group.home.board_type1_no_data_btn': '前往登錄專案',
  'studio.group.home.board_type1_data1': '專案',
  'studio.group.home.board_type1_data2': '商品',
  'studio.group.home.board_type2': '團隊成員',
  'studio.group.home.board_type2_no_data1': '邀請和您一起進行專案的成員吧！',
  'studio.group.home.board_type2_mem_count': '{memCount}人',
  'studio.group.home.board_type3': '商品累積販售排名',
  'studio.group.home.board_type3_data1': '累積銷售量／購買轉換率',
  'studio.group.home.board_type4': '{currentMonth}月預估銷售金額',
  'studio.group.home.board_type4_no_data1': '為進行結算，需團隊的銀行資訊。',
  'studio.group.home.board_type4_no_data2': '要登錄銀行資訊嗎？',
  'studio.group.home.board_type4_no_data_btn': '前往登錄專案',
  'studio.group.home.board_type5': '上市',
  'studio.group.home.board_type5_stt_to_be_opened_badge': '預計',
  'studio.group.home.board_type5_stt_to_be_opened_guide': '預計開放商品頁面',
  'studio.group.home.board_type5_stt_live_applied_badge': '套用至LIVE',
  'studio.group.home.board_type5_stt_live_applied_guide': '開始預購',
  'studio.group.home.board_type5_stt_to_be_applied_badge': '預計套用',
  'studio.group.home.board_type5_stt_to_be_applied_guide': '正式上市',
  'studio.group.home.board_type6': '商店心得',
  'studio.group.home.board_type6_no_data1_after': '沒有近期的商品心得',
  'studio.group.home.board_type6_no_data2_after': '沒有近期的留言',
  'studio.group.home.board_type6_data1_after': '商店心得',
  'studio.group.home.board_type6_data2_after': '近期留言 ',
  'studio.group.home.board_type7': '商店論壇',
  'studio.group.home.board_type7_no_data1_after': '沒有近期的貼文',
  'studio.group.home.board_type7_no_data2_after': '沒有近期的留言',
  'studio.group.home.board_type7_data1_after': '近期貼文 ',
  'studio.group.home.board_type7_data2_after': '近期留言 ',
  'studio.group.home.board_type7_not_existed': '論壇不存在。',
  'studio.group.home.board_type8': 'Lounge #標籤',
  'studio.group.home.board_type8_no_data1_after': '沒有登錄的標籤',
  'studio.group.home.board_type8_data1_after': '最新貼文',
  'studio.group.home.board_type9': '商店珍藏',
  'studio.group.home.board_type9_data1_after': '珍藏',
  'studio.group.home.board_type10': '商品指標',
  'studio.group.home.board_type10_select_box1_tool_tip': '遊戲同時上線使用者人數',
  'studio.group.home.board_type10_select_box2_tool_tip': '商品頁面訪問人數',
  'studio.group.home.board_type10_select_box3_tool_tip': '每日遊玩玩家人數',
  'studio.group.home.first_page_register_guide1': '請先登錄專案！',
  'studio.group.home.first_page_register_guide2': '登錄專案後即可使用登錄、上市商品等所有Studio的功能。',
  'studio.group.home.dash_board_setting': '設定儀表板',
  'studio.group.home.select_product': '選擇商品',
  'studio.group.home.edit_list': '編輯列表',
  'studio.group.home.refresh_info': '商店資訊將於每週一0點更新，可能會與即時數據有落差。',
  'studio.group.home.select_product.title': '選擇商品',
  'studio.group.home.select_product.search_place_holder': '請搜尋商品 ',
  'studio.group.home.select_product.search_no_result_msg': '查無搜尋結果。',
  'studio.group.home.select_product.search_no_select': '尚未選擇商品。',
  'studio.group.home.edit_list.title': '編輯列表',
  'studio.group.home.edit_list.guide': '請選擇要顯示在儀表板上的項目，或是透過拖曳來改變顯示順序。',
  'studio.group.home.edit_list.breadcrumb1': '團隊首頁',
  'studio.group.home.edit_list.breadcrumb2': '編輯列表',
  'studio.group.notice.title': 'Studio公告事項',
  'studio.group.notice.sub_title': 'Studio公告事項',
  'studio.group.notice.copy_text_button': '複製URL',
  'studio.group.notice.file_download_btn': '下載',
  'studio.group.notice.notice_list_dir_btn': '查看所有貼文',
  'studio.group.notice.list_header1': '分類',
  'studio.group.notice.list_header2': '標題',
  'studio.group.notice.list_header3': '撰寫日期',
  'studio.group.notice.copied_toast_msg': '已複製貼文URL。',
  'studio.group.pre_grp_landing.new_term_agreement_chkbox': ' （必選）同意條款。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg1': '已同意所有條款。',
  'studio.group.pre_grp_landing.all_terms_agreed_pop_msg2': '前往團隊頁面。',
  'studio.member_manage.member.member_title.nick_header': '暱稱',
  'studio.member_manage.member.member_title.project_count_header': '所屬專案',
  'studio.member_manage.member.member_title.regi_date_header': '加入日期',
  'studio.member_manage.member_all_title': '全部',
  'studio.member_manage.member_invite_btn': '邀請成員',
  'studio.member_manage.member_invite_alert1_msg': '您沒有編輯權限。<br/>請向團隊管理員詢問。',
  'studio.member_manage.member.guide1': '可邀請成員加入團隊並管理團隊。',
  'studio.member_manage.member.guide2': '可賦予成員選單／商品權限及職務。',
  'studio.member_manage.member.guide3': '職務為可賦予預設的職務，或是替製作人團隊自訂職務設定。',
  'studio.member_manage.member_invite.mem_invite': '邀請成員',
  'studio.member_manage.member_invite.mem_invite_link': '邀請連結',
  'studio.member_manage.member_invite.link_expiry': '將於{remainingTimeNum}{timeUnit}後過期。',
  'studio.member_manage.member_invite.link_used_times': '目前次數： ',
  'studio.member_manage.member_invite.link_used_times_value': '{times}次',
  'studio.member_manage.member_invite.link_regen_btn': '重新產生連結',
  'studio.member_manage.member_invite.link_regen_guide': '已重新產生連結。<br/>已無法再透過該連結加入。',
  'studio.member_manage.member_invite.link_regen_cf_btn': '重新產生連結',
  'studio.member_manage.member_invite.link_regen_done': '已重新產生邀請連結。',
  'studio.member_manage.member_invite.mem_invite_link_advanced_settings': '進階設定',
  'studio.member_manage.member_invite.mem_invite_link_activation_y_n': '是否啟用',
  'studio.member_manage.member_invite.mem_invite_link_activation_guide': '停用連結後，在連結啟用之前都無法使用該連結。',
  'studio.member_manage.member_invite.mem_invite_link_activation_y': '啟用',
  'studio.member_manage.member_invite.mem_invite_link_activation_n': '停用',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry': '連結有效期限',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_guide': '修改連結的有效期限後，有效期限將從儲存時起更新。 ',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_def_7d_': '7天',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_30m': '30分鐘',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1h': '1小時',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_6h': '6小時',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_12h': '12小時',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_1d': '1天',
  'studio.member_manage.member_invite.mem_invite_set_link_expiry_n': '無有效期限',
  'studio.member_manage.member_invite.mem_invite_link_guide': '邀請連結',
  'studio.member_manage.member_invite.mem_invite_link_guide1':
    '請複製生成的邀請連結，並將連結傳給您想邀請的人員。邀請的人員收到邀請連結後，若尚未註冊Studio，則會先進行Studio註冊；若已註冊Studio，則可申請加入團隊。',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide': '進階設定',
  'studio.member_manage.member_invite.mem_invite_link_advanced_setting_guide1':
    '可針對連結進行設定，變更後須儲存才能更改設定。重新產生連結時，連結將重設為預設值。',
  'studio.member_manage.member_invite.mem_invite_link_expired': '邀請連結已過期。',
  'studio.member_manage.member_invite.mem_invite_link_copied': '複製完成',
  'studio.member_manage.member.list_invite_date': '邀請日期',
  'studio.member_manage.member.list_resend_invite_btn': '重新發送',
  'studio.member_manage.member.list_cancel_invite_btn': '取消邀請',
  'studio.member_manage.member.invite_link_popup_case_4806': '已經加入此團隊。',
  'studio.member_manage.member.invite_link_popup_case_4500_01_4804': '連結已失效或該成員不存在。',
  'studio.member_manage.member.invite_link_popup_case_4505': '{grpName}的<br/>加入邀請碼已過期。<br/>請團隊代表人重新分享邀請碼後，再申請加入。',
  'studio.member_manage.member.invite_link_popup_case_0_success': '已申請加入<br/>{grpName}團隊。<br/>請於加入狀態中查看是否已被批准加入。',
  'studio.member_manage.role_manage_btn': '管理職務',
  'studio.member_manage.role_value_operator': '營運',
  'studio.member_manage.role_value_marketer': '事業',
  'studio.member_manage.role_value_developer': '開發',
  'studio.member_manage.role_value_manager': '專案管理員',
  'studio.member_manage.role_manage_create_role_btn': '建立新職務',
  'studio.member_manage.role_manage_create_role_msg1': '職務名稱',
  'studio.member_manage.role_manage_create_role_place_holder': '請輸入職務名稱 ',
  'studio.member_manage.role_manage_create_role_alert1': '請輸入職務名稱。',
  'studio.member_manage.role_manage_create_role_val1': '職務名稱重複，請確認並重新輸入。',
  'studio.member_manage.role_manage_create_role_msg2': '權限設定',
  'studio.member_manage.role_manage_create_role_msg3': '可針對各個商品頁面的各個項目賦予權限。',
  'studio.member_manage.role_manage_create_role_menu_header1': '選單',
  'studio.member_manage.role_manage_create_role_perm_view_header2': '查詢',
  'studio.member_manage.role_manage_create_role_perm_edit_header3': '編輯',
  'studio.member_manage.role_manage_create_role_register_btn': '登錄',
  'studio.member_manage.role_manage_create_role_msg6': '職務及各選單權限設定',
  'studio.member_manage.role_manage_create_role_msg7': '各選單可設定不同的存取權限。<br/>請替各個職務取不同名稱，以利區分。<br/>職務名稱不能重複！',
  'studio.member_manage.role_manage_create_role_msg8': '指標／結算權限設定',
  'studio.member_manage.role_manage_create_role_msg9': '選擇指標／結算時，將賦予可在團隊選單中進行查看的權限。',
  'studio.member_manage.role_manage_create_role_register_alert_msg': '已登錄新職務。',
  'studio.member_manage.role_manage_details_title': '修改職務',
  'studio.member_manage.role_manage_details_save_btn': '儲存',
  'studio.member_manage.role_manage_details_delete_btn': '刪除職務',
  'studio.member_manage.role_manage_details_save_alert_msg': '已儲存職務。',
  'studio.member_manage.role_manage_details_delete_step1_msg': '確定要刪除職務嗎？<br/>被賦予該職務的成員職務均會消失。',
  'studio.member_manage.role_manage_details_delete_step1_delete_btn': '刪除',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert1_msg': '已刪除職務。',
  'studio.member_manage.role_manage_details_delete_step2_delete_alert2_msg': '請重新整理或<br/>重新嘗試。',
  'studio.member_manage.role_manage_list_by_menu': '選單',
  'studio.member_manage.role_manage_list_view_per': '查詢',
  'studio.member_manage.role_manage_list_edit_per': '編輯',
  'studio.member_manage.role_manage_list_by_menu_release_plan': '上市',
  'studio.member_manage.role_manage_list_by_menu_prod_pg_mgmt': '商品頁面管理',
  'studio.member_manage.role_manage_list_by_menu_prod_setting': '商品設定',
  'studio.member_manage.role_manage_list_by_menu_prod_pg': '商品頁面',
  'studio.member_manage.role_manage_list_by_menu_prod_term': '商品條款',
  'studio.member_manage.role_manage_list_by_menu_price': '價格',
  'studio.member_manage.role_manage_list_by_menu_discount': '折扣',
  'studio.member_manage.role_manage_list_by_menu_pur_cond': '購買條件',
  'studio.member_manage.role_manage_list_by_menu_early_access': '搶先體驗文字設定',
  'studio.member_manage.role_manage_list_by_menu_collection': '精選商品',
  'studio.member_manage.role_manage_list_by_menu_prod_data_mgmt': '商品資料管理',
  'studio.member_manage.role_manage_list_by_menu_build_mgmt': '管理組建',
  'studio.member_manage.role_manage_list_by_menu_exe_setting': '執行設定',
  'studio.member_manage.role_manage_list_by_menu_rating_build_review': '使用等級及組建審查',
  'studio.member_manage.role_manage_list_by_menu_stats': '統計值',
  'studio.member_manage.role_manage_list_by_menu_ranking': '排名',
  'studio.member_manage.role_manage_list_by_menu_challenge': '挑戰課題',
  'studio.member_manage.role_manage_list_by_menu_cloud_saving': '雲端儲存',
  'studio.member_manage.role_manage_list_by_menu_match_making': '配對',
  'studio.member_manage.role_manage_list_by_menu_prod_mkt_mgmt': '商品行銷管理',
  'studio.member_manage.role_manage_list_by_menu_statistics': '指標',
  'studio.member_manage.role_manage_list_by_menu_bill_settlement': '結算',
  'studio.member_manage.role_manage_list_by_menu_ingame_store': '遊戲內商店',
  'studio.member_manage.role_manage_list_by_menu_ingame_setting': '遊戲內付款設定',
  'studio.member_manage.role_manage_list_by_menu_sub_ingame_store': '遊戲內商店',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_product': '遊戲內商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_discount': '遊戲內折扣商品',
  'studio.member_manage.role_manage_list_by_menu_ingame_store_payment_history': '遊戲內付款紀錄',
  'studio.member_manage.role_manage_details_msg1': 'Studio基本職務',
  'studio.member_manage.role_manage_details_msg2': 'Studio預設的基本職務無法變更或刪除。',
  'studio.member_manage.member_nick_header2': '暱稱',
  'studio.member_manage.member_project_count_header3': '所屬專案',
  'studio.member_manage.member_regi_date_header4': '加入日期',
  'studio.member_manage.member_invite_date_header5': '邀請時間',
  'studio.member_manage.search_place_holder': '請搜尋暱稱',
  'studio.member_manage.history': '查看紀錄',
  'studio.member_manage.search_nmrf': '無符合搜尋條件的結果。',
  'studio.member_manage.list_no_data': '沒有列表。',
  'studio.member_manage.mem_by_project_title': '各專案成員',
  'studio.member_manage.project_project_name_header1': '專案',
  'studio.member_manage.project_no_of_member_header2': '成員人數',
  'studio.member_manage.project_project_name_header2': '建立日期',
  'studio.member_manage.project_list_member_title': '成員',
  'studio.member_manage.project_list_nickname_header3': '暱稱',
  'studio.member_manage.project_list_product_name_header1': '商品',
  'studio.member_manage.project_list_role_header4': '職務',
  'studio.member_manage.project_list_date_authorized_header5': '賦予權限日期',
  'studio.member_manage.project_list_collapse_all_btn': '全部收起',
  'studio.member_manage.project_list_expand_all_btn': '全部展開',
  'studio.member_manage.join_waitlist_chk_btn': '等待加入',
  'studio.member_manage.join_waitlist_nickname': '暱稱',
  'studio.member_manage.join_waitlist_req_date': '申請加入日期',
  'studio.member_manage.join_waitlist_stt': '狀態',
  'studio.member_manage.join_waitlist_stt_waiting': '等待',
  'studio.member_manage.join_waitlist_no_data': '尚未有申請加入群組的成員。<br/>若要邀請成員，請建立並分享邀請連結。',
  'studio.member_manage.membership_requests_decline_btn': '拒絕',
  'studio.member_manage.membership_requests_approve_btn': '核准',
  'studio.member_manage.membership_requests_approve_alert_msg': '已完成加入審核。<br/>若要設定權限，請從清單中點選成員並進行權限設定。',
  'studio.member_manage.membership_requests_decline_alert_msg': '已拒絕加入。',
  'studio.member_manage.membership_requests_action_alert_msg': '請在列表中選擇成員。',
  'studio.member_manage.member_details_msg2': '暱稱',
  'studio.member_manage.member_details_msg3': '加入日期',
  'studio.member_manage.member_details_group_menu_permission_title': '選擇團隊選單權限',
  'studio.member_manage.member_details_product_permission_title': '選擇商品權限',
  'studio.member_manage.member_details_right_guide1': '專案及商品權限',
  'studio.member_manage.member_details_right_guide2': '可賦予團隊擁有之商品的權限。',
  'studio.member_manage.member_details_right_guide3': '自動賦予職務',
  'studio.member_manage.member_details_right_guide4': '成員接受邀請後，每次新增商品時即會自動賦予權限，無需手動設定。 ',
  'studio.member_manage.member_details_right_guide5': '權限為自動賦予，如需隱藏專案或商品，請於該成員的詳細資訊頁面中修正。',
  'studio.member_manage.member_details_save_btn': '儲存',
  'studio.member_manage.member_details_remove_btn': '驅逐成員',
  'studio.member_manage.member_details_remove_step1_msg': '確定要讓該名成員離開團隊嗎？',
  'studio.member_manage.member_details_remove_step1_remove_btn': '驅逐',
  'studio.member_manage.member_details_remove_step2_msg': '已讓成員離開團隊。',
  'studio.member_manage.member_details_group_menu_permission_msg1': '請選擇欲賦予團隊選單權限的成員。',
  'studio.member_manage.member_details_group_menu_permission_msg2': '須擁有商品權限才可查看結算／指標的選單。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_title': '郵件／通知',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_msg': '接收擁有權限之商品的郵件或通知。',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_settlement_chkbox': '結算',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_review_chkbox': '審查',
  'studio.member_manage.member_details_group_menu_permission_mail_or_notice_contract_chkbox': '合約',
  'studio.member_manage.member_details_product_permission_msg1': '請選擇欲賦予成員的商品及職務。',
  'studio.member_manage.member_details_product_permission_product_name_header1': '專案及商品名稱',
  'studio.member_manage.member_details_product_permission_role_selection_dropbox_header2': '選擇職務',
  'studio.member_manage.member_details_product_permission_apply_all_btn': '全部套用',
  'studio.member_manage.member_details_product_permission_full_btn': '放到最大',
  'studio.member_manage.member_details_product_permission_msg2': '在團隊中新增商品時，將自動賦予職務。',
  'studio.member_manage.member_details_product_permission_product_place_holder': '沒有可賦予權限的商品。<br/>團隊中至少要有1款以上的商品。',
  'studio.member_manage.history_nick_header1': '暱稱',
  'studio.member_manage.history_summary_header2': '內容',
  'studio.member_manage.history_status_header3': '狀態',
  'studio.member_manage.history_date_header4': '日期',
  'studio.member_manage.history_category_all': '全部',
  'studio.member_manage.history_category_joined': '加入',
  'studio.member_manage.history_category_rejected': '拒絕',
  'studio.member_manage.history_category_edit': '修改',
  'studio.member_manage.history_category_left_gr': '退出',
  'studio.member_manage.history_status_edit_depth_details_added': '[新增]',
  'studio.member_manage.history_status_edit_depth_details_removed': '[刪除]',
  'studio.member_manage.history_status_invited': '邀請',
  'studio.member_manage.history_status_invited_details': '已邀請 {email}。',
  'studio.member_manage.history_status_joined': '加入',
  'studio.member_manage.history_status_joined_details': '新加入！',
  'studio.member_manage.history_status_declined': '拒絕',
  'studio.member_manage.history_status_edit_product': '修改',
  'studio.member_manage.history_status_edit_product_details': '已修改{nickName}的商品權限。',
  'studio.member_manage.history_status_edit_menu': '修改',
  'studio.member_manage.history_status_edit_menu_details': '已修改{nickName}的選單權限。',
  'studio.member_manage.history_status_dismiss': '退出',
  'studio.member_manage.history_status_dismiss_details': '已驅逐{nickName}。',
  'studio.member_manage.history_status_left': '退出',
  'studio.member_manage.history_status_left_details': '{nickName}已離開團隊。',
  'studio.member_manage.history_status_expand_details': '查看詳情',
  'studio.member_manage.history_search_place_holder': '請搜尋暱稱',
  'studio.prod_home.pur_cond.pur_cond': '購買條件',
  'studio.prod_home.pur_cond.btn_save': '儲存',
  'studio.prod_home.pur_cond.pur_cond_prod': '購買條件商品',
  'studio.prod_home.pur_cond.pur_cond_prod_place_holder': '請搜尋商品',
  'studio.prod_home.pur_cond.pur_cond_prod_no_result': '查無搜尋結果。',
  'studio.prod_home.pur_cond.pur_cond_type': '條件類別',
  'studio.prod_home.pur_cond.pur_cond_type1': 'AND條件',
  'studio.prod_home.pur_cond.pur_cond_type2': 'OR條件',
  'studio.prod_home.pur_cond.pur_cond_option': '是否使用購買條件',
  'studio.prod_home.pur_cond.pur_cond_option_y': '使用',
  'studio.prod_home.pur_cond.pur_cond_option_n': '不使用',
  'studio.prod_home.pur_cond.pur_cond_guide1': '哪些商品可以設為購買條件商品呢？',
  'studio.prod_home.pur_cond.pur_cond_guide1_detail':
    '可將我隸屬之團隊的商品或組合商品設為購買條件商品。<br/>然而，當A商品被登錄為B商品的購買條件商品時，無法將B商品登錄為A商品的購買條件商品。',
  'studio.prod_home.pur_cond.pur_cond_guide2': 'AND條件類型是什麼？',
  'studio.prod_home.pur_cond.pur_cond_guide2_detail': '只有擁有所有購買條件商品的使用者才可購買。 ',
  'studio.prod_home.pur_cond.pur_cond_guide3': 'OR條件類型是什麼？',
  'studio.prod_home.pur_cond.pur_cond_guide3_detail': '只有擁有購買條件商品中的1款商品以上的使用者才可購買。 ',
  'studio.prod_home.pur_cond.pur_cond_guide5': '購買條件是什麼？',
  'studio.prod_home.pur_cond.pur_cond_guide5_detail': '在該商品的「購買條件商品中」登錄A商品後，只有擁有A商品的使用者才可購買該商品。',
  'studio.prod_home.pur_cond.pur_cond_stove_set': 'STOVE設定購買條件商品',
  'studio.prod_home.pur_cond.pur_cond_guide4': 'STOVE設定購買條件商品是什麼？',
  'studio.prod_home.pur_cond.pur_cond_guide4_detail':
    'STOVE營運人員所設定的購買條件商品。<br/>當商品為STOVE設定購買條件商品時，無法直接設定購買條件。若想將其他商品設為購買條件商品，請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.prj_prod.this_prod.landing_msg1': '商品頁面',
  'studio.prj_prod.this_prod.landing_create_btn': '創建',
  'studio.prj_prod.this_prod.landing_msg2': '創建並編輯商品頁面，讓使用者們看到我的商品！',
  'studio.prj_prod.this_prod.landing_msg3': '請準備好30MB以下的代表圖片、截圖、圖示及100MB以下的影片，並撰寫商品簡介文章。',
  'studio.prj_prod.this_prod.landing_create_pop_msg1': '請輸入商品頁面名稱。 ',
  'studio.prj_prod.this_prod.landing_create_pop_msg2': '用來區分商品頁面的名稱，不會對使用者顯示。',
  'studio.prj_prod.this_prod.landing_create_pop_page_name_place_holder': '請輸入商品頁面名稱',
  'studio.prj_prod.this_prod.landing_create_pop_input_msg1': '請輸入商品頁面名稱。 ',
  'studio.prj_prod.this_prod.landing_create_pop_create_btn': '創建',
  'studio.prj_prod.this_prod.edit_page_name': '靈魂遊戲商店頁面',
  'studio.prj_prod.this_prod.edit_info_hover_msg': '翻譯成多國語言時的基本語言。<br/>只有團隊代表可於團隊首頁點擊語言按鈕後更改。',
  'studio.prj_prod.edit_preview_toggle_msg': '收起預覽區塊，並充分利用作業區塊。',
  'studio.prj_prod.this_prod.edit_sidebar_title': '編輯商品頁面',
  'studio.prj_prod.this_prod.edit_sidebar_msg1': '只顯示必填項目',
  'studio.prj_prod.this_prod.edit_preview_btn': '預覽',
  'studio.prj_prod.this_prod.edit_mls_btn': '多國語言設定',
  'studio.prj_prod.this_prod.text_missing_mls_n_popup': '輸入單行介紹文後，即可設定多國語言。<br/>請輸入內容後再重新嘗試。',
  'studio.prj_prod.this_prod.edit_save_step0_msg': '必填項目中有未輸入的內容。<br/>必須輸入所有必填項目才能登錄上市計畫。',
  'studio.prj_prod.this_prod.edit_display_prod_pg': '顯示商品頁面',
  'studio.prj_prod.this_prod.edit_display_countries_msg1': '顯示的國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_view_btn': '查看所有國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_select_all': '所有國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_select_partial': '部分國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_msg4': '選擇國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_regions': '依區域查看',
  'studio.prj_prod.this_prod.edit_display_countries_search_country': '搜尋個別國家與地區',
  'studio.prj_prod.this_prod.edit_display_countries_regions_all': '全部',
  'studio.prj_prod.this_prod.edit_display_countries_checkbox_val1': '請選擇1個以上的國家。',
  'studio.prj_prod.this_prod.edit_display_countries_search_country_placeholder': '請選擇國家',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg1': '我的電腦',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg2': '儲存空間',
  'studio.prj_prod.this_prod.edit_gamepreview_hover_msg3': '編輯',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert2': '只能選擇1個檔案。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert3': '不支援此檔案類型。<br/>請確認副檔名後再上傳。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert4': '已超過檔案大小上限。<br/>請確認檔案大小上限後再上傳。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_title': '開始日期',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_immediate_radio_btn': '立刻',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_select_time_radio_btn': '預約',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_req_msg': '請選擇開始日期。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_invalid_msg': '請將預約的開始日期選為晚於今天的日期。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop1_msg': '確定要立刻套用商品頁面嗎？',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_display_start_date_pop2_msg': '要套用商品頁面的預約嗎？',
  'studio.prj_prod.this_prod.edit_gamepreview_title': '影片及圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg1': '選擇畫面類型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1': '基本類型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2': '影片背景類型',
  'studio.prj_prod.this_prod.edit_gamepreview_radio1_msg1': '商品頁面背景圖片（選擇）',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1': '商品頁面背景影片',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg1_guide1': '將在行動裝置、PC網頁的商品頁面中作為背景顯示。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_required_n': '請登錄影片。',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2': '商品頁面背景圖片（選擇）',
  'studio.prj_prod.this_prod.edit_gamepreview_radio2_msg2_guide1': '將在客戶端的商品頁面中作為背景顯示。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg6': '顯示的影片及圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn': '新增檔案',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_link_btn': '影片連結',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_video_file_btn': '影片檔案',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_image_btn': '圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_title': '影片連結 ',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_link_place_holder': '請先新增縮圖，然後輸入影片URL。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_title': '影片檔',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_image_title': '圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert1': '請登錄影片或圖片。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert2': '請登錄影片縮圖。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert3': '請登錄影片URL。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert4': 'URL必須為1到2000個字。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_add_btn_alert5': '此URL格式無效。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7': '1:1圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_1': '用於商品的標題圖片，並顯示在商品排名頁面等處。',
  'studio.prj_prod.this_prod.edit_gamepreview_1to1_info_hover_msg': '顯示於商品頁面中所標示的位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg7_attach_msg1': '請登錄圖片。',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_btn': '依各語言登錄',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8': '16:9圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_1': '用於商品列表、購物車及使用者資料等處。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg8_attach_msg1': '請登錄圖片。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_btn': '預覽',
  'studio.prj_prod.this_prod.edit_gamepreview_language_setting_guide': '包含LOGO的圖片，若各語言有不同的LOGO，可依語言個別登錄。 ',
  'studio.ai_translation.base_lang_ko': '韓文',
  'studio.ai_translation.base_lang_ch_cn': '簡體中文',
  'studio.ai_translation.base_lang_ch_tw': '繁體中文',
  'studio.prj_prod.this_prod.edit_title_bg_img': '標題背景圖片（選擇）',
  'studio.prj_prod.this_prod.edit_title_bg_img_guide': '可新增背景圖片讓1:1圖片更顯眼。',
  'studio.prj_prod.this_prod.edit_gamepreview_title_background_info_hover_msg': '顯示於商品頁面中所標示的位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9': '單行介紹文圖片（選擇）',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_1': '可新增單行介紹文上方顯示的圖片。',
  'studio.prj_prod.this_prod.edit_gamepreview_headline_info_hover_msg': '顯示於商品頁面中所標示的位置。',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_title': '預覽16:9圖片套用',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg1': '示意圖',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg2': '商店商品列表',
  'studio.prj_prod.this_prod.edit_gamepreview_16to9_preview_msg4': '購物車',
  'studio.prj_prod.this_prod.edit_texts': '文字',
  'studio.prj_prod.this_prod.edit_texts_subtitle_title': '前置標籤（選填）',
  'studio.prj_prod.this_prod.edit_texts_subtitle_guide': '如有需要，您可以在商品名稱前加入前置標籤。建議使用能補充商品名稱意涵的文字。',
  'studio.prj_prod.this_prod.edit_texts_subtitle_place_holder': '請輸入前置標籤。',
  'studio.prj_prod.this_prod.edit_texts_headline_title': '單行介紹文',
  'studio.prj_prod.this_prod.edit_texts_headline_place_holder': '請輸入單行介紹文',
  'studio.prj_prod.this_prod.edit_texts_headline_alert1': '請輸入單行介紹文。',
  'studio.prj_prod.this_prod.edit_writing_guidance_btn': '撰寫指南',
  'studio.prj_prod.this_prod.edit_writing_guidance_info1': '單行介紹文是用來確保商品可順利被搜尋引擎搜尋到。',
  'studio.prj_prod.this_prod.edit_writing_guidance_info2': '推薦寫法',
  'studio.prj_prod.this_prod.edit_writing_guidance_info3': '包含主要關鍵字',
  'studio.prj_prod.this_prod.edit_writing_guidance_info4': '概括所有商品內容',
  'studio.prj_prod.this_prod.edit_writing_guidance_info5': '英文在160字以內，韓文／日文／中文在80字以內',
  'studio.prj_prod.this_prod.edit_writing_guidance_info6': '不推薦的寫法',
  'studio.prj_prod.this_prod.edit_writing_guidance_info7': '重複提到2次以上相同關鍵字',
  'studio.prj_prod.this_prod.edit_writing_guidance_info8': '內含與商品無關的關鍵字',
  'studio.prj_prod.this_prod.edit_writing_guidance_info9': '僅輸入商品名稱',
  'studio.prj_prod.this_prod.edit_summary_title': '商品說明（選填）',
  'studio.prj_prod.this_prod.edit_summary_title_full_btn': '顯示全螢幕畫面',
  'studio.prj_prod.this_prod.edit_summary_place_holder1': '遊戲商品說明中最好包含這些資訊！<br/>如有任何有助於理解的圖片，也別忘了附上。',
  'studio.prj_prod.this_prod.edit_summary_place_holder2': '使用者遊玩評論',
  'studio.prj_prod.this_prod.edit_summary_place_holder3': '遊戲的魅力點',
  'studio.prj_prod.this_prod.edit_summary_place_holder4': '角色介紹',
  'studio.prj_prod.this_prod.edit_summary_place_holder5': '故事情節',
  'studio.prj_prod.this_prod.edit_summary_place_holder6': '操作方法',
  'studio.prj_prod.this_prod.edit_summary_place_holder7': '製作人評論',
  'studio.prj_prod.this_prod.edit_summary_info_hover_msg': '可於全螢幕畫面中輸入深色模式。',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg1': '我的電腦',
  'studio.prj_prod.this_prod.edit_summary_attatch_msg2': '儲存空間',
  'studio.prj_prod.this_prod.edit_summary_fullscreen_exit_btn': '關閉全螢幕畫面',
  'studio.prj_prod.this_prod.edit_summary_darkmode_btn': '深色模式',
  'studio.prj_prod.this_prod.edit_additional_info_title': '額外資訊',
  'studio.prj_prod.this_prod.edit_additional_info_tags_title': 'Tag（選填）',
  'studio.prj_prod.this_prod.edit_additional_info_tags_guide': '使用者可透過登錄的Tag過濾並尋找商品。<br/>Tag將依設定順序顯示，可透過拖曳更改順序。',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_place_holder': '搜尋看看Tag',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_no_msg': '搜尋結果不存在。 ',
  'studio.prj_prod.this_prod.edit_additional_info_tags_search_msg1': '特定Tag將依平台政策優先顯示。',
  'studio.prj_prod.this_prod.edit_additional_supporting_title': '支援功能（選填）',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_title': '產品內支援語言',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_val_msg1': '請選擇1個以上支援語言。',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg1': '介面',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg2': '聲音',
  'studio.prj_prod.this_prod.edit_additional_supporting_languages_msg3': '字幕',
  'studio.prj_prod.this_prod.edit_additional_requirements_title': '規格',
  'studio.prj_prod.this_prod.edit_additional_requirements_add_btn': '新增規格',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_place_holder': '最低規格（必填）',
  'studio.prj_prod.this_prod.edit_additional_requirements_component': '項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_min_place_holder': '最低規格（選填）',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_recommended_place_holder': '建議規格（選填）',
  'studio.prj_prod.this_prod.edit_additional_requirements_toggle': '輸入建議規格',
  'studio.prj_prod.this_prod.edit_additional_requirements_os_val_msg': '請輸入OS項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_processor_val_msg': '請輸入Processor項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_memory_val_msg': '請輸入Memory項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_graphics_val_msg': '請輸入Graphics項目。',
  'studio.prj_prod.this_prod.edit_additional_requirements_directx_val_msg': '請輸入DirectX項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_storage_val_msg': '請輸入Storage項目',
  'studio.prj_prod.this_prod.edit_additional_requirements_sound_val_msg': '請輸入Sound項目',
  'studio.prj_prod.this_prod.edit_additional_links_title': '相關連結（選填）',
  'studio.prj_prod.this_prod.edit_additional_links_add_btn': '新增連結',
  'studio.prj_prod.this_prod.edit_additional_links_name_place_holder': '輸入連結標題',
  'studio.prj_prod.this_prod.edit_additional_links_name_val_msg1': '請輸入連結標題 ',
  'studio.prj_prod.this_prod.edit_additional_links_url_place_holder': '輸入URL',
  'studio.prj_prod.this_prod.edit_additional_links_url_val_msg1': '無效的URL格式。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_title': '得獎圖片（選填）',
  'studio.prj_prod.this_prod.edit_additional_awards_image_add_btn': '新增得獎圖片',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg1': '副檔名不同，無法上傳。 ',
  'studio.prj_prod.this_prod.edit_additional_awards_image_val_msg2': '超過檔案大小上限，無法上傳。',
  'studio.prj_prod.this_prod.edit_additional_awards_this_image_name': '圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_title': '編輯圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_imagetype_subtitle': '16:9圖片',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg1': '查看指南',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip1':
    '請確認圖片必須置入的位置。<br/>主要圖片必須置於紅線區域內，LOGO必須置於黃線區域內。<br/>指引線不會儲存。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_info_tool_tip2':
    '請確認圖片必須置入的位置。<br/>主要圖片必須置於紅線區域內。<br/>指引線不會儲存。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_msg2': '新增LOGO',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_local_btn': '我的電腦',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_storage_btn': '儲存空間',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_abbr': '背景顏色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_background_color_full': '背景顏色',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_btn': '儲存',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn': '儲存至儲存空間',
  'studio.prj_prod.this_proj.this_prod.status_header1': '狀態',
  'studio.prj_prod.this_proj.this_prod.list_this_status_upcoming_msg': '預計套用',
  'studio.prj_prod.this_proj.this_prod.list_this_status_expired_msg': '結束',
  'studio.prj_prod.this_proj.this_prod.list_this_status_declined_msg': '審查退回',
  'studio.prj_prod.this_proj.this_prod.list_this_status_active_msg': '套用為最新版本',
  'studio.prj_prod.this_proj.this_prod.list_this_status_suspend_msg': '暫停展示',
  'studio.prj_prod.this_proj.this_prod.prod_page_name_header3': '商品頁面名稱',
  'studio.prj_prod.this_proj.this_prod.display_header2': '展示 ',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_header4': '登錄日（編輯日）',
  'studio.prj_prod.this_proj.this_prod.list_kebab_edit_page_name_btn': '修改商品頁面名稱',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_btn': '複製',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_btn': '刪除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_n_btn': '停止顯示',
  'studio.prj_prod.this_proj.this_prod.list_kebab_display_y_btn': '恢復顯示',
  'studio.prj_prod.this_proj.this_prod.release_period_header5': '期間',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg': '恢復顯示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_msg1': '如欲開始顯示，請輸入「ON」。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop1_display_y_btn': '恢復顯示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg': '停止顯示',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_msg1': '如欲停止顯示，請輸入「OFF」。 ',
  'studio.prj_prod.this_proj.this_prod.list_display_switch_pop2_display_n_btn': '停止顯示',
  'studio.prj_prod.this_proj.this_prod.list_this_status_in_review_msg': '審查中',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_title': '複製商品頁面',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_msg': '請選擇欲複製此商品頁面的所有位置。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_prod_page_count_title': '全部',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_place_holder': '請搜尋商品 ',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_duplicate_btn': '複製',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_product_header2': '商品',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_x_msg': '已有套用狀態，無法刪除。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_limit_exceed_msg': '一次最多可選擇50個。',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg': '確定要刪除預計套用的商品頁面嗎？',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_cf_btn': '刪除',
  'studio.prj_prod.this_proj.this_prod.list_kebab_duplicate_pop_search_nmrf': '搜尋結果不存在。',
  'studio.prj_prod.this_prod.list_edit_edit_msg1': '請輸入商品頁面名稱。 ',
  'studio.prj_prod.this_prod.list_edit_edit_msg2': '用以區分商品頁面的名稱，使用者不會看到。',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_place_holder': '請輸入商品頁面名稱',
  'studio.prj_prod.this_prod.list_edit_edit_page_name_input_val_msg1': '請輸入商品頁面名稱。 ',
  'studio.prj_prod.this_prod.edit_title': '編輯商品頁面',
  'studio.prj_prod.this_prod.edit_page_not_status2_msg': '為{releaseStatus}狀態商品頁面。點擊編輯按鍵即可編輯複製的商品頁面。 ',
  'studio.prj_prod.this_prod.edit_duplicate_btn': '複製',
  'studio.prj_prod.this_prod.edit.pop_declined_items_msg': '退回原因',
  'studio.prj_prod_mngmt.pg_title': '專案·商品管理',
  'studio.prj_prod_mngmt.btn_prj_reg': '專案清單',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb1': '管理專案‧商品 ',
  'studio.prj_prod_mngmt.prj_reg.breadcrumb2': '登錄專案及商品',
  'studio.prj_prod_mngmt.prj_reg.pg_title': '專案清單',
  'studio.prj_prod_mngmt.prj_reg.prj_name': '專案名稱',
  'studio.prj_prod_mngmt.prj_reg.prj_name_place_holder': '請輸入專案名稱',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg1': '請輸入專案名稱 ',
  'studio.prj_prod_mngmt.prj_reg.prj_name_val_msg3': '已有相同名稱的專案，<br/>請輸入其他專案名稱。',
  'studio.prj_prod_mngmt.prj_reg.chkbox_add_prod': '一併登錄此專案的商品',
  'studio.prj_prod_mngmt.prj_reg.btn_reg': '登錄',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg1': '最多可登錄500個專案。',
  'studio.prj_prod_mngmt.prj_reg.prj_num_over100_val_msg2': '請刪除現有專案後登錄。',
  'studio.prj_prod_mngmt.prj_reg.prj_guide1': '專案是什麼？',
  'studio.prj_prod_mngmt.prj_reg.prj_guide2': '建立專案後，即可在專案內製造多樣商品。<br/>合約及結算將以專案為單位進行。',
  'studio.prj_prod_mngmt.prj_reg.prod_name': '商品名稱',
  'studio.prj_prod_mngmt.prj_reg.prod_name_place_holder': '請輸入商品名稱',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg1': '請輸入商品名稱。',
  'studio.prj_prod_mngmt.prj_reg.prod_name_val_msg3': '已有相同名稱的商品。請輸入其他商品名稱。',
  'studio.prj_prod_mngmt.prj_reg.prod_type': '商品類型',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide': '登錄商品類型後即無法更改，請謹慎選擇。',
  'studio.prj_prod_mngmt.prj_reg.dropbox_prod_type': '請選擇商品類型',
  'studio.prj_prod_mngmt.prj_reg.prod_type_val_msg': '請選擇商品類型。',
  'studio.prj_prod_mngmt.prj_reg.prod_guide1': '商品是什麼？',
  'studio.prj_prod_mngmt.prj_reg.prod_guide2': '商品是指在商店中販售的Game/Utility。<br/>可依商品類別創建商店的商品頁面。',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide1': '商品類型是什麼？',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide2': '商品類型不同，可上傳的檔案也不同。 ',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide3': '可上傳遊戲相關組建',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide4': '可上傳圖片、聲音、影片等',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide5': '可上傳遊戲創作引擎或工具',
  'studio.prj_prod_mngmt.prj_reg.prod_type_guide6': '登錄商品後，即可在「商品設定」選單中連動及設定Demo、DLC。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg1': '最多可登錄1,000個商品。',
  'studio.prj_prod_mngmt.prj_reg.prod_num_over1000_val_msg2': '請刪除現有商品並登錄。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list': '專案',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_collapse': '全部收起',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_list_expand': '全部展開',
  'studio.prj_prod_mngmt.prj_prod_reg_done.srch_place_holder': '搜尋專案名稱或商品名稱',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_list_sort': '專案',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_sort': '商品數量',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file': '專案檔案 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.create_date': '建立日期',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prj_reg': '專案清單',
  'studio.prj_prod_mngmt.prj_prod_reg_done.btn_prod_reg': '登錄商品 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_breadcrumb1': '管理專案‧商品',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_title': '登錄商品',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name': '商品名稱',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_place_holder': '請輸入商品名稱',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg1': '請輸入商品名稱。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_name_val_msg2': '已有相同名稱的商品。請輸入其他商品名稱。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type': '商品類型',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide': '登錄商品類型後即無法更改，請謹慎選擇。',
  'studio.prj_prod_mngmt.post_prj_reg.dropbox_prod_reg_type': '請選擇商品類型',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_game': 'Game',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_contents': 'Content',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_utility': 'Utility',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_val_msg': '請選擇商品類型。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide1': '商品是什麼？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_guide2': '商品是指在Store販售的Game/Utility。<br/>可依商品類別創建Store商品頁面。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide1': '商品類型是什麼？',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide2': '商品類型不同，可上傳的檔案也不同。 ',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide3': '可上傳遊戲相關組建',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide4': '可上傳圖片、聲音、影片等',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide5': '可上傳遊戲創作引擎或工具',
  'studio.prj_prod_mngmt.post_prj_reg.prod_reg_type_guide6': '登錄商品後，即可在「商品設定」選單中連動及設定Demo、DLC。',
  'studio.prj_prod_mngmt.post_prj_reg.btn_prod_reg_cf': '登錄',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg1': '最多可登錄1,000個商品。',
  'studio.prj_prod_mngmt.post_prj_reg.prod_num_over1000_val_msg2': '請刪除現有商品並登錄。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_list': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_sort': '商品',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_type_sort': '商品類型',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_release_status': '狀態 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_price': '售價 ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_rate': '折扣率',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_create_date': '建立日期',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_prod_discount_price': '折扣價',
  'studio.prj_prod_mngmt.prj_prod_list.discount_rate_by_currency': '(依貨幣類別設定)',
  'studio.prj_prod_mngmt.prj_prod_list.discount_price_by_currency': '(依貨幣類別設定)',
  'studio.prj_prod_mngmt.prj_prod_list.price_by_currency_guide': '依貨幣類別設定',
  'studio.prj_prod_mngmt.srch_no_result': '無搜尋結果。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.title': '登錄大量商品',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num': '登錄數量',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide1': '登錄大量商品的數量上限為50個，將依商品名稱為基準，自動新增隨機編號並登錄。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.guide2':
    '登錄大量商品時，將登錄為相同商品類型，登錄後無法修改，因此登錄大量商品時請選擇相同類型的商品。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_place_holder': '請輸入商品登錄數量',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg': '請輸入商品登錄數量。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.prod_num_input_val_msg2': '商品登錄數量可輸入2至50個。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_title': '{prjName}大量登錄',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide1': '批次登錄商品時，商品名稱為隨機編號。可直接修改商品名稱。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_guide2': '登錄商品類型後即無法更改，請謹慎選擇。如為批次登錄，建立所需時間約為1分鐘。',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name': '商品名稱',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_type': '商品類型',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prod_name_place_holder': '請輸入商品名稱',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_dup_name_val_msg': '已有相同名稱的商品。請輸入其他商品名稱。',
  'email.prj_reg.completed.title': '電子郵件標題：[STOVE Studio]{prjName}專案登錄完成',
  'email.prj_reg.completed.msg1': '專案登錄完畢',
  'email.prj_reg.completed.msg2': '已登錄專案。在Studio登錄商品後，將產生商品的首頁。',
  'email.prj_reg.completed.msg3': '在商品首頁登錄商品頁面，並上傳組建將遊戲上市吧。',
  'email.completed.info_grp_name': '團隊名稱',
  'email.completed.info_prj_name': '專案名稱',
  'email.completed.grp_home_dir_btn': '立即前往Studio團隊首頁',
  'email.prj_del.completed.title': '電子郵件標題：[STOVE Studio]{prjName}專案刪除完成',
  'email.prj_del.completed.msg1': '專案刪除完畢',
  'email.prj_del.completed.msg2': '專案已遭刪除。已刪除的專案無法復原。',
  'email.prj_del.completed.msg3': '無法查詢專案及遊戲連結資訊、組建資訊等，且成員的權限將全部重置。',
  'studio.prj_prod_mngmt.btn_prj_edit': '修改專案名稱',
  'studio.prj_prod_mngmt.btn_prj_del': '刪除',
  'studio.prj_prod_mngmt.prj_edit_guide1': '請輸入專案名稱 ',
  'studio.prj_prod_mngmt.prj_edit_guide2': '於Studio一次管理多個商品時使用，可隨時修改。',
  'studio.prj_prod_mngmt.prj_edit_name_place_holder': '請輸入專案名稱',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg1': '請輸入專案名稱 ',
  'studio.prj_prod_mngmt.prj_edit_name_val_msg3': '已有相同名稱的專案，<br/>請輸入其他專案名稱。',
  'studio.prj_prod_mngmt.prj_edit_name_cf': '儲存',
  'studio.prj_prod_mngmt.popup_prj_del_guide1': '刪除專案',
  'studio.prj_prod_mngmt.popup_prj_del_guide2': '專案內所有商品以及儲存資料也將一併刪除。<br/> 如欲刪除，請輸入「DELETE」。<br/>刪除後無法復原。',
  'studio.prj_prod_mngmt.kebap_suspend_sale': '停售',
  'studio.prj_prod_mngmt.kebap_del_request': '申請刪除',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide1': '有商品包含在組合內。',
  'studio.prj_prod_mngmt.del_req_x_included_in_collection_guide2': '請在組合的組成列表中刪除該商品後再重新嘗試。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide1': '商品仍在販售中。',
  'studio.prj_prod_mngmt.popup_suspend_sale_title': '停售',
  'studio.prj_prod_mngmt.popup_suspend_cf_btn': '暫停',
  'studio.prj_prod_mngmt.popup_restart_sale_title': '恢復販售',
  'studio.prj_prod_mngmt.popup_restart_sale_guide': '如欲再次販售，請輸入「START」。 ',
  'studio.prj_prod_mngmt.popup_restart_cf_btn': '恢復',
  'studio.prod_list.kebap_del_request_popup_title': '申請刪除',
  'studio.prod_list.kebap_del_request_popup_msg': '如欲申請刪除請輸入「DELETE」，經STOVE營運人員批准後（2~3天）即會刪除。刪除後將無法復原。',
  'studio.prj_prod_mngmt.popup_prod_del_cf_btn': '刪除',
  'studio.prj_prod_mngmt.popup_prod_del_req_completed_msg': '已完成刪除請求。',
  'studio.prj_prod_mngmt.prod_del_req_stt': '申請刪除',
  'studio.prj_prod_mngmt.cancel_prod_del_req_btn': '取消申請刪除',
  'studio.prj_prod_mngmt.popup_prod_del_req_cancelled_msg': '已取消申請刪除。',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_suspend_btn': '停止開放',
  'studio.prj_prod_mngmt.kebap_del_req_btn': '申請刪除',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide1': '商品頁面開放中。',
  'studio.prj_prod_mngmt.del_req_x_prod_pg_open_guide2': '請暫停開放後再提出申請刪除。',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_title': '停止開放商品頁面',
  'studio.prj_prod_mngmt.popup_prod_pg_open_suspend_guide': '如欲停止開放商品頁面，請輸入「SUSPEND」。 ',
  'studio.prj_prod_mngmt.kebap_prod_pg_open_resume_btn': '恢復開放',
  'studio.prj_prod_mngmt.del_req_completed_msg': '申請刪除完畢。',
  'studio.prj_prod_mngmt.kebap_del_req_cancel_btn': '取消申請刪除',
  'studio.prj_prod_mngmt.kebap_del_req_cancelled_msg': '已取消申請刪除。',
  'studio.prj_prod_mngmt.kebap_unreleased_prod_del_btn': '刪除',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_title': '刪除商品',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide1': '如欲刪除，請輸入「DELETE」。 ',
  'studio.prj_prod_mngmt.popup_unreleased_prod_del_guide2': '刪除後無法復原。',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_title': '恢復開放商品頁面',
  'studio.prj_prod_mngmt.popup_prod_pg_reopen_guide': '如欲重新開啟商品頁面，請輸入「ON」。 ',
  'studio.prj_prod_mngmt.noti_release_del_completed_msg':
    '已刪除{prodName}的上市。<br/>已刪除的商品資訊無法復原，將依STOVE營運政策保留商品銷售紀錄及結算資訊。  ',
  'studio.prj_prod_mngmt.del_req_rejected_tooltip':
    "刪除申請已退回。可與營運人員事先洽談後再刪除。<br/>如欲洽談請透過電子郵件（stoveindie{'@'}smilegate.com）進行諮詢。",
  'studio.prj_prod_mngmt.display_restricted_case_user_report': '限制顯示（使用者檢舉）',
  'studio.prj_prod_mngmt.display_restricted_case_operator_set': '限制顯示（營運人員）',
  'studio.prj_prod_mngmt.purchase_restricted_case': '限制購買',
  'studio.mail.case_prod_del_request_title': '申請刪除商品',
  'studio.mail.case_prod_del_request_msg1': '已完成商品刪除請求。',
  'studio.mail.case_prod_del_request_msg2': '營運人員確認需1～3天，刪除後無法復原商品資訊。',
  'studio.mail.case_prod_del_request_msg3': '將依STOVE營運政策保留商品銷售紀錄及交易資訊。',
  'studio.mail.this_release_info_1_grp_name': '團隊名稱：',
  'studio.mail.this_release_info_2_prj_name': '專案名稱：',
  'studio.mail.this_release_info_3_prod_pg': '商品頁面：',
  'studio.mail.prod_home_dir_btn': '立即前往Studio商品首頁',
  'studio.prj_prod.release_info_del_completed': '商品刪除完畢',
  'studio.mail.this_release_info_del_completed_detail_msg1': '發布資訊刪除完畢，已刪除的發布資訊無法復原。 ',
  'studio.mail.this_release_info_del_completed_detail_msg2': '將依STOVE營運政策保留商品銷售紀錄及結算資訊。',
  'studio.mail.grp_home_dir_btn': '立即前往Studio團隊首頁',
  'studio.prj_prod.release_info_del_rejected': '商品刪除申請退回',
  'studio.mail.this_release_info_del_rejected_detail_msg1': 'STOVE營運人員已審查完畢。',
  'studio.mail.this_release_info_del_rejected_detail_msg2': '上市刪除申請已退回。',
  'studio.mail.this_release_info_del_rejected_detail_msg3':
    "發布後，須先事先告知顧客其曾購買過的商品停止販售、協議結算及取消合約等事宜後，方可刪除。請聯絡下方電子信箱諮詢協議事宜。<br/>stoveindie{'@'}smilegate.com",
  'studio.prj_prod_mngmt.btn_storage': '儲存空間',
  'studio.prj_prod_mngmt.storage_intro_guide': '以單位進行管理的儲存空間。<br/>請先上傳商品圖片、影片等資源，便於裝飾商品頁面或登錄圖片。',
  'studio.prj_prod_mngmt.storage.title': '{prjName}儲存空間',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide1': '請托放或點擊檔案上傳按鍵。<br/>一次最多可上傳10個。',
  'studio.prj_prod_mngmt.storage_no_folder_file.guide2': '可上傳檔案：JPG、PNG、GIF、WEBP、ICO、MP4',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_btn': '新資料夾',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_title': '建立資料夾',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_place_holder': '請輸入資料夾名稱',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_cf_btn': '創建',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg1': '請輸入資料夾名稱。',
  'studio.prj_prod_mngmt.storage_no_folder_file.create_folder_val_msg2': '已有相同名稱的資料夾，請輸入其他資料夾名稱。',
  'studio.prj_prod_mngmt.storage_only_folder.title': '資料夾',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name': '修改資料夾名稱',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder': '刪除',
  'studio.prj_prod_mngmt.storage_only_folder.edit_folder_name_title': '修改資料夾名稱',
  'studio.prj_prod_mngmt.storage_only_folder.btn_edit_folder_name_cf': '修改',
  'studio.prj_prod_mngmt.storage_only_folder.del_folder_popup_msg':
    '確定要刪除所選資料夾嗎？<br/>刪除資料夾時，資料夾內所有檔案也會全數被刪除，刪除後無法復原。',
  'studio.prj_prod_mngmt.storage_only_folder.btn_del_folder_cf': '刪除',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_upload': '上傳檔案',
  'studio.prj_prod_mngmt.storage_upload_method1.btn_open': '開啟',
  'studio.prj_prod_mngmt.storage_upload_method1.file_num_over10_msg': '一次可選擇10個檔案上傳。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg1': '不ˊ支援的檔案類型，<br/>請確認保管箱支援的檔案類型後再上傳。',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg2': '支援檔案',
  'studio.prj_prod_mngmt.storage_upload_method1.wrong_format_msg3': 'JPG、PNG、GIF、WEBP、ICO、MP4',
  'studio.prj_prod_mngmt.storage_upload_method1.storage_exceed_msg': '檔案大小超過儲存空間。<br/>請刪除現有檔案或上傳其他檔案。',
  'studio.prj_prod_mngmt.storage_upload_method1.uploading_msg': '正在上傳至檔案保管箱，<br/>請稍候。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_cancel_msg': '已取消上傳。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_done_msg': '已上傳{fileNum}個檔案。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_failed_msg': '檔案上傳失敗。<br/>請重新再試。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_damaged_msg': '此為毀損檔案。<br/>請檢查檔案後再上傳。',
  'studio.prj_prod_mngmt.storage_upload_method1.upload_limit_msg': '只能上傳100MB以下的檔案，<br/>請確認檔案大小後再上傳。 ',
  'studio.prj_prod_mngmt.storage_upload.file_drop_guide': '請將檔案拖曳到此處。 ',
  'studio.prj_prod_mngmt.storage_upload_done.file_title': '檔案',
  'studio.prj_prod_mngmt.storage_upload_done.file_info1': '尺寸',
  'studio.prj_prod_mngmt.storage_upload_done.file_info2': '大小：',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move_to_folder': '移動資料夾',
  'studio.prj_prod_mngmt.storage_upload_done.btn_download': '下載原檔',
  'studio.prj_prod_mngmt.storage_upload_done.btn_del': '刪除',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_msg': '確定要全數刪除所選的{fileNum}個檔案嗎？<br/>刪除後無法復原。',
  'studio.prj_prod_mngmt.storage_upload_done.del_completed_msg': '已刪除檔案。',
  'studio.prj_prod_mngmt.storage_upload_done.popup_move_to_folder_title': '移動資料夾',
  'studio.prj_prod_mngmt.storage_upload_done.storage_folder': '儲存空間',
  'studio.prj_prod_mngmt.storage_upload_done.btn_move': '移動',
  'studio.prj_prod_mngmt.storage_upload_done.move_completed_msg': '已移動資料夾。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_msg': '確定要刪除所選的{fileNum}個檔案嗎？<br/>刪除後無法復原。',
  'studio.prj_prod_mngmt.storage_multiple_select.del_btn': '刪除',
  'studio.prj_prod_mngmt.storage_multiple_select.del_all_done_msg': '已刪除{fileNum}個檔案。',
  'studio.prj_prod_mngmt.storage_srch_result.srchbar_place_holder': '搜尋{folderName}',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg1': '無{searchValue}搜尋結果。',
  'studio.prj_prod_mngmt.storage_srch_result.no_result_msg2': '請以其他關鍵字搜尋。',
  'studio.prj_prod_mngmt.storage_srch_sorting_value1': '依最新排序',
  'studio.prj_prod_mngmt.storage_srch_sorting_value2': '依最舊排序',
  'studio.prj_prod_mngmt.storage_srch_sorting_value3': '由高至低排序',
  'studio.prj_prod_mngmt.storage_srch_sorting_value4': '由低至高排序',
  'studio.prj_prod_mngmt.storage_folder_selected.no_file_msg': '這個資料夾是空的。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg1': '無{searchValue}搜尋結果。',
  'studio.prj_prod_mngmt.storage_srch_in_folder.no_result_msg2': '請以其他關鍵字搜尋。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.subtitle': '選擇附件',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.guide':
    '無上傳至儲存空間的檔案。<br>可透過<em class="font-medium text-on-surface-elevation-2">專案管理&gt;儲存空間</em>新增檔案。',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_go_to_prj_mngmt': '前往管理專案頁面',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.btn_upload_file': '登錄所選檔案',
  'studio.prj_prod_mngmt.storage_select_attachment.no_folder_file.title': '{prjName}儲存空間',
  'studio.prj_prod_mngmt.prod_home.prod_terms.pg_title': '商品條款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_1':
    '可制定商品發布時的必要條款。<br/>EULA條款將於STOVE PC客戶端安裝遊戲時顯示。<br/>使用遊戲內商店或線上服務時則需服務使用條款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.guide_2': '執行選項中只選擇「行動裝置」的使用者無需設定條款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample1': '默認（客戶端）顯示<br/>軟體使用者同意條款(EULA)',
  'studio.prj_prod_mngmt.prod_home.prod_terms.sample2': '遊戲內顯示<br/>服務使用條款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.create_btn': '登錄',
  'studio.prj_prod_mngmt.prod_home.create_term.pg_title': '登錄條款',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type': '選擇條款類別 ',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_guide': '可選擇欲創建的條款類別。依據所選的類別不同，輸入項目將會有所不同。',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_dropbox': '請選擇',
  'studio.prj_prod_mngmt.prod_home.create_term.select_type_required_msg': '請選擇條款類別。',
  'studio.prj_prod_mngmt.prod_home.create_term.title': '條款註冊',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide': '條款類別有哪些？',
  'studio.prj_prod_mngmt.prod_home.create_term.overall_guide_content': '向使用者發布遊戲前，可依據所使用功能建立各種不同條款。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide': '最終使用者授權合約(EULA)',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_guide_1': '如為需要安裝的遊戲或軟體，須告知使用者條款內容後取得使用者同意方可安裝。',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide': '服務使用條款',
  'studio.prj_prod_mngmt.prod_home.create_term.type2_guide_1':
    '如為遊戲套組（Package Game）或不支援於遊戲內付款，則無須填寫。想取得服務使用條款時填寫即可。',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide': '付款前注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.type3_guide_1': '用於STOVE遊戲幣的儲值服務。可撰寫儲值遊戲幣時顯示於付款視窗內的說明內容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide': '同意提供資訊予第三方',
  'studio.prj_prod_mngmt.prod_home.create_term.type4_guide_1': '用於使用者於遊戲內提供資訊時，須提供予STOVE外的第三方時。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide': '遊戲使用監護人同意',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_1': '如為遊戲套組（Package Game）或不支援於遊戲內付款，則無須填寫。',
  'studio.prj_prod_mngmt.prod_home.create_term.type5_guide_2': '未滿18歲的青少年遊玩遊戲，須徵求監護人同意時，所顯示的必要內容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide': '監護人同意蒐集個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_1': '如為遊戲套組（Package Game）或不支援於遊戲內付款，則無須填寫。',
  'studio.prj_prod_mngmt.prod_home.create_term.type6_guide_2': '未成年人於遊戲內付款須徵求監護人同意時，所顯示的必要內容。',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide': '同意蒐集及利用個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.type7_guide_1': '用於遊戲內接收使用者資訊、告知使用者活動宣傳內容‧',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_duplicate_popup': '條款已登錄完畢。<br/>如須修改條款內容，請於清單中查詢該條款。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_eula': '最終使用者授權合約(EULA)',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_usage': '服務使用條款',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_pre_payment_caution': '付款前注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_3rd_party': '同意提供資訊予第三方',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian': '使用遊戲監護人同意',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_guardian_info': '監護人同意蒐集個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.term_type_personal_info': '同意蒐集及利用個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name': '條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_guide': '所輸入的條款僅供自己可見，不會顯示予使用者。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_place_holder': '請輸入條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_title': '條款內容 ',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_guide': '修改已發布遊戲的條款時，將建立新版本的條款。發布前僅能儲存！',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_sample':
    '本文件具法律效力，最終定義使用者及{businessName}（以下簡稱「公司」）間提供軟體執行檔或安裝檔（以下簡稱「產品」）、安裝指南、使用者指南等一切文件（以下簡稱「文件」）之權利及義務。<br/>下載、安裝、複製、存取「產品」，即視為同意本合約細項，並已悉知條款一切內容，同意所有條件。<br/>如若不同意本合約條件，請勿下載、安裝、複製、存取即使用「產品」。已安裝之「產品」亦應立即銷毀，如已購買「產品」，請依退款政策退還授權許可，並收取已支付金額之退款。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_version_select': '載入',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_multi_lang_setting': '設定多國語言',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_input_fullscr': '全螢幕畫面',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_create': '登錄',
  'studio.prj_prod_mngmt.prod_home.create_term.btn_exit_fullscr': '關閉全螢幕畫面',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_ver': '套用至發布版本',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_name': '條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_type': '條款類別',
  'studio.prj_prod_mngmt.prod_home.prod_terms.release_applied_term_apply_date': '條款生效日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_ver': '版本',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_name': '條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_create_date': '創建日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_apply_date': '條款生效日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_btn': '刪除',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide': '刪除商品條款',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_guide1': '如欲刪除，請輸入「DELETE」，<br/>刪除後將無法復原。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms.term_del_cf_btn': '刪除',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.pg_title': '條款詳情',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name': '條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_guide': '所輸入的條款僅供自己可見，不會顯示予使用者。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_name_place_holder': '請輸入條款管理名稱。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_title': '條款內容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_content_edit_guide': '修改已發布遊戲的條款時，將建立新版本的條款。發布前僅能儲存！',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_eula_content_place_holder':
    '本文件具法律效力，最終定義使用者及{bizName}（以下簡稱「公司」）間提供軟體執行檔或安裝檔（以下簡稱「產品」）、安裝指南、使用者指南等一切文件（以下簡稱「文件」）之權利及義務。<br/>下載、安裝、複製、存取「產品」，即視為同意本合約細項，並已悉知條款一切內容，同意所有條件。<br/>如若不同意本合約條件，請勿下載、安裝、複製、存取及使用「產品」。已安裝之「產品」亦應立即銷毀，如已購買「產品」，請依退款政策退還授權許可，並收取已支付金額之退款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_version_select': '載入',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date': '條款生效日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_guide':
    '可設定條款生效日期。如尚未確定生效日期，則可透過預約功能指定任意日期。 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_immediate': '立刻',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_select_time': '預約',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_1': '已有適用中條款。<br/>確定要立即套用新條款嗎？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_case_2': '立即套用新條款。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_sel_guide': '生效日期只能選擇未來日期。<br/>請再次確認生效日期。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_sched_guide': '已有適用中條款。<br/>確定要預約新條款生效日期嗎？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_change_x': '為適用中條款，無法變更條款預約日期。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_saved_popup': '已儲存完畢。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_popup_msg':
    '已於發布時發布之條款僅能透過登錄新版本更新。<br/>確定要將填寫內容登錄為新版本嗎？',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.save_as_new_ver_cf_btn': '登錄',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.saved_as_new_ver_cf_msg': '新版本已登錄完畢。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_name': '條款管理名稱',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_content': '條款內容 ',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.view_mode_term_apply_date': '條款生效日期',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_btn': '暫停',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide_title': '暫停條款',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_guide': '如欲停止，請輸入「SUSPEND」，<br/>停止後將無法復原。',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_app_suspend_cf_btn': '暫停',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_none_guide': '如支援遊戲內商店，請務必登錄服務使用條款。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_content_place_holder': '範例請參閱右側說明的「公平交易委員會標準條款」。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide': '服務使用條款',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_1': '服務使用條款與STOVE及Studio使用條款無關，針對使用者及開發商之間的糾紛概不負責。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_2': '如難以填寫內容，請透過下方連結反映各遊戲特殊事項，制定服務使用條款。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_standard_ref': '公平交易委員會準則 > ',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_3':
    '*一般情況下，建議開發公司於七天前通知消費者服務使用條款變更內容，如遇重大事件或不利事件時，建議於三十天前通知消費者。',
  'studio.prj_prod_mngmt.prod_home.create_term.usage_guide_preview': '範例圖片）',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_content_sample':
    '供應商：{businessName}<br/>您所購買Cash將透過ID（帳號）發放，付款後即可立刻使用。<br/>所儲值之Cash有效期限為最後一次使用日起算五年。<br/>未使用之Cash可於儲值日起，於七天內以付款方式進行退款。然而，如使用無法取消付款之付款方式或超過可取消期限時，將退款至用戶帳戶。<br/>關於取消訂單及退款詳情，敬請參考付費內容條款。<br/>須連線至網路，方可領取及利用Cash，建議使用Internet Explorer11、Chrome最新版本。使用Cash購買內容或道具時，須符合驅動各遊戲或服務之技術規格配置，購買前請詳閱各遊戲及服務首頁之「系統規格」。<br/>消費者諮詢號碼可於首頁下方查看。',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide': '付款前注意事項',
  'studio.prj_prod_mngmt.prod_home.create_term.pre_payment_caution_guide_1':
    '此條款僅用於在「STOVE」中管理遊戲幣。可撰寫並管理儲值遊戲幣前所顯示的內容。',
  'studio.prj_prod_mngmt.prod_home.create_term.term_content_place_holder': '請輸入條款內容',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide': '同意提供資訊予第三方',
  'studio.prj_prod_mngmt.prod_home.create_term.3rd_party_info_use_guide_1': '使用者的資訊提供予非STOVE或開發商之第三方時，取得使用者同意時使用。',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide': '遊戲使用監護人同意',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_agree_guide_1':
    '遇未滿18歲的青少年遊玩遊戲，須徵求監護人同意時，所顯示之同意內容。可透過監護人本人認證執行同意流程。',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide': '監護人同意蒐集個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.guardian_info_guide_1': '未成年人於遊戲內付款須徵求監護人同意時，告知須取得監護人同意的條款！',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide': '同意蒐集及利用個人資訊',
  'studio.prj_prod_mngmt.prod_home.create_term.personal_info_guide_1': '接收並利用使用者個人資訊時取得同意的條款！',
  'studio.prj_prod.this_prod.home_search_place_holder': '請搜尋商品',
  'studio.prj_prod.this_project.this_product.home_search_nmrf_msg': '搜尋結果不存在。',
  'studio.prj_prod.prod_home.tabs_home': '商品首頁',
  'studio.prj_prod.this_prod.home_setting_guide': '請輸入基本資料，並連結與Demo、DLC等其他相關商品。',
  'studio.prj_prod.this_prod.home_product_page_guide': '請準備圖片、影片、說明並裝飾商品頁面。',
  'studio.prj_prod.this_prod.home_price_guide': '請設定商品販售價格。',
  'studio.prj_prod.this_prod.home_discount_guide': '可分別新增折扣。',
  'studio.prj_prod.this_prod.home_sale_guide': '設定為只有擁有特定商品的使用者才能購買的商品。',
  'studio.prj_prod.this_prod.home_early_access_guide': '如想在完成前提前販售商品，請輸入介紹文字。',
  'studio.gnb.common_2depth_stove_pc_sdk': 'STOVE PC SDK',
  'studio.prj_prod.this_prod.home_stove_pc_sdk_guide': '可使用所有權、管理指標等STOVE附加服務。',
  'studio.prj_prod.this_prod.home_build_guide': '可上傳欲在商店中販售的Game及Utility的組建。',
  'studio.prj_prod.this_prod.home_execution_guide': '可設定商品執行平台及驅動方法。',
  'studio.gnb.common_2depth_client_test': '客戶端執行測試',
  'studio.prod_home.component_client_test': '客戶端執行測試',
  'studio.prj_prod.this_prod.home_client_test_guide': '下載STOVE PC客戶端，親自測試。',
  'studio.prj_prod.this_prod.home_tier_review_guide': '可於STOVE所提供之免費「GRAC STOVE審議分級」進行審查。 ',
  'studio.prj_prod.this_prod.home_condition_guide': '可使用制定標準條款或自訂條款。',
  'studio.prj_prod.this_prod.home_stats_guide': '可儲存及管理與SDK連動的商品數據數值。',
  'studio.prj_prod.this_prod.home_ranking_guide': '可利用統計數據確認使用者的排名。',
  'studio.prj_prod.this_prod.home_challenges_guide': '可設定目標及分別確認使用者是否達成。',
  'studio.prj_prod.this_prod.home_cloud_guide': '可在任何裝置尚同步最新儲存檔案。',
  'studio.prj_prod.this_prod.home_match_guide': '降低網路延遲時間。',
  'studio.prj_prod.this_prod.home_banner_guide': '登錄橫幅圖片，可以讓商品在商品清單中更顯眼。',
  'studio.prj_prod.this_prod.home_in_app_setting_guide': '可選擇是否使用遊戲內商店。 ',
  'studio.prj_prod.this_prod.home_in_app_shop_guide': '可建立遊戲內道具商店。 ',
  'studio.prj_prod.this_prod.home_in_app_product_guide': '可登錄遊戲內販售的道具。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_guide': '可以折扣價格販售道具。',
  'studio.prj_prod.this_prod.home_in_app_payment_history_guide': '可查看並管理遊戲內道具販售紀錄。 ',
  'studio.prj_prod.this_prod.home_in_app_discount_pre_release_access_n': '折扣選單在商品上市後才可以使用。<br/>上市時可以另外設定上市折扣。',
  'studio.prj_prod.this_prod.home_product_setting_title': '設定商品',
  'studio.prj_prod.this_prod.home_product_setting_basic_title': '基本資訊',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg1': '可透過多國語言設定功能查看您所輸入的基本資訊翻譯內容。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2': '商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_place_holder': '請輸入商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg2_required_n': '請輸入商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_invalid':
    "無法使用除了- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。以外的特殊符號。",
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3': '創作者名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_place_holder': '請輸入創作者名稱',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_required_n': '請輸入創作者名稱。',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4': '發行商名',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_place_holder': '請輸入發行公司名稱',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg4_required_n': '請輸入發行公司名稱。',
  'studio.prj_prod.this_prod.home_product_setting_category': '類別',
  'studio.prj_prod.this_prod.home_product_setting_category_val_msg': '請選擇1個以上的類別。 ',
  'studio.prj_prod.this_prod.home_product_setting_representative_category': '代表類別',
  'studio.prj_prod.this_prod.home_product_setting_prod_type': '商品類型',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_guide': '發布前可自由變更類別，但當連動的商品已存在或正式發布後，將無法變更類別。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic': '正式版Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo': 'Demo Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_place_holder': '請搜尋商品',
  'studio.prj_prod.this_prod.home_product_setting_prod_add_btn': '新增',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type': '支援功能',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_online': '線上 - 透過網路連結伺服器時',
  'studio.prj_prod.this_prod.home_product_setting_prod_supported_type_vr': 'VR  - 須配備或支援VR功能時 ',
  'studio.prj_prod.this_prod.home_product_setting_guide1': '基本資訊及類別',
  'studio.prj_prod.this_prod.home_product_setting_guide1_1':
    '您所輸入的訊息將於商品頁面向使用者公開，且為年齡分級時重要依據。依您的語言輸入基本資訊後，請透過多國語言設定以AI進行翻譯。<br/>如欲修改GRAC STOVE審議分級商品的商品名稱、創作者名稱、類別，須透過申請修改內容進行，且須重新年齡分級。',
  'studio.prj_prod.this_prod.home_product_setting_guide2': '商品類型',
  'studio.prj_prod.this_prod.home_product_setting_guide2_1':
    '一般來說，正式上市將預選正式版Game的類型，但在正式上市前也可將類型選為Demo版Game後再上市。<br/>Demo版Game上市後，可將其變更為正式版正式上市，亦可登錄新產品，並將正式版Game與Demo版連結後進行個別管理，可自由選擇。',
  'studio.prj_prod.this_prod.home_product_setting_guide6': '連動商品',
  'studio.prj_prod.this_prod.home_product_setting_guide6_1':
    '如有與正式上市商品相關的Demo、DLC、Utility等各個組建，可建立商品後再與正式上市的Game商品進行連結，一併顯示於商品頁面。<br/>然而，需在已連結的各商品頁面及組建的管理選單中輸入資訊後，再進行審查及上市。（DLC上市後無法解除。）<br/>※ 如為已與其他商品連結的商品，則無法新增，解除連結後即可新增。',
  'studio.prj_prod.this_prod.home_product_setting_guide9': '商品頁面 - Demo套用範例',
  'studio.prj_prod.this_prod.home_product_setting_guide8': '商品頁面 - DLC/Utility套用範例',
  'studio.prj_prod.this_prod.home_product_setting_prod_search_nmrf': '無可選擇的商品。',
  'studio.prj_prod.this_prod.home_product_setting_depth_search_add_btn': '新增新商品',
  'studio.prj_prod.this_prod.home_product_setting_search_all_prod_chkbox': '所有商品',
  'studio.prj_prod.this_prod.home_product_setting_multiple_select_case': '除{productName}({productID})外{extraSelectedNum}個商品',
  'studio.prj_prod.this_prod.home_product_setting_demo_add_pop_msg': '請輸入新登錄的Demo商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_new_add_pop_place_holder': '請輸入商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_val_required_n': '請輸入商品名稱。 ',
  'studio.prj_prod.this_prod.home_product_setting_val_duplication_msg': '已有相同名稱的商品。請輸入其他商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_add_register_btn': '登錄',
  'studio.prj_prod.this_prod.home_product_setting_dlc_add_pop_msg': '請輸入新登錄的DLC商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_content_add_pop_msg': '請輸入新登錄的Content商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_utility_add_pop_msg': '請輸入新登錄的Utility商品名稱。',
  'studio.prj_prod.this_prod.home_product_setting_prod_id_header1': '商品編號',
  'studio.prj_prod.this_prod.home_product_setting_prod_name_header2': '商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_prod_status_header3': '發布狀態',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_header4': '獨立頁面',
  'studio.prj_prod.this_prod.home_product_setting_prod_haspage_hover_msg': '若需顯示作為 Demo 新增之商品的商店商品頁面，請啟用此選項。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_demo_list_unlink_pop_msg1': '確定要解除連動Demo嗎？',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_cnf_btn': '解除',
  'studio.prj_prod.this_prod.home_product_setting_dlc_list_unlink_pop_msg1': '確定要解除連動DLC嗎？',
  'studio.prj_prod.this_prod.home_product_setting_content_list_unlink_pop_msg1': '確定要解除連動Content嗎？',
  'studio.prj_prod.this_prod.home_product_setting_utility_list_unlink_pop_msg1': '確定要解除連動Utility嗎？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg1': '要更改商品類型嗎？',
  'studio.prj_prod.this_prod.home_product_setting_type_list_change_pop_msg2': '通過發行計劃應用 Live 時，需要重新設定用戶的現有所有權。',
  'studio.prj_prod.this_prod.home_product_setting_list_unlink_pop_change_btn': '變更',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg1': '無法連動DLC說明',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_pop_msg2':
    '已設定遊戲內付款。<br/>請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.prj_prod.this_prod.home_product_setting_dlc_link_x_dir_ingame_setting_btn': '立刻查看',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip': '如停用該選項，則只能管理上層商品頁面。',
  'studio.prj_prod.this_prod.home_product_setting.demo_prod_pg_yn_tooltip_details':
    '未顯示Demo商品頁面<br/>未顯示Demo商品評論及使用者評價<br/>Demo商品的公告欄將以上層商品公告欄代替，<br/>顯示上層商品頁面上的Demo商品條款及年齡分級',
  'studio.prj_prod.this_prod.home_product_setting_linked_game': '上級遊戲',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_id_header1': '商品編號',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_name_header2': '商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_prod_status_header3': '發行狀態',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_requesting': '發行請求',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_rejected': '發行被駁回',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_coming_soon': '預定發行',
  'studio.prj_prod.this_prod.home_product_setting_linked_game_release_stt_available': '發行中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game': '上層Game',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_no': '商品編號',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_name': '商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_under_review': '審核中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_awaiting': '等待發行',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_released': '發行中',
  'studio.prj_prod.this_prod.home_product_setting_higher_game_stt_release_suspended': '發行中止',
  'studio.prj_prod.this_prod.home_product_setting_guide5': '解除連動',
  'studio.prj_prod.this_prod.home_product_setting_guide5_1': '可於連動的上層商品的商品設定選單中解除連動。',
  'studio.prj_prod.this_prod.home_product_setting_guide11': '商品類型',
  'studio.prj_prod.this_prod.home_product_setting_guide11_1': '以Demo連動商品時，無法變更商品類型。如須個別單獨發布，須先解除連動後再變更商品類型。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_msg0': '獨立頁面設定為不顯示。',
  'studio.prj_prod.this_proj.this_prod.edit_sidebar_publish_edit_btn': '修改',
  'studio.prj_prod.this_prod.home_product_setting_guide6_2':
    '如將含有商品內容的可執行Demo版本視為新商品上傳並連動，即可使Demo商品一同顯示於商品頁面。<br/>然而，須在已連動的各商品及版本須在該商品頁面的管理清單的管理清單中輸入資訊後進行審查及發布。<br/>※如為與其他商品連動的商品則無法新增，須解除連動後新增。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_msg1': '發布前可自由變更類別，但當連動的商品已存在或正式發布後，將無法變更類別。',
  'studio.prj_prod.this_prod.home_product_setting_content_type': '詳細類型',
  'studio.prj_prod.this_prod.home_product_setting_content_sound_hover_msg': '音軌、全語音等與聲音相關的內容',
  'studio.prj_prod.this_prod.home_product_setting_content_image_hover_msg': '插圖、Art Book等與圖片相關的內容',
  'studio.prj_prod.this_prod.home_product_setting_content_video_hover_msg': 'PV、動畫電影等與影片相關的內容',
  'studio.prj_prod.this_prod.home_product_setting_content_type_val_msg': '請選擇詳細類型。',
  'studio.prj_prod.this_prod.home_product_setting_guide7': '基本資訊',
  'studio.prj_prod.this_prod.home_product_setting_guide7_1':
    '您所輸入的資訊為於商品頁面向使用者公開的重要資訊，請以基準言輸入後，使用多國語言設定以AI進行翻譯。',
  'studio.prj_prod.this_prod.home_product_setting_guide2_2':
    '一般來說，正式發布將預設選擇Content，但在正式發布前也可先選擇Demo後再發布。<br/>可先以Demo發布後，再變更為Content類別後正式發布，亦可註冊Demo再連動新商品個別管理，可自由選擇。',
  'studio.prj_prod.this_prod.home_product_setting_guide4': '詳細類型',
  'studio.prj_prod.this_prod.home_product_setting_guide4_1': '將依您所選的類型分別顯示於商店商品頁面上，請確認您所選擇的類型與您所上傳的檔案一致。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_3':
    '如將含有正式上市版本內容的體驗版內容當作新商品上傳，連結商品時Demo版商品可一同顯示於正式上市的商品頁面中。<br/>然而，需在已連結的各商品頁面及組建的管理選單中輸入資訊後，再進行審查及上市。<br/>※ 如為已與其他商品連結的商品，則無法新增，解除連結後即可新增。',
  'studio.prj_prod.this_prod.home_product_setting_linked_content': '商品Content',
  'studio.prj_prod.this_prod.home_product_setting_guide2_3':
    '一般來說，正式上市將預選正式版Utility的類型，但在正式上市前也可將類型選為Demo版Utility後再上市。<br/>Demo版Utility上市後，可將其變更為正式版正式上市，亦可登錄新產品，並將正式版Utility與Demo版連結後進行個別管理，可自由選擇。',
  'studio.prj_prod.this_prod.home_product_setting_guide6_4':
    '如有與正式上市商品相關的Demo或DLC的各個組建，可建立商品後再與正式上市的Utility商品進行連結，一併顯示於商品頁面。<br/>然而，需在已連結的各商品頁面及組建的管理選單中輸入資訊後，再進行審查及上市。（DLC上市後無法解除。）<br/>※ 如為已與其他商品連結的商品，則無法新增，解除連結後即可新增。',
  'studio.prj_prod.this_prod.home_product_setting_guide10': '商品頁面 - DLC套用範例',
  'studio.prj_prod.this_prod.home_product_setting_linked_utility': '上層Utility',
  'studio.prj_prod.this_prod.home_product_setting_guide6_5':
    '如果 Demo 建構存在，您可以創建商品並將其連接到正式發佈的公用產品，並能在商品頁面上一同顯示。<br/>但連接的每個商品頁面和建構必須在該商品的管理菜單中設置信息，然後進行審核和發佈。<br/>※ 若商品已連接至其他商品，則無法新增。解除連接後即可新增。請在重新設定後重新註冊到發佈計劃中。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_stt': '審查中',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_guide': 'LIVE發布審查過程中無法修改，請待審查完畢。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_name': '商品名稱',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_creator_name': '創作者名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_distrib_co_name': '發行商名',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_genre': '類別',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_type': '商品類型',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type': '支援功能',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type1_onl': '線上',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type2_onl_vr': '線上、VR',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_supported_type3_none': '不適用',
  'studio.common.live_apply_popup_title': '套用至LIVE',
  'studio.common.popup_case_ii_release_guide': '如欲套用，請輸入「RELEASE」。<br/>商品名稱、創作者名稱、代表類別將於內容修正申報審查結束後自動套用。',
  'studio.common.popup_case_iv_release_guide': '已套用至LIVE。',
  'studio.common.popup_case_v_release_guide': '無修改內容。<br/>請重新確認。',
  'studio.common.popup_case_vi_release_guide': '有修改內容。<br/>確定不套用就離開嗎？',
  'studio.common.popup_case_vi_release_guide_close_btn': '關閉',
  'studio.prj_prod.this_prod.home_product_setting_rating_under_review_edit_x_guide': '正在審查年齡分級中，無法修改基本資訊。',
  'studio.prj_prod.this_prod.home_product_setting_under_review_info_view_prod_detailed_type': '詳細類型',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_title':
    "商品類型變更說明（Demo <i class='stove-ui-icon h-20 w-20 text-3xl before:ic-v2-control-arrow-right-line'></i> {basicType}）",
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide1':
    '如欲變更為{basicType}，須停止原先的Demo版商品上市，並重新設定組建、商品頁面及價格等正式上市的必要項目後再上市才能套用。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting': '商品所有權',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw': '回收',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_withdraw_guide':
    '（回收使用者對Demo的所有權後，所有權將重置，進行正式發布。）',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain': '維持 ',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_copyright_setting_remain_guide':
    '（玩家對Demo商品的所有權在正式上市後仍相同。）',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_1': '如欲重新發布，請輸入「CONFIRM」。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_popup_guide2_2': '進行後將無法再復原，請慎選。',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_cf_btn': '進行重新發布',
  'studio.prj_prod.this_prod.home_product_setting_post_release_type_change_complete_popup':
    '已暫停發布。<br/>請設定正式發布所需的必要項目後，再進行發布。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg1': '原本的Demo商品已停售。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg2': '已開放正式上市的必填功能。',
  'studio.prj_prod.post_release.demo_to_game.popup_msg3': '(價格、折扣、搶先體驗)<br/>請透過上市按鈕進行正式上市。',
  'studio.prj_prod.this_prod.home_early_access_title': '設定搶先體驗字句',
  'studio.prj_prod.this_prod.home_early_access_save_btn': '儲存',
  'studio.prj_prod.this_prod.home_early_access_msg': '搶先體驗介紹',
  'studio.prj_prod.this_prod.home_early_access_preview_btn': '預覽',
  'studio.prj_prod.this_prod.home_early_access_full_btn': '以全螢幕顯示',
  'studio.prj_prod.this_prod.home_early_access_prompt1': 'Q.為什麼要搶先體驗呢？',
  'studio.prj_prod.this_prod.home_early_access_place_holder': 'A.請輸入內容。',
  'studio.prj_prod.this_prod.home_early_access_prompt2': 'Q.在搶先體驗時，遊玩這款遊戲多久？',
  'studio.prj_prod.this_prod.home_early_access_prompt3': 'Q.正式版本和搶先體驗版本有什麼不同呢？',
  'studio.prj_prod.this_prod.home_early_access_prompt4': 'Q.搶先體驗時期和往後遊戲的價格會有所不同嗎？',
  'studio.prj_prod.this_prod.home_early_access_prompt5': 'Q.如何讓討論區參與開發過程？',
  'studio.prj_prod.this_prod.home_early_access_prompt_required_n': '請撰寫搶先體驗的介紹。',
  'studio.prj_prod.this_prod.home_early_access_guide1': '搶先體驗是什麼？',
  'studio.prj_prod.this_prod.home_early_access_guide1_1':
    '讓使用者知道此款商品尚在開發中並販售予使用者的商品。就算搶先體驗商品不完美，也要讓搶先體驗的商品是處於可以遊玩的狀態，並有持續開發並發布商品的計畫。',
  'studio.prj_prod.this_prod.home_early_access_guide2': '一定要寫搶先體驗介紹嗎？',
  'studio.prj_prod.this_prod.home_early_access_guide2_1':
    '想以搶先體驗的方式發布，就必須填寫搶先體驗的通知字句。在搶先體驗期間，此搶先體驗介紹將會出現在商品頁面上。',
  'studio.prj_prod.this_prod.home_early_access_tooltip_hover_msg': '可於全螢幕畫面中輸入深色模式。',
  'studio.prj_prod.this_prod.home_early_access_preview_title': '預覽搶先體驗的文字',
  'studio.prj_prod.this_prod.home_early_access_preview_guide1': '此商品為搶先體驗的版本。',
  'studio.prj_prod.this_prod.home_early_access_preview_guide2': '在未來的更新中，可能會修改部分商品內容或調整價格。',
  'studio.prj_prod.this_prod.home_early_access_preview_see_creator_comment': '查看製作人評論',
  'studio.prj_prod.this_prod.home_early_access_text_display': '顯示選項',
  'studio.prj_prod.this_prod.home_early_access_text_display_y': '顯示',
  'studio.prj_prod.this_prod.home_early_access_text_display_n': '不顯示',
  'studio.prj_prod.this_prod.home_early_access_full_exit_btn': '關閉全螢幕畫面',
  'studio.prj_prod.this_prod.home_early_access_darkmode': '深色模式',
  'studio.prj_prod.this_prod.marketing_banner_rectangular_image_title': '方形圖片',
  'studio.prj_prod.this_prod.marketing_banner_portrait_image_title': '直向圖片',
  'studio.prj_prod.this_prod.marketing_banner_landscape_image_title': '橫向圖片',
  'studio.prj_prod.this_prod.marketing_banner_preview_btn': '預覽',
  'studio.prj_prod.this_prod.marketing_banner_image_title': '橫幅圖片',
  'studio.prj_prod.this_prod.marketing_banner_guide1': '橫幅圖片是什麼？一定要登錄嗎？',
  'studio.prj_prod.this_prod.marketing_banner_guide1_1':
    '橫幅圖片非必須項目。<br/>登錄橫幅圖片後，STOVE商店營運人員即可將橫幅圖片設為顯示在商品清單頁面中，<br/>使登錄的商品在商品清單中更顯眼。',
  'studio.prj_prod.this_prod.marketing_banner_preview_title': '預覽圖片',
  'studio.prj_prod.this_prod.marketing_banner_preview_msg': '協助理解的範例圖片。',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title1': '舊世界（Old World）',
  'studio.prj_prod.this_prod.marketing_banner_preview_sample_title2': '寓言王國（Fabledom）',
  'studio.prj_prod_mngmt.rating_build_review.popup_no_view_per': '您沒有查詢權限。<br/>請向管理員詢問。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1': '欲上市遊戲，上傳的組建需接受審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.guide1_1': '接受審查前，請確認是否具下列項目。<br/>至審查結束最多需要七天，請提前做足準備。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info': '個人／企業資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_guide':
    '輸入個人／事業者資訊時，需事先準備住民登錄謄本、護照、身分證、營業執照',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl': '上傳組建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_upl_guide': '請事先上傳欲接受審查的組建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content': '遊戲內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.game_content_guide': '請提前準備遊戲影片／CG圖片／台詞檔案',
  'studio.prj_prod_mngmt.rating_build_review.self_review.bims_bank_info_pg_dir_btn': '輸入資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.build_mgmt_pg_dir_btn': '上傳',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb1': '管理專案‧商品',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb2': '{productName}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb3': '使用等級及組建審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pg_title': '使用等級及組建審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.popup_no_info': '未登錄個人、企業資訊。<br/>請先輸入個人、企業資訊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_reg_x': '個人／企業資訊正在審查中，<br/>審查完成後即可註冊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_btn': '登錄審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_btn': '查看歷史紀錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_info_title': '遊戲基本資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.game_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.dev_company': '開發商名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.genre': '代表類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.info_edit_btn': '修改資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_info_title': '企業／負責人資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.country': '所在國家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_reg_num': '商業登記編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_type': '企業類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_category': '製作／發行類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.biz_name': '企業名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.representative_name': '代表人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.pic_name': '負責人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.email': '電子信箱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact': '聯絡方式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.contact_guide':
    '由{grpName}接收審查過程的負責人練絡方式。<br/>將透過您所輸入的聯絡資訊告知審查結果。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1': '在這裡要做什麼呢？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide1_1':
    '為了正式上市，需要使用等級。<br/>請選擇欲接受審查的使用等級，並連結欲進行上市的組建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2': 'GRAC STOVE審議分級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide2_1':
    '可透過STOVE進行GRAC年齡分級審查。如您是第一次審查，請務必試試看！<br/>是免費的服務。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide3_1':
    '可直接輸入審查完成的韓國等級編號，並登錄為年齡分級。<br/>執行設定只有WEB時，僅可透過直接輸入來進行登錄。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4': '國際等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.guide4_1':
    '除GRAC外，如有其他國際年齡分級編號，亦可直接輸入登錄使用等級。<br/>登錄的使用等級如下圖所示。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_1': '審查資訊登錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.title': '審查資訊登錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating': '選擇年齡分級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.select_rating_grac_self_review': 'GRAC（韓國）STOVE審議分級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide': '青少年無法遊玩的遊戲無法自行審議。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.guide_ex': '範例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build': '組建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_place_holder': '請選擇組建',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_no_result': '搜尋結果不存在。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country': '原著國家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_guide': '請選擇遊戲實際誕生的原著國家 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description': '一行說明',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_guide': '請撰寫一行說明，介紹遊戲。',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.intl_org.chkbox': '已有國際年齡分級編號。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_org_dropbox_place_holder': '請選擇',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ESRB': 'ESRB（北美／南美）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI': 'PEGI（歐洲／中東）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.PEGI2': 'PEGI 2（葡萄牙）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.USK': 'USK（德國）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.ACB': 'ACB（澳洲）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CLASS_IND': 'Classlnd（巴西）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.CERO': 'CERO（日本）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.IARC': 'IARC（除上述國家外的國家）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.select_rating_dropbox_place_holder': '請選擇',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.enter_rating_reg_num_place_holder': '請輸入等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.none_rating_reg_num_val_msg1': '請登錄1個以上的國際機關年齡分級。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.self_review.rating_reg.intl_org.allowed_char_msg': '僅能輸入數字、「-」及英文。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.add_rating_reg_num_btn': '新增 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case1_popup':
    '每個國際年齡分級，最多可以增加2個等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case2_popup':
    '每個國際年齡分級，最多可以增加1個等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.region_org': '地區',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating': '等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_reg_num': '編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.intl_org.rating_num_exceed_case3_popup':
    '每個國際年齡分級，<br/>最多可以增加1個等級。<br/>確定要重置清單嗎？',
  'studio.prj_prod_mngmt.rating_build_review.rating_reg.next_btn': '繼續 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.teenagers_prohibited_review_x_guide_popup':
    "如欲接受審查的遊戲為<span class='text-tint-red-a400 font-bold'>青少年無法遊玩</span>的遊戲，<br/><span class='text-on-surface-elevation-1 font-medium'>將無法透過自行審查接受年齡分級審查，</span><br/>須透過GRAC（遊戲管理委員會）<br/>接受審查。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_missing_popup': '必須輸入遊戲基本資訊及企業資訊。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.fill_qtn_tab': '填寫問卷調查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_reg_title': '審查資訊登錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_tab': '附上審查資料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.pre_qtn': '0.預先問卷調查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_violence': '1.暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_sexuality': '2.煽情性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_gambling': '3.賭博性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_horror': '4.恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_language': '5.語言',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_drug': '6.藥物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_crime': '7.犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_progress': '進度：{percentage}%',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_next_btn': '繼續',
  'studio.prj_prod_mngmt.rating_build_review.self_review.qtn_back_btn': '回到上一步',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_btn': '附上<br/>審查資料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin': '選擇原作國家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_guide': '請選擇遊戲實際誕生的原作國家。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_place_holder': '選擇',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_country_of_origin_val_msg': '請選擇原著國家。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr': '遊戲說明',
  'studio.common.full_scr_btn': '全螢幕畫面',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_guide': '請輸入審查時所需的Game說明',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_req_val_msg': '請撰寫遊戲說明。',
  'studio.common.exit_full_scr_btn': '關閉全螢幕畫面',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method': '遊戲操作方法',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_guide': '請寫出要用什麼方式遊玩遊戲。<br/>可附上截圖。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_create_method_req_val_msg': '請寫出遊戲操作方法。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc': '附上審查資料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_guide': '可另外附上檔案或可下載的連結。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_link_format_val_msg': '請輸入正確的連結。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_dl_link_btn': '新增連結',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_add_btn': '附件',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg1': '檔案大小不得超過 2GB。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_size_limit_val_msg2': '請將超過容量的檔案用下載連結的方式新增，再申請審查。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg1': '附加檔案不得超過10個。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.attch_doc_num_limit_val_msg2': '請將超過個數的附檔用下載連結的方式新增，再申請審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide': '審查資料必填項目',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1': '1.遊戲遊玩影片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_1':
    '請分為前期／中期／後期，依各階段上傳。（如有多種結局，請附上所有結局影片）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_2': '如有煽情或暴力影片，請額外上傳，並在檔案上標註',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_3': '請上傳.mp4、.avi等影片格式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_4': '影片大小太大時，也可以在「Game說明」內新增影片的下載連結',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex1': '遊戲前期（6分鐘）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex2': '遊戲中期（6分鐘）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide1_ex3': '遊戲後期（6分鐘）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2': 'CG圖片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_1': '請附上遊戲中所有角色的CG圖片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_2': '如有煽情或暴力圖片，請額外上傳，並在檔案上標註',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide2_3': '請上傳.png、.jpg、.gif等圖片格式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3': '3.語言檔案',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_1': '請附上遊戲內出現的所有文本檔案。（角色台詞、旁白、UI等）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_2': '如未出現髒話或煽情台詞，則不必附上',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_attch_guide3_3': '請上傳.word、.pdf、.hwp等文件格式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_1': '{rating}歲可使用<br/>{category}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_2': '為您的預估等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_3': '審查過程中，無法變更商品資訊及企業資訊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_4': '審查結束後，如變更商品名稱、創作者名稱、類別，<br/>須重新進行審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_req_cf_btn': '申請審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_1': '預估<span class="text-tint-red-a400">青少年無法使用</span>。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_2': '青少年無法遊玩的遊戲<br/>須直接接受遊戲管理委員會審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide2_3': "如須直接審查相關協助，<br/>請聯絡：stove.rating{'@'}smilegate.com",
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_1': '已申請審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_2': '預計需2～4個工作天。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide3_3': '審查結果將透過電子郵件及「通知」進行通知。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide1': '正在審查中。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_guide2': '預計最多需2～4個工作天。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_1': '審查前',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_2': '審查中',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3': '審查完畢',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_detail_pg_dir_btn': '確認審查中資訊 ',
  'studio.prj_prod_mngmt.rating_build_review.info_detailed_pg_dir_btn': '詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_company': '開發商名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_genre': '代表類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_type': '年齡分級類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_assigned_date': '等級分類日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif': '等級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_classif_detail': '分類內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_rating_reg_num': '等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_info_build_id': '組建ID',
  'studio.prj_prod_mngmt.rating_build_review.reg_btn': '登錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_guide': '已審查完畢，<br/>可發布遊戲。',
  'studio.prj_prod_mngmt.rating_build_review.release_plan_dir_btn': '上市',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_done_re_reg_guide':
    '已有透過自行審議分類取得之年齡分級。<br/>如欲重新登錄，須手動輸入分類編號，先前的年齡分級將被刪除。<br/><br/>確定要重新登錄嗎？ ',
  'studio.prj_prod_mngmt.rating_build_review.see_history_btn': '查看歷史紀錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_guide': '審查已<span class="text-[#EC3B47]">退回</span>。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_stt': '退回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_chk_btn': '查看退回原因',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rejected_reason_pg_title': '查看退回原因',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_2': '查看退回原因',
  'email.review_result_noti.completed.title': '{prodName}審查完成 ',
  'email.review_result_noti.completed.msg_1': '{prodname}已完成審查。 ',
  'email.review_result_noti.completed.msg_2': 'GRAC STOVE審議分級審查結果為{rating}級。 ',
  'email.review_result_noti.go_to_review_pg_btn': '立刻查看 ',
  'email.review_result_noti.rejected.title': '{prodname}審查退回',
  'email.review_result_noti.rejected.msg_1': '{prodName}的審查已退回。<br/>如欲確認原因，請點擊[立即前往]。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide1': '正當權利是什麼？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_guide2':
    '正當權利為具「法律依據」。<br/>只要是使用正當版權創作的作品，均可接受審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1': '重新年齡分級對象基準',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_1':
    '修改或新增遊戲主要內容（劇情、角色、道具等）、影片、聲音元素等的程度可能會影響到評定年齡分級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_2': '修改遊戲貨幣的儲值、轉移、使用等使用方式。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_3':
    '修改其他可能會引發賭博性或引發使用者過度投入遊戲之遊戲進行方式。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_4': '如為街機遊戲，修改遊戲內容、遊玩方法、程式。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_5': '長期未上報修改內容或新增內容過於龐大。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide1_6': '修改其他部分至需更改年齡分級的程度。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2': '賭博性遊戲',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_1': '可依遊戲的結果獲得現金  ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_2': '符合下列任一項即為透過資訊通信網提供之賭博性遊戲',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_3': '1)直接以現金儲值遊戲貨幣',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_4': '2)使用者可於遊戲內互相轉移遊戲貨幣',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_5': '3)在遊戲內將勝負獲得的分數或遊戲貨幣兌換為現金',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_6': '4)依據勝負結果，可獲得現金或其他物品',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn02_guide2_7':
    '5)以直接或間接方式將遊戲勝負所獲得的分數或遊戲貨幣轉換為有形或無形獎勵提供予使用者',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn01_copyright_n_popup':
    '須持有遊戲著作權<br/>才能進行審查。<br/>請確認著作權後重新選擇。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn023_gambling_y_popup': '賭博性遊戲<br/>無法透過自行審議進行審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.pre_qtn031_crime_y_popup':
    '包含該內容的遊戲<br/>無法透過自行審議進行年齡分級審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1': '人形角色',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide1_1': '包括實際人類及人形的角色、怪物（例如：鷹身女妖、半人馬）等',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2': '暴力表現範例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1': '下圖為參考範例資料。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_1': '以簡單、漫畫的效果呈現',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide2_1_2': '雖然是鮮血，卻是以漫畫方式呈現',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3': '武器類及攻擊呈現範例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1': '下圖為參考範例資料。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_1': '呈現攻擊行為',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide3_1_2': '攻擊呈現逼真',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4': '描繪鮮血和殘缺屍體',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1': '下圖為參考範例資料。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_1': '可呈現行為，但不能直接呈現',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide4_1_2': '雖實際呈現出毀損，但只呈現出極少數',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5': '資源掠奪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_1':
    '單純等級：<br/>入侵對方領土後，可消耗對方累積的資源（單純）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn1_guide5_2':
    '輕微等級：<br/>入侵對方領土後，可搶奪對方資源，但24小時內無法再次入侵相同對象領土，且一周內不能搶奪3次以上',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide': '煽情描繪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1': '下圖為參考範例資料。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_1': '局部暴露的輕微裸露',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_2': '上半身（胸部）、下半身輕微暴露',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_3': '露骨地裸露讓人聯想到性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn2_guide1_4': '裸露除生殖器以外的重要部位',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1': '賭博性要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_1':
    '輕微等級：<br/>賭博，但不存在投注要素。雖有卡牌和輪盤，但規則只適用於遊戲內<br/>無撲克、二十一點、One Card要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_2':
    '限制等級：<br/>僅有極少數撲克、One Card要素出現在迷你遊戲中，無投注要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide1_3':
    '實際等級：<br/>有撲克、二十一點、One Card、Go-stop要素，<br/>於遊戲內獲得的貨幣幾乎等同於現金相似的價值<br/>具使用者間進行交易的拍賣場',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2': '機率道具（扭蛋等）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_1':
    '如想使用可遊玩的角色或道具，須儲值遊戲內貨幣，購買後隨機抽取角色或道具才能遊玩。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn3_guide2_2':
    '使用者之間可於交易場交易遊戲內儲值或取得的商品，也可以在現實生活中兌現',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide': '恐怖描寫',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1': '下圖為參考範例資料。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_1': '僅以背景表達氣氛',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_2': '營造出陰森、黑暗的氣氛',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_3': '營造出真實的恐怖感',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn4_guide1_4': '過度營造出恐怖要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide': '語言要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_1': '輕微等級：<br/>滾開、閉嘴、超他媽X等',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_2': '限制等級：<br/>靠X、神經X、操他X、賤X等',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn5_guide_3': '過度等級：<br/>過讀表達不當言語，無法過濾髒話時',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide': '藥物要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_1': '輕微等級：<br/>吸菸、酒僅存在於背景（以圓點或漫畫方式呈現）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_2':
    '限制等級：<br/>使用者可喝酒、吸菸（使用者）<br/>只有極小動作或使用效果',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn6_guide_3': '直接等級：<br/>可使用酒、菸、毒品（使用者）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide': '犯罪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_1':
    '輕微等級：<br/>強盜、殺人要素單純存在於文本之中<br/>無行犯罪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_2': '限制等級：<br/>強盜、殺人要素以圖片或文本方式描寫',
  'studio.prj_prod_mngmt.rating_build_review.self_review.self_review_req.qtn7_guide_3': '直接等級：<br/>真實呈現出強盜、殺人、性犯罪要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_detail_pg_title': '審查資訊詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_btn': '提出異議',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg1':
    '已變更套用於欲申請異議之年齡分級的適用遊戲名稱、開發商名稱、代表類別。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.appeal_info_edited_popup_msg2': '請先修改進行內容修改申報。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.detailed_pg.next_btn': '繼續 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_title': '提出異議',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_detail_input': '填寫內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_qtn': '填寫問卷調查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_attch_doc': '附上審查資料',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating': '調整申請等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_place_holder': '選擇',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_rating_val_msg': '請選擇調整申請之等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_use_existed_info_chkbox': '使用先前的問卷內容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content': '請選擇遊戲包含的內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_sexuality': '煽情性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_gambling': '賭博性',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_lang': '語言',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_drug': '藥物',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_content_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_input': '提出異議事由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_reason_val_msg': '請填寫提出異議事由',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_next_btn': '繼續 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide': '提出異議',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide1': '如對審查完成的年齡分級有異議，可提出異議。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide2': '請選擇想調整的年齡分級以及遊戲含有的內容，並填寫提出異議事由。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide3': '如想使用先前問卷調查內容，請在相應的選框中打勾。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_guide4': '提出異議將以首次賦予的年齡分級為基準，每個商品只能提出1次。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_raise_title': '提出異議',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_btn': '申請審查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg1': '正在進行異議審查，<br/>無法變更商品資訊及企業資訊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_noti_popup_msg2': '提出異議與審查結果無關，<br/>僅能申請1次。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_cf_btn': '異議申請 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_done_popup_msg1':
    '已申請審查。<br/>預計須2～4個工作天。<br/>審查結果將透過電子郵件及「通知」進行通知。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide': '正在審查異議事項。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_req_under_review_guide_1': '預計最多需2～4個工作天。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_chk_req_detail_btn': '確認審查中資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_done_msg': '異議審查完畢。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_review_result': '{assignedRating}→{requestedRating}',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info': '最近審查完畢資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_guide':
    '此為尚未發布的預備年齡分級審查資訊。發布後將會更新為「年齡分級審查資訊」。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_msg': "異議審查申請已<span class='text-error'>退回</span>。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_reason_chk_btn': '查看退回原因',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_rejected_result': '退回',
  'email.appeal_review_result_noti.completed.title': '{prodName}審查完成',
  'email.appeal_review_result_noti.completed.msg_done': '{prodName}審查已完成。',
  'email.appeal_review_result_noti.completed.msg_assigned_rating': '基本等級：「{assignedRating}」',
  'email.appeal_review_result_noti.completed.msg_requested_rating': '申請等級：「{requestedRating}」',
  'email.appeal_review_result_noti.completed.msg_assigned_category': '目前分類內容：「{assignedCategory}」',
  'email.appeal_review_result_noti.completed.msg_requested_category': '申請分類內容：「{requestedCategory}」',
  'email.appeal_review_result_noti.rejected.title': '{prodName}審查退回',
  'email.appeal_review_result_noti.rejected.msg_rejected': '{prodName}審查已退回。',
  'email.appeal_review_result_noti.rejected.msg_assigned_rating': '基本等級：「{assignedRating}」',
  'email.appeal_review_result_noti.rejected.msg_requested_rating': '申請等級：「{requestedRating}」',
  'email.appeal_review_result_noti.rejected.msg_assigned_category': '目前分類內容：「{assignedCategory}」',
  'email.appeal_review_result_noti.rejected.msg_requested_category': '申請分類內容：「{requestedCategory}」',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_btn': '內容修改申報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.title': '內容修改申報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info': '遊戲基本資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_company': '開發商名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.basic_info_genre': '代表類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_info': '年齡分級審查資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_rating': '等級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_category': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1': '內容修改申報是什麼？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide1_1': '遊戲內容變更時，須申報修改何種內容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2': '申報修改範圍',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_1':
    '如為單純修正組建中的錯誤，無需進行內容修改申告，即可進行上市。<br/>如有變更與遊戲相關的內容或遊戲基本資訊，需附上審查資料說明變更之內容，並接受審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide2_2':
    '僅變更遊戲名稱、開發商名稱（創作者名稱）時，無須提出申報修改內容也會自動申報',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3': '填寫問卷調查',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_1':
    '如非變更與遊戲分類有關之內容（例如：暴力性、煽情性），則可直接套用回答先前問卷調查相應問題的內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.review_guide3_2': '但Studio負責人可額外確認變更事項與問卷調查內容是否一致。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id': '組建ID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_place_holder': '請選擇組建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.build_id_val_msg': '請選擇組建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info': '變更事項',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_guide': '如為單純修正錯誤，無需進行內容修改申告，即可進行上市。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_game_name': '更改遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_company': '更改開發商名稱（創作者名稱）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_genre': '更改主要類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_background': '變更背景、影片',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_sys_ui': '變更基本系統、UI',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_billing_sys': '變更課金制度',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_mission_scenario': '變更任務、劇情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_char_item': '變更角色、道具',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating': '變更國際機關年齡分級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.req_val_msg': '請至少選擇1個以上的變更事項。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_detail': '變更內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.use_existed_info_chkbox': '使用先前的問卷內容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_intl_rating_chkbox': '變更國際機關年齡分級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.next_btn': '繼續 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_type': '年齡分級類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_assigned_date': '等級分類日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif': '等級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_classif_detail': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_rating_reg_num': '等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_completed_info_build_id': '組建ID',
  'email.review_result_noti.change_update_completed.msg_1': '{prodname}內容修改申報已完成審查。 ',
  'email.review_result_noti.change_update_completed.msg_2': '可上市已完成審查的組建',
  'email.review_result_noti.change_update_rejected.msg_1': '{prodName}內容修改申告已退回。',
  'email.review_result_noti.change_update_rejected.reason_chk_guide': '如欲確認原因，請點擊[立即前往]。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.title': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.sub_title': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.place_holder': '請輸入等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_msg': '請輸入等級分類編號。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.allowed_char_msg': '僅能輸入數字、「-」及英文。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.add_btn': '新增',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_game_title': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_rating': '年齡分級',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_category': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_reg_num': '等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.rating_info_assigned_date': '等級分類日期',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.inquiry_failed_reg_num_not_existed': '不存在的資訊。<br/>請確認等級分類編號。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.failed_reg_num_limit': '每款遊戲最多可以增加2個等級。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.guide_1': '可直接輸入先前分配的韓國等級編號，並登錄為年齡分級。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_btn': '登錄',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed': '年齡分級資訊<br/>已登錄完畢。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.required_val_popup': '請新增一個以上的年齡分級資訊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb5': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed_guide': '已登錄完畢。<br/>現在可以發布遊戲了。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_guide': '所登錄的年齡分級已存在。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_guide':
    '重新登錄時，將透過自行審查處理，先前發布的使用等級將遭刪除。',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_edit_guide':
    '如有修改事項，<br/>請透過修改詳情進行修改。<br/>確定要重新登錄嗎？',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_8': '年齡分級詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_detailed_pg_title': '年齡分級詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic': '遊戲基本資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_company': '開發商名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_basic_genre': '代表類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz': '企業／負責人資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_country': '所在國家',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_type': '企業類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_name': '企業名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_reg_num': '商業登記編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_category': '製作／發行類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_biz_representative_name': '代表人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_name': '負責人姓名',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_email': '電子信箱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_contact': '聯絡方式',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_pic_guide':
    '由企業接收審查過程的負責人連絡方式。<br/>審查流程將告知GRAC STOVE審議分級負責人。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select': '選擇年齡分級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_self_review': 'GRAC（韓國）STOVE審議分級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_select_direct_input': '查詢韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg3': '先前年齡分級資訊可於「查看紀錄」中查看。',
  'studio.prj_prod_mngmt.rating_build_review.edit_done_msg': '年齡分級資訊已重新登錄。',
  'studio.prj_prod_mngmt.rating_build_review.rating_info_title': '年齡分級資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_monitoring_rating_adj_guide':
    "該遊戲經監測後，被分類為<span class='text-tint-red-a400 font-bold'>等級調整措施對象</span>，請確認詳情。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_see_detail_btn': '查看詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_3': '等級調整措施',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_title': '等級調整措施通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_rating': '調整等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_category': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_applied_date': '預計實施日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_reason': '調整原因',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accept_btn': '採納等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg1': '採納調整措施的等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_msg2': '在等級預計實施日期以前，無法進行使用等級及組建的審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_cf_msg': '已依等級調整措施，採納等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg1': '不採納等級，修改遊戲內容。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.reject_adj_change_msg2': '在審核完畢前，遊戲將暫停出現在商店中，無法販售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_guide_popup': '請在使用等級及組建審查選單中，<br/>完成內容修改申告。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_change_x': '個人／企業資訊正在審查中，<br/>審查完成後，即可進行內容修改申報。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide': '等級調整措施通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide1':
    '接受等級時，在等級預計實施日期以前，無法進行組建及等級審查的登錄。預計實施日起將套用變更後的等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_1': '修改內容後，直到內容審查完畢前，遊戲將暫停出現在商店中，無法販售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_guide2_2': '內容修改申報審查完畢後，<br/>Game即可重新登錄至上市計畫中並販售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_adj_accepted_guide':
    "已依照等級調整處置<span class='text-brand-primary font-bold'>接受處置內容</span>。{reclassifyDate}前無法申請新組建及等級審查。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change_required_guide':
    '須進行內容修改申報。直到審查完畢前，遊戲暫時不會出現，無法販售。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide':
    "該遊戲經監測後，被分類為<span class='text-tint-red-a400 font-bold'>職權重新分類對象</span>，請確認詳情。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_4': '職權重新分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_pg_title': '職權重新分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_title': '職權重新分類通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_cf_msg': '已依職權重新分類措施，採納等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_announce': '職權重新分類通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_1':
    '採納等級後，遊戲將暫停出現在商店中，且無法販售，直到等級實施預計日期止。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_2': '將於實施預計日期套用變更等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide1_3':
    '內容修改申報審查完畢後，Game即可以{rating}等級再次登錄至上市計畫並販售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_guide2':
    '修改內容後，直到內容審查完畢前，Game將暫停出現在Store中，無法販售。<br/>內容修改申報審查完畢後，<br/>Game即可再次登錄至上市計畫並販售。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_accepted_guide':
    "已依職權重新分類措施<span class='text-brand-primary font-bold'>採納調整內容</span>。至{date}前，遊戲暫停顯示，且無法販售。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.adj_adj_see_detail_btn': '查看詳情',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_report_change_required_guide':
    '須進行內容修改申報。直到審查完畢前，遊戲暫時不會出現，無法販售。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.auth_adj_teenager_x_info_reg_guide':
    '透過職權重新分類評定為青少年不可遊玩的遊戲。請登錄GRAC（遊戲管理委員會）審查後評定的等級分類資訊。',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg2': '遊戲已經上市時，將在之後套用修正後的內容。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide':
    "該Game經監測後，被分類為<span class='text-tint-red-a400 font-bold'>等級取消對象</span>。Game將停止顯示，且無法進行販售及執行。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_5': '取消等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_pg_title': '取消等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_title': '等級取消通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_detail': '申辯內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_btn': '申請申辯 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_appeal_req_done_popup': '已申請申辯。<br/>確認申辯須3～4個工作天。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide_title': '等級取消通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_1': '年齡分級已取消。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_2': '如不申請申辯，將於實施預計日期取消等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_cancel_guide1_3': '實施預計日期後，將暫停遊戲顯示、販售、遊玩。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide':
    "該Game經監測後，被分類為<span class='text-tint-red-a400 font-bold'>等級拒絕對象</span>。Game將停止顯示，且無法進行販售及執行。",
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_6': '拒絕等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_pg_title': '拒絕等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_title': '等級拒絕通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_detail': '申辯內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_announce': '等級拒絕通知',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_1': '年齡分級遭拒。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_2': '如不申請申辯，將於實施預計日期拒絕等級。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_guide1_3': '實施預計日期後，將暫停遊戲顯示、販售、遊玩。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.breadcrumb4_7': '查看歷史紀錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history_pg_title': '查看歷史紀錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.report_change_approved': '內容修改申報（批准）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_latest_order': '依最新排序',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case1_approved_title': '登錄（批准）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_a': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_b': '年齡分級類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_c': '等級分類日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_d': '等級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_e': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_f': '等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_h': '國際等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case2_rejected_title': '登錄（退回）案例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_g': '組建ID',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_i': '原因',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case3_registered_title': '登錄案例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case4_edit_title': '修改案例',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case5_change_approved_title': '內容修改申報（核准）',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_j': '變更事項',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case6_change_rejected_title': '內容修改申告 - 退回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case7_rating_adj_title': '調整等級',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.sub_info_k': '實施日 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case8_auth_adj_title': '職權重新分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case9_rating_cancelled_title': '等級取消',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.case10_rating_rejected_title': '等級拒絕 ',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_title': '最近審查完畢資訊',
  'studio.prj_prod_mngmt.rating_build_review.latest_review_req_info_guide':
    '此為尚未發布的預備年齡分級審查資訊。發布後將會更新為「年齡分級審查資訊」。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_prod_name': '遊戲名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_company': '開發商名稱',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_genre': '代表類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_type': '年齡分級類別',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_assigned_date': '等級分類日期',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif': '等級分類',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_classif_detail': '包含內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_reg_num': '等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_info_build_id': '組建ID',
  'studio.prj_prod_mngmt.rating_build_review.rating_review_info_title': '年齡分級審查資訊',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb1': '管理專案‧商品 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb2': '{prodName}',
  'studio.prj_prod.this_prod.prod_mgmt_price_breadcrumb3': '商品頁面',
  'studio.prj_prod.this_prod.prod_mgmt_price_title': '價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_btn': '登錄',
  'studio.prj_prod.this_prod.prod_mgmt_price_landing_guide1': '請登錄商品的販售價格。<br/>可直接輸入各幣別的價格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_x_under_review_pop_msg1': '有價格資訊正處於審查狀態。<br/>取消或刪除後即可修改。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_title': '登錄價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_title': '販售類型',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_paid_msg': '免費',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_sales_type_free_msg': '付費',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_title': '基準販售價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_required_val_msg': '請設定基準販售價格。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_base_price_msg': '請選擇或輸入美金（USD）價格。套用至先前販賣價格後，即可直接修改各貨幣價格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_btn': '直接輸入',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1': '為什麼商店顯示價格和支付價格幣值不同？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide1_1':
    '實際支付時，全球將以USD($)支付，韓國則以KRW(￦)支付。商店顯示價格將依據每日匯率改變，僅供參考。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2': '是否有可適用之價格輸入條件？',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_guide2_1': '美元可輸入USD0.99以上的價格，KRW則可輸入10以上的價格，輸入時僅能以10為單位增加。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_title': '輸入價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_apply_btn': '套用',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_title': '各貨幣價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_header1': '商店顯示價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_checkout_price_header2': '支付價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_usd_msg': '美國 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_krw_msg': '韓國 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_cny_msg': '中國 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_eur_msg': '歐盟 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_gbp_msg': '英國 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_hkd_msg': '香港 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_idr_msg': '印尼 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_jpy_msg': '日本 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_myr_msg': '馬來西亞 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_php_msg': '菲律賓 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_sgd_msg': '新加坡 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_thb_msg': '泰國',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_displayed_price_vnd_msg': '越南 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg1': '請輸入基準價格後套用。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_regional_prices_required_val_msg2': '有尚未輸入的項目，請確認幣別的交易價格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg2': '交易價格僅能輸入數字和「.」。',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_btn': '修改',
  'studio.prj_prod.this_prod.prod_mgmt_price_msg1': '商品發布後將適用下列價格。',
  'studio.breadcrumb.price_edit': '修改價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_title': '修改價格',
  'studio.prj_prod.this_prod.prod_mgmt_price_ msg0': '審查中',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_msg': '套用至LIVE',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_from_msg': '{dateTime}套用',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_msg':
    '修改價格須進行審查流程。<br/>審查最多須5個工作天，<br/>修改後的價格通過審查後，將立刻套用。 ',
  'studio.prj_prod.this_prod.prod_mgmt_price_edit_adjust_live_price_pop_review_req_btn': '申請審查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg1': '申請審查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_msg2': '審查通過後立刻套用',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_msg': '確定要取消審查嗎？<br/>取消後，審查中的數據將遭刪除。',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_awaiting_review_cancel_pop_withdraw_review_btn': '取消審查',
  'studio.prj_prod.this_prod.prod_mgmt_price_active_in_review_msg1': '審查中',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_msg': '審查退回',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_review_timestamp_msg': '{dateTime}退回',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_btn': '刪除',
  'studio.prj_prod.this_prod.prod_mgmt_price_declined_reason_guide': '退回原因',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_msg': '確定要刪除處於審查退回狀態的價格嗎？',
  'studio.prj_prod.this_prod.prod_mgmt_price_delete_pop_delete_btn': '刪除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_title': '折扣',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_btn': '登錄',
  'studio.prj_prod.this_prod.prod_mgmt_discount_landing_guide1':
    '可針對幾個商品新增折扣。<br/>將以[販售價格]所輸入的價格為基準計算折扣。<br/>亦可進行限定數量折扣販售。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_title': '登錄折扣',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_title': '折扣名稱',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_place_holder': '請輸入折扣名稱',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_name_required_val_msg1': '請輸入折扣名稱。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_title': '起始日',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_immed_apply': '立刻',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_start_date_schedule_apply': '預約',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_title': '結束日',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_dup_period_val_msg1': '該期限內已有重複折扣。請變更期限後重試。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_reset_time_val_msg2': '請將預約日期請設定為目前日期以後。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_end_date_invalid_val_msg3': '請將結束日期設定為開始日期後。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_title': '折扣率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_req_val_msg1': '請輸入折扣率。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discount_rate_valid_num_val_msg2': '折扣率為0到100之間。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1': '折扣名稱是什麼？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide1_1': '此名稱為用以區分折扣，不會顯示給使用者看。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2': '折扣率如何計算？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide2_1': '折扣期間，將會以販售價格計算折扣率。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3': '使用限定數量折扣販售會發生什麼事情？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_guide3_1':
    '當設定限定數量折扣販售時，販售數量賣完後暫停，將停止以折扣價格販售。<br/>就算販售數量尚未賣完，到折扣結束日期那天，折扣仍會結束。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_title': '折扣適用價格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_msg':
    '以下價格是以目前販售價格為基準計算，販售價格變更時，折扣價格也會產生變化。<br/>商店中顯示的價格將依匯率不同有所變化。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_displayed_price_header1': '商店顯示價格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_checkout_price_header2': '支付價格',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_guide': '當價格設定為免費時，仍會以免費價格顯示，不受折扣率影響。 ',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_discounted_price_free_msg': '付費',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_title': '限定數量折扣販售',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_enable_msg': '使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_disable_msg': '不使用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_title': '限定販售數量',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_unit_msg': '個',
  'studio.prj_prod.this_prod.prod_mgmt_discount_register_limited_sales_quantity_valid_num_val_msg': '數量應介於1至9,999,999之間。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_header1': '狀態',
  'studio.prj_prod.this_prod.prod_mgmt_discount_name_header2': '折扣名稱',
  'studio.prj_prod.this_prod.prod_mgmt_discount_discount_rate_header3': '折扣率',
  'studio.prj_prod.this_prod.prod_mgmt_discount_remaining_quantity_header4': '剩餘數量',
  'studio.prj_prod.this_prod.prod_mgmt_discount_period_header5': '期間',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_btn': '刪除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_btn': '暫停',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_upcoming_msg': '預計套用',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_active_msg': '套用至LIVE',
  'studio.prj_prod.this_prod.prod_mgmt_discount_status_expired_msg': '結束',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg1': '停止折扣',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_msg2': '如欲停止，請輸入「SUSPEND」，<br/>停止後將無法復原。',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_suspend_pop_withdraw_btn': '暫停',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_msg': '確定要刪除預計套用的折扣嗎？',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_delete_pop_delete_btn': '刪除',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_all_msg': '全部',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_active_or_upcoming_msg': '套用／預計套用至LIVE',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_expired_msg': '結束',
  'studio.prj_prod.this_prod.prod_mgmt_discount_list_filter_no_data': '無符合所選條件的結果。',
  'studio.breadcrumb.discount_details': '折扣詳情',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_title': '折扣詳情',
  'studio.prj_prod.this_prod.prod_mgmt_discount_this_discount_details_limited_sales_remaining_quantity_msg': '（剩餘數量：{remainingNum}個）',
  'studio.prj_prod.this_prod.home_release_status': 'Studio商品上市現況',
  'studio.prj_prod.this_prod.home_release_status_msg1': '發布商品，發布後如有更新，請確認進行現況。',
  'studio.prj_prod.this_prod.home_release_status_msg2': '發布後，請立刻或預約更新各功能。 ',
  'studio.prj_prod.this_prod.home_release_btn': '發布',
  'studio.prj_prod.this_prod.home_guide1': '請準備<br/>商品頁面。',
  'studio.prj_prod.this_prod.home_guide1_1': '已輸入商品設定和商品頁面，請先發布商品頁面。',
  'studio.prj_prod.this_prod.home_guide2': '和組建一同<br/>上市。',
  'studio.prj_prod.this_prod.home_guide2_1': '請按照預購、搶先體驗等上市計畫開放商品頁面並正式將組建上市。',
  'studio.prj_prod.this_prod.home_guide3': '發布後，<br/>即可輕鬆進行更新。',
  'studio.prj_prod.this_prod.home_guide3_1': '選擇須套用的項目即可輕鬆更新，<br/>可立即或預約套用各功能之修改內容。',
  'studio.prj_prod.this_prod.home_release_status_timezone': 'Studio商品上市現況(UTC+9)',
  'studio.prj_prod.this_prod.home_prod_page_title': '商品頁面',
  'studio.prj_prod.this_prod.home_build_title': '組建',
  'studio.prj_prod.this_prod.home_build_msg1': '正式上市時，將會顯示組建狀態。',
  'studio.prj_prod.this_prod.home_sales_title': '價格（折扣率）及折扣',
  'studio.prj_prod.this_prod.home_sales_msg': '正式上市時，將會顯示售價。',
  'studio.prj_prod.this_prod.home_review_progress_title': '審查及套用至LIVE',
  'studio.prj_prod.this_prod.home_review_progress_tooltip_msg':
    '申請審查時，將會顯示申請審查、審查中、審查完畢、審查退回狀態，<br/>上市後，各功能更新時，將顯示適用日期。',
  'studio.prj_prod.this_prod.home_review_progress_stt1': '申請審查',
  'studio.prj_prod.this_prod.home_review_progress_stt2': '審查中',
  'studio.prj_prod.this_prod.home_review_progress_stt3': '審查完畢',
  'studio.prj_prod.this_prod.home_review_progress_stt4': '審查遭駁回',
  'studio.prj_prod.this_prod.home_release_stt_title': '發布狀態',
  'studio.prj_prod.this_prod.home_release_stt_tooltip_msg':
    '若只開啟商品頁面，則顯示「商品頁面開放」；<br/>若正式上市，則顯示「預購」、「預計發布」、「正式發布」。<br/>若為限制狀態，則會顯示圖示，請確認狀態。',
  'studio.prj_prod.this_prod.home_pre_release_guide': '根據上市計畫，將會顯示狀態。',
  'studio.prj_prod.this_prod.home_release_stt_chk_btn': '商品發布現況',
  'studio.prj_prod.this_prod.home_apply_stt1': '預計套用',
  'studio.prj_prod.this_prod.home_apply_stt2': '套用至LIVE',
  'studio.prj_prod.this_prod.stt_restriction_display_operator': '展示懲處（營運人員）',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_y': '套用至商品頁面LIVE',
  'studio.prj_prod.this_prod.stt_prod_pg_go_live_n': '套用至商品設定LIVE',
  'studio.prj_prod.this_prod.stt_community_go_live_y': '未套用社群LIVE',
  'studio.prj_prod.this_prod.stt_community_go_live_n': '套用社群LIVE',
  'studio.prj_prod.this_prod.stt_discount_go_live_y': '套用至折扣LIVE',
  'studio.prj_prod.this_prod.stt_discount_go_live_n': '套用至執行設定LIVE',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_y': '套用至遊戲內商店LIVE',
  'studio.prj_prod.this_prod.stt_ingame_store_go_live_n': '未套用至遊戲內商店LIVE',
  'studio.prj_prod.this_prod.stt_term_go_live_y': '套用至商品條款LIVE',
  'studio.prj_prod.this_prod.stt_term_go_live_n': '未套用至商品條款LIVE',
  'studio.prj_prod.this_prod.stt_achievement_go_live_y': '套用至挑戰課題LIVE',
  'studio.prj_prod.this_prod.stt_achievement_go_live_n': '未套用至挑戰課題LIVE',
  'studio.prj_prod.this_prod.stt_ranking_go_live_y': '套用至排名LIVE',
  'studio.prj_prod.this_prod.stt_ranking_go_live_n': '未套用至排名LIVE',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_y': '套用至雲端儲存LIVE',
  'studio.prj_prod.this_prod.stt_cloud_saving_go_live_n': '未套用至雲端儲存LIVE',
  'studio.prj_prod.this_prod.stt_match_making_go_live_y': '套用至LIVE配對',
  'studio.prj_prod.this_prod.stt_match_making_go_live_n': '未套用至LIVE配對',
  'studio.prj_prod.this_prod.release_stt_browser_title': 'Studio商品上市現況',
  'studio.prj_prod.this_prod.release_stt_title': 'Studio商品上市現況',
  'studio.prj_prod.this_prod.release_stt_msg': '如發布商品或為更新預約時，日曆上就會顯示現況。可依據登錄項目查看詳細資訊及狀態。',
  'studio.prj_prod.this_prod.release_stt_browser_release_btn': '發布',
  'studio.prj_prod.this_prod.release_stt_calendar_today_btn': '今天',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_all': '全部',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_prod_page': '商品頁面',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_build': '組建及使用等級',
  'studio.prj_prod.this_prod.release_stt_filter_cbox_price_and_discounts': '價格及折扣',
  'studio.prj_prod.status_review_requested': '申請審查',
  'studio.prj_prod.status_review_declined': '審查遭駁回／懲處',
  'studio.prj_prod.status_live': '套用至LIVE',
  'studio.prj_prod.status_suspend_or_deleted': '停止／刪除',
  'studio.prj_prod.this_prod.release_stt_calendar_event_date': '{eventDate}日',
  'studio.prj_prod.this_prod.release_stt_calendar_event_msg': '無商品紀錄',
  'studio.prj_prod.this_prod.release_stt_event_list_ex_msg': '無商品紀錄',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_request_review_btn': '申請審查',
  'studio.prj_prod.this_prod.release_details_pbar_msg1': '正在準備發布中',
  'studio.prj_prod.this_prod.release_details_pbar_prep_completed': '已準備好發布，請申請審查。',
  'studio.prj_prod.this_prod.review_status_pbar_under_review': '營運人員正在審查中，最多可能需要5天。',
  'studio.prj_prod.this_prod.release_details_pbar_rejected': '遭駁回，請確認項目後再申請審查。',
  'studio.prj_prod.this_prod.review_status_pbar_msg5': '已審查完畢，正在等待發布。',
  'studio.prj_prod.this_prod.release_stt_pbar_msg6': '商品已發布，套用LIVE中。',
  'studio.prj_prod.this_prod.release_stt_pbar_release_terminated': '發布暫停。可重新發布或刪除發布。',
  'studio.prj_prod.this_prod.release_details_page_only_title': '只開啟商品頁面。',
  'studio.prj_prod.this_prod.release_details_page_only_msg': '提前曝光、宣傳即將發布的商品，透過社群與使用者溝通。',
  'studio.prj_prod.this_prod.release_details_with_build_msg': '發布所需內容都準備完畢了嗎ˊ？可制定預約發布、搶先體驗等計畫並販售商品。',
  'studio.prj_prod.this_prod.release_details_product_page_info_title': '準備商品頁面',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_title': '設定商品',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_msg1':
    '請確認商品資本資訊（商品名稱、開發商名稱、發行商名稱）、類別、商品類型是否均已填寫。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_complete_msg': '已輸入所有商品設定。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_setting_missing_msg': '無設置商品設定',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_title': '商品頁面',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_msg': '只有輸入所有必要項目的商品頁面會顯示在清單中。',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_dbox_default_msg': '請選擇商品頁面',
  'studio.prj_prod.this_prod.release_details_product_page_preview_dir_btn': '預覽',
  'studio.prj_prod.this_prod.release_details_product_page_option_title': '商品頁面選項',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_title': '商店社群',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg1': '即便尚未註冊社群，也會在開啟商品頁面後自動註冊社群。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_mgmt_dir_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg2':
    '商品頁面開放後，社群將自動創建。<br/>如果希望將社群與其他商品合併，請在群組首頁 > 商店社群選單中進行整合設置。',
  'studio.prj_prod.this_prod.release_details_release_plan_title': '發布計畫',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_title': '開放商品頁面',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_date_title': '商品頁面開放日',
  'studio.timezone_preview_view_btn': '顯示主要城市UTC',
  'studio.timezone_preview_pop_title': '主要城市UTC',
  'studio.timezone_preview_pop_seoul': '首爾',
  'studio.timezone_preview_pop_tokyo': '東京',
  'studio.timezone_preview_pop_beijing': '北京 ',
  'studio.timezone_preview_pop_taipei': '臺北',
  'studio.timezone_preview_pop_london': '倫敦',
  'studio.timezone_preview_pop_nyc': '紐約',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_title': '發布資訊',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_msg': '將依設定順序依序套用至商店並發布。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_current_status_msg': '現在（發布前）',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_this_status_msg': '開放商品頁面',
  'studio.prj_prod.this_prod.release_details_release_form_confirmation': '以設定資訊發布。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg1': '各功能中設定的數據與發布資訊不符。 ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_info_mismatch_msg2': '請確認項目後，點擊重新整理。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg1': '審查中不得修改或刪除發布時所填寫之資訊。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_msg2': 'STOVE營運人員審查約需1～5天。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item_title': '審查項目',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item1': '設定商品',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item2': '商品頁面 ',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item3': '發布計畫',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_manual_release_select_msg': '審查完成後，可以調整設定的排程立刻上市。',
  'studio.prj_prod.this_prod.release_details_browser_request_review_request_review_alert_msg': '已申請審查。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_btn': '取消申請審查',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg1': '確定要取消審查嗎？',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_pop_msg2': '取消後，重新審查約需1～5天。',
  'studio.common.popup_case_close_btn': '關閉',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg1': '已取消審查。',
  'studio.prj_prod.this_prod.release_details_browser_withdraw_review_request_msg2': '請確認審查所需項目後重新申請審查。',
  'studio.prj_prod.this_prod.release_stt_browser_product_release_info_btn': '商品發布資訊',
  'studio.noti.review_req_for_release.completed_msg':
    '已申請{prodName}（{prodNo}）商品上市審查。<br/>STOVE營運人員即將進行審查。審查最長須七個工作天，審查中不得修改商品資訊。',
  'studio.mail.case_review_request.title': '申請審查',
  'studio.mail.case_review_request.mail_content': '已完成發布之審查申請。',
  'studio.prj_prod.prod_release_info_pg_dir_btn': '商品發布資訊',
  'studio.mail.case_in_review.title': '審查中',
  'studio.mail.case_in_review.content_msg1': 'STOVE營運人員正在進行審查。',
  'studio.mail.case_in_review.content_msg2': '審查中不得修改商品資訊。',
  'studio.mail.review_status_in_review_detail_msg3': '※Studio審查完畢後，商品頁面將根據上市日期開放，屆時即可販售商品。',
  'studio.mail.review_status_in_review_detail_msg4': '審查最長須一週，審查中不得修改商品資訊或申請審查。',
  'studio.noti.review_req_rejected_msg': '{prodName}({prodNo})審查申請遭駁回。<br/>請確認駁回原因後重新申請審查。',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_1': '遭駁回。',
  'studio.prj_prod.this_prod.review_status_pbar_msg4_2': '確認項目並修改後，請點擊重新整理按鈕並申請審查。',
  'studio.prj_prod.release_info_checklist_stt_incompleted': '未完成',
  'studio.prj_prod.this_prod.release_details_rejection_criteria_msg': '駁回原因',
  'studio.mail.case_review_rejected.title': '審查遭駁回',
  'studio.mail.case_review_rejected.content_msg1': 'STOVE營運人員已審查完畢。',
  'studio.mail.case_review_rejected.content_msg2': '商品發布遭駁回，請於商品發布現況中確認原因後再次申請審查。',
  'studio.prj_prod.this_prod.popup_product_page_change_saved_msg': '已反映發布資訊。',
  'studio.mail.case_review_completed.title': '審查完畢',
  'studio.mail.case_review_completed.content_msg1': 'STOVE營運人員已審查完畢。',
  'studio.mail.case_review_completed.content_msg2': '將依發布時間於商店中開放商品頁面。',
  'studio.mail.case_review_completed.content_msg3': '設定為手動發布的商品，請於確認商品發布現況後進行發布。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_btn': '手動套用LIVE',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_title': '套用至LIVE',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_pop_msg': '如欲套用至商品頁面，請輸入「RELEASE」。 ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg1': '恭喜！ ',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg2': '已開放商品頁面。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_msg3': '請於商店查看商品頁面。',
  'studio.prj_prod.this_prod.release_stt_calendarview_manual_release_apply_pop_redirect_store_btn': '前往商店',
  'studio.prj_prod.this_prod.home_release_stt_browser_manual_release_btn': '手動套用LIVE',
  'studio.noti.prod_pg_opened_msg': '恭喜您!<br/>{prodName}（{prodNo}）的商品頁面開放了。',
  'studio.prj_prod.this_prod.release_stt_calendarview_store_dir_btn': '前往商店',
  'studio.prj_prod.this_prod.release_stt_calendarview_community_dir_btn': '社群',
  'studio.mail.case_release_notice.title': '發布通知',
  'studio.mail.case_release_notice.content_msg1': '恭喜。',
  'studio.mail.case_release_notice.content_msg2': '已於STOVE商店中開放商品頁面。 ',
  'studio.mail.redirect_product_page_btn': '前往商店商品頁面',
  'studio.prod_home.release_info_open_suspend_btn': '停止開放商品頁面',
  'studio.prod_home.popup_prod_pg_open_suspend_msg1': '停止開放商品頁面時，即可刪除商品，商店也會自動取消顯示該商品。 ',
  'studio.prod_home.popup_prod_pg_open_suspend_msg2': '確定要停止開放商品頁面嗎？',
  'studio.prod_home.popup_prod_pg_open_suspend_cf_btn': '暫停開啟',
  'studio.prod_home.prod_pg_reopen_btn': '恢復開放商品頁面',
  'studio.prod_home.popup_prod_pg_reopen_msg1': '確定要再次變更為公開狀態嗎？',
  'studio.prod_home.popup_prod_pg_reopen_msg2': '將於商店中開放商品頁面。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_only': '商品頁面停止開放。可重新開放或將其從專案及商品管理中刪除。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide.case_prod_pg_build': '已暫停販售。可重新恢復販售或將其從專案及商品管理中刪除。',
  'studio.prod_home.release_info_sale_suspend_btn': '停售',
  'studio.prod_home.popup_release_info_sale_suspend_msg1': '確定要站提販售嗎？',
  'studio.prod_home.popup_release_info_sale_suspend_msg2': '將於商店中顯示為暫停販售的狀態。',
  'studio.prod_home.release_info_restart_sale_btn': '恢復販售',
  'studio.prj_prod.this_prod.del_req_rejected_reason_1':
    "上市後，有關停止開放商品頁面之內容，可事先與營運人員商議後刪除。<br/>請透過電子信箱（stoveindie{'@'}smilegate.com）諮詢相關事宜。",
  'studio.prj_prod.this_prod.del_req_rejected_reason_2':
    "發布後，須先事先告知顧客其曾購買過的商品停止販售、協議結算及取消合約等事宜後，方可刪除。<br/>請透過電子信箱（(stoveindie{'@'}smilegate.com）諮詢。",
  'studio.prj_prod.release_info_official_release_date_input_n': '未輸入',
  'studio.prj_prod.this_prod.release_details_product_page_guide':
    '可從輸入所有必要項目的商品頁面中選擇。設定發布日時，可將審查時間考慮進去，設定為一週後。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_title': '搶先體驗字句',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_msg': '告知使用者此為尚未完成商品的功能',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_preview_btn': '預覽',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_content_place_holder': '未設定搶先體驗字句。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_title': '設定期間',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_msg': '「搶先體驗」的文句可以在正式發布後自由設置並顯示。',
  'studio.release_details.period_settings.start_date_before_open_val_msg2': '請將開始日期設定為商品頁面開放日後。',
  'studio.prj_prod.this_prod.release_details_build_title': '準備組建',
  'studio.prj_prod.this_prod.release_details_build_execution_title': '執行設定',
  'studio.prj_prod.this_prod.release_details_build_execution_msg': '請於上傳組建後，請進行設定以利在STOVE PC客戶端上執行組建。',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder2': '已輸入所有執行設定。',
  'studio.prj_prod.this_prod.release_details_build_execution_place_holder1': '尚無執行設定。',
  'studio.prj_prod.this_prod.release_details_build_execution_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_title': '組建管理及使用等級',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg1':
    '請選擇欲進行上市的組建。組建列表將依照最近完成使用等級審查之組建的順序來顯示。',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_msg2':
    '如列表中未顯示組建，請在組建管理中進行上傳後再確認是否已接受使用等級審查。',
  'studio.prj_prod.build_mgmt_pg_dir_btn': '組建管理',
  'studio.prj_prod.rating_build_review_pg_dir_btn': '使用等級及組建審查',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_place_holder': '請選擇要上市的組建',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review_build_dbox_required_val': '請選擇要上市的組建',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.self_review_expected_rating_guide':
    '等級審查已完成，預備等級為（{expectedRating}），正式上市後將反映。 ',
  'studio.prj_prod.this_prod.release_details_studio_support_title': '設定遊戲支援服務',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_title': '遊戲內商店 ',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_msg':
    '可於遊戲內生成道具販售給使用者的功能。啟用遊戲內商店時，請務必設定商品條款 > 服務使用及付款前ˊ注意事項。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_shop_name_msg': '商店名稱',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_quantity_msg': '商品數量',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_server_hosting_msg': '有無遊戲伺服器',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_place_holder': '尚未登錄遊戲內商店',
  'studio.prj_prod.this_prod.release_details_build_and_rating_review.rating_none_guide': '尚未獲得年齡分級。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_title': '商品條款',
  'studio.prj_prod.this_prod.release_details_studio_support_term_msg': '發布商品時，須符合條款才能發布。請先於設定商品條款中建立條款後套用。',
  'studio.prj_prod.this_prod.release_details_studio_support_no_term_msg': '尚未登錄商品條款。',
  'studio.prj_prod.this_prod.release_details_studio_support_term_category': '條款類別',
  'studio.prj_prod.this_prod.release_details_studio_support_term_name': '條款管理名稱',
  'studio.prj_prod.this_prod.release_details_studio_support_term_version': '版本',
  'studio.prj_prod.this_prod.release_details_studio_support_term_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_title': '挑戰課題',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_msg':
    '可與遊戲數據連動創造挑戰課題，可顯示及套用於商品頁面。與SDK連動後，挑戰課題須登錄及設定後才能套用。',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_registered_challenges_msg': '挑戰課題登錄個數',
  'studio.prj_prod.this_prod.release_details_studio_support_achievements_place_holder': '尚未登錄挑戰課題。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_title': '排名',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_msg':
    '使用者依據統計數據所達成的排名可顯示及套用於商品頁面。與SDK連動後，須登錄及設定排名後才能套用。',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_registered_ranking_to_total_number_msg': '排名登錄個數',
  'studio.prj_prod.this_prod.release_details_studio_support_ranking_place_holder': '尚未登錄排名。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_title': '雲端儲存',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_msg':
    '可將使用者遊戲數據檔案套用至雲端伺服器的功能。與SDK連動後，請設定是否須套用至雲端儲存。',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_location_msg': '安全檔案儲存路徑',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_info_msg': '安全檔案資訊',
  'studio.prj_prod.this_prod.release_details_studio_support_cloud_savefile_place_holder': '尚未設定雲端儲存。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_title': '配對',
  'studio.prj_prod.this_prod.release_details_studio_support_match_msg': '支持使用者遊玩時維持較低網路PING的功能，須與SDK連動後才能啟用。 ',
  'studio.prj_prod.this_prod.release_details_studio_support_match_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_intergrated_msg': '配對已連動。',
  'studio.prj_prod.this_prod.release_details_studio_support_match_status_not_prepared_msg': '未設定配對連動。',
  'studio.prj_prod.this_prod.release_details_sales_setting_title': '設定銷售',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_title': '設定價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_msg': '請確認登錄的販售價格。當輸入的價格不同時，請於價格頁面修改。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_redirect_btn': '立刻查看',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_msg': '販售類型',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_free': '付費',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_case_free_place_holder': '尚未設定價格。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_sales_type_this_type_paid': '免費',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_price_msg': '售價',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_title': '設定發布折扣',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_msg': '如需於發布時打折，請設定折扣。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_radio_disable_msg': '不使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_title': '折扣期間',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_msg': '自正式發布日起',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_in_days_msg': '天內',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate_title': '折扣率',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_title': '折扣適用價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg1':
    '以下價格是以目前販售價格為基準計算，販售價格變更時，折扣價格也會產生變化。 ',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_msg2':
    '商店中顯示的價格將依匯率不同有所變化。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_btn':
    '確認各國販售價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_displayed_price_header1': '商店顯示價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_checkout_price_header2': '支付價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_discounted_price_regional_price_pop_title': '各國價格',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_title': '設定限定販售',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_msg': '正式發布後，將於販售數量賣完或期間結束時停止販售。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_volume_msg': '販售數量賣完後暫停',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_sales_by_period_msg': '期間結束時停止',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_radio_deactivated_msg': '不使用',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_title': '設定販售數量',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_quantity_limit_counting_unit_ko': '個',
  'studio.release_info_setting.limited_sales_quantity_required_msg': '請輸入販售數量。',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_setting': '設定結束日期',
  'studio.prj_prod.this_prod.release_details_sales_setting_limited_sales_setting_period_input_n_val_msg': '請設定結束日期。 ',
  'studio.prj_prod.this_prod.release_details_pur_cond_title': '購買選項',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_title': '設定購買條件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg1': '適用於購買目前發布商品前須購買其他商品的條件。 ',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_msg2': '增加設定於購買條件中的商品清單。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_title': '條件類別',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_and': 'AND條件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_cond_type_this_type_or': 'OR條件',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_place_holder': '尚未設定購買條件。',
  'studio.prj_prod.this_prod.release_details_pur_cond_setting_redirect_btn': '立即前往',
  'studio.prj_prod.this_prod.release_details_plan_title': '發布計畫',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_title': '開放商品頁面',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_msg': '商品頁面的開放日期可以考慮到審核期，最早設置在一週後。',
  'studio.prj_prod.this_prod.release_details_plan_product_page_open_date_title': '商品頁面開放日',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_title': '設定預購',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_msg':
    '若想在正式發布前提前販售，可設定預售。亦可設定預購使用者的下載、安裝及執行選項。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_enable_msg': '使用',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_radio_disable_msg': '不使用',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_title': '設定正式發布日期',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_msg':
    '如尚未確定正式發布日期，請設定要顯示予使用者的選項。發布 전 언제든지 자유롭게 변경할 수 있어요.',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option': '顯示選項',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt1_upcoming': '預計發布',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_option_dbox_opt4_quarter': '{relYear} 第{quarter}季',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_title': '正式發布日期',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_title': '設定期間',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_input_n_val_msg1': '請選擇結束日期。 ',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_schedule_setting_end_date_after_official_release_val_msg2':
    '請將結束日期設為正式上市的日期以前。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_title': '下載及安裝',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_allow': '允許',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_download_and_installation_not_allow': '不允許',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_title': '執行',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_all': '全部允許',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_stove_mem_no': '登錄STOVE會員編號',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_stove_mem_no_reg_tooltip':
    '登入STOVE後，從我的資訊 > 會員編號確認會員編號，並登錄至模板後，只有獲得許可的使用者才可執行。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_allow_by_ip_address': '登錄IP地址',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_ip_address_reg_tooltip':
    '只有登錄於模板的IP地址的使用者才可執行遊戲。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_not_allow': '不允許',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_placeholder': '請下載模板後上傳。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_file_upload_btn': '上傳',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert1': '上傳失敗。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_mem_no':
    '{memNo} 有誤。請修改後重新上傳。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_alert2_case_ip_address':
    '{ipAddress} 有誤。請修改後重新上傳。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_input_value':
    '上傳失敗：Excel檔案中含有不支援的文字形式，請確認檔案。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_over_1000':
    '上傳失敗：支援人數超過1000人，請減少人員後重試。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_upload_failed_case_invalid_format':
    '上傳失敗：無效的檔案格式。請使用支援的檔案格式。',
  'studio.prj_prod.this_prod.release_details_plan_early_access_setting_execution_reg_template_download_btn': '下載模板',
  'studio.file_excel_whitelist_sheet1_guide_header2': '指南(Guide)',
  'studio.file_excel_whitelist_sheet1_introduction':
    '請輸入加入STOVE的會員編號，<br/>上限為1,000人。<br/>Please enter STOVE membership number.<br/>You can enter up to 1,000 Users.',
  'studio.file_excel_whitelist_sheet2_introduction':
    '請輸入允許遊玩的IP地址，<br/>上限為1,000人。<br/>Please enter your IP address. You can enter up to 1,000 Users.',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_view_guide': '請確認登錄資訊。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_present': '現在（發布前）',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_prod_pg_open': '開放商品頁面',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_early_access_display_on': '顯示搶先體驗字句',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_end_date_invalid_val_msg1': '不能將結束日期設於正式發布日期後。',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_pre_order': '預購',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_official_release': '正式發布',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount': '發布折扣',
  'studio.prj_prod.this_prod.release_details_release_plan_release_timeline_discount_start_date_invalid_val_msg':
    '發布折扣開始日期須依據正式發布日期設定。',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg1': '除了商品頁面的相關資訊，至今輸入的資訊皆會重置。 ',
  'studio.prj_prod.this_prod.release_details_opt_switch.prod_pg_release_only_popup_msg2': '確定要變更為只開放商品頁面嗎？',
  'studio.common.popup_case_change_btn': '變更',
  'studio.prj_prod.release_info_checklist_stt_completed': '審查完畢',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item4': '執行設定',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item5': '組建管理及使用等級',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item6': '設定價格',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item7': '發布折扣',
  'studio.prj_prod.this_prod.release_details_browser_request_review_pop_review_item8': '設定販售數量',
  'studio.home.release_timeline.prod_pg_item.community_open': '開啟社群',
  'studio.home.release_timeline.prod_pg_item.community_early_access': '搶先體驗',
  'studio.home.release_timeline.prod_pg_item.community_ingame_store': '遊戲內商店',
  'studio.home.release_timeline.prod_pg_item.community_term': '商品條款',
  'studio.home.release_timeline.prod_pg_item.community_achievements': '挑戰課題',
  'studio.home.release_timeline.prod_pg_item.community_ranking': '排名',
  'studio.home.release_timeline.prod_pg_item.community_cloud_saving': '雲端儲存',
  'studio.home.release_timeline.prod_pg_item.community_match_making': '配對',
  'studio.home.release_timeline.prod_pg_item.price_release_discount': '發布折扣',
  'studio.home.release_timeline.prod_pg_item.price_discount_period': '{discountDayNum}天',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit': '販售數量',
  'studio.home.release_timeline.prod_ptyitem.price_sale_limit_quantity': '{limitedNum}個',
  'studio.home.release_timeline.prod_pg_item.price_sale_limit_guide': '販售數量賣完後暫停',
  'studio.home.release_timeline.prod_pg_item.price_sale_period_terminate_guide': '期間結束時停止',
  'studio.home.release_timeline.prod_pg_item.price_purchase_cond_set': '設定購買條件',
  'studio.home.release_timeline.prod_pg_item.release_plan_prod_page_open': '開放商品頁面',
  'studio.home.release_timeline.prod_pg_item.release_plan_pre_order': '預購',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_yn': '允許下載及安裝',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_yn': '允許全部執行',
  'studio.home.release_timeline.prod_pg_item.release_plan_official_release_date': '正式發布日期',
  'studio.prj_prod.this_prod.release_details_save_btn': '儲存',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_end_date_equal_val_msg1':
    '結束日期須晚於開始日期。請重新設定開始日期及結束日期。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_start_date_before_open_val_msg2':
    '請將開始日期設定為商品頁面開放日後。',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_input_n_val_msg3': '請設定結束日期。 ',
  'studio.prj_prod.this_prod.release_details_product_page_option_early_access_period_end_date_after_official_release_val_msg4':
    '請將結束日期設定為正式發布日期前。',
  'studio.group.home.board_type5_to_be_applied_item1_prod_pg': '商品頁面',
  'studio.group.home.board_type5_to_be_applied_item2_build_rating': '組建及使用等級',
  'studio.group.home.board_type5_to_be_applied_item3_price': '價格',
  'studio.group.home.board_type5_to_be_applied_item4_discount': '折扣',
  'studio.mail.this_release_info_4_build': '組建：',
  'studio.mail.this_release_info_5_sale_prep': '販售準備：',
  'studio.mail.this_release_info_6_release_plan': '發布計畫：',
  'studio.mail.this_release_info_6_1_official_release': '正式發布：',
  'studio.mail.this_release_info_6_2_pre_order': '預售：',
  'studio.mail.case_pre_order_started.title': '開始預售',
  'studio.mail.case_pre_order_started.mail_content': '恭喜您。<br/>您的產品已在STOVE Store開始預購。',
  'studio.mail.case_official_released.title': '正式發布',
  'studio.mail.case_official_released.mail_content': '恭喜您。<br/>您的產品已在STOVE Store中正式上市。',
  'studio.noti.case_restricted':
    '{prodName}處於{resrictionType}狀態。<br/>暫停顯示及販售商品。請於發布現況清單中確認懲處原因，並更新以解除懲處狀態。',
  'studio.prj_prod.restriction_type_user_report': '使用者檢舉',
  'studio.prj_prod.restriction_criteria_policy_violation': '違法',
  'studio.prj_prod.restriction_criteria_adult_content': '成人內容 ',
  'studio.prj_prod.restriction_criteria_defamation': '妨害名譽',
  'studio.prj_prod.restriction_criteria_copyright_violation': '侵犯版權',
  'studio.prj_prod.restriction_criteria_child_bully': '虐待兒童',
  'studio.prj_prod.restriction_criteria_malicious_code': '惡意代碼',
  'studio.prj_prod.this_prod.release_details_pbar_msg10_user_report': '因前述原因導致暫停發布。請於修改後申請審查。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator':
    '因營運人員<span class="font-medium text-tint-red-a400">{restrictionType}</span>導致暫停發布，請於修改後申請審查。',
  'studio.prj_prod.this_prod.release_details_restriction_criteria_partners_title': '展示懲處',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg1': '因營運人員審議懲處導致暫停發布，請於修改後申請審查。',
  'studio.prj_prod.this_prod.release_details_pbar_msg11_operator_review_restriction_msg2': '請前往使用等級及組建審查確認詳情後再申請審查。',
  'studio.prj_prod.this_prod.release_details_pbar_redirect_btn': '立刻查看',
  'studio.mail.this_release_status.checklist_btn': '確認清單',
  'studio.mail.this_release_status.checklist_popup_title': '確認清單',
  'studio.prj_prod.release_info_checklist_review_stt': '審查狀態',
  'studio.prj_prod.release_info_checklist_review_stt_prep': '準備中',
  'studio.prj_prod.release_info_checklist_official_release_date': '正式發布日',
  'studio.prj_prod.release_info_checklist_official_release_stt_pre_release': '發布前',
  'studio.prj_prod.release_info_checklist_official_release_stt_to_be_release': '預計發布',
  'studio.mail.this_release_status_checklist_release_date': '正式發布日',
  'studio.mail.this_release_status_checklist_release_upcoming': '預計發布',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep': '準備商品頁面',
  'studio.mail.this_release_status.checklist_popup_item1_prod_pg_prep.prod_setting': '設定商品',
  'studio.mail.this_release_status_checklist_product_page_info_product_page': '創建商品頁面',
  'studio.mail.this_release_status_checklist_product_page_option_title': '商品頁面選項',
  'studio.mail.this_release_status_checklist_product_page_option_community': '套用至社群',
  'studio.mail.this_release_status_checklist_prod_pg_opt_early_access_guide': '顯示搶先體驗字句',
  'studio.mail.this_release_status_checklist_release_plan_title': '上市計畫',
  'studio.mail.this_release_status_checklist_release_plan_open_date_input': '輸入商品頁面的開放日期',
  'studio.mail.this_release_status_checklist_monetization_setting_title': '準備結算販售收益',
  'studio.mail.this_release_status_checklist_monetization_setting_business_info': '登錄企業資訊',
  'studio.mail.this_release_status_checklist_monetization_setting_bank_account_info': '登錄銀行資訊（選填）',
  'studio.prj_prod.status_rejected': '審查遭駁回',
  'studio.mail.this_release_status_checklist_build_title': '準備組建',
  'studio.mail.this_release_status_checklist_build_execution': '設定執行',
  'studio.mail.this_release_status_checklist_build_file_upload': '上傳組建檔',
  'studio.mail.this_release_status_checklist_build_ratings_and_review': '接受使用等級及組建審查',
  'studio.mail.this_release_status_checklist_studio_support_title': '遊戲支援服務',
  'studio.mail.this_release_status_checklist_studio_support_in_app_shop': '套用遊戲內商店',
  'studio.mail.this_release_status_checklist_studio_support_condition': '套用商品條款',
  'studio.mail.this_release_status_checklist_studio_support_challenges': '套用挑戰課題',
  'studio.mail.this_release_status_checklist_studio_support_ranking': '套用排名',
  'studio.mail.this_release_status_checklist_studio_support_cloud': '套用雲端儲存',
  'studio.mail.this_release_status_checklist_studio_support_match': '套用配對',
  'studio.mail.this_release_status_checklist_sales_setting_title': '設定販售',
  'studio.mail.this_release_status_checklist_sales_setting_price_and_discount': '套用價格及折扣',
  'studio.mail.this_release_status_checklist_sales_setting_sale': '設定購買條件',
  'studio.mail.this_release_status_checklist_release_plan_early_access': '設定預購（選填）',
  'studio.mail.this_release_status_checklist_release_plan_schedule': '設定正式發布日',
  'studio.prj_prod.post_release.price_update.popup_msg':
    '如欲修改價格，須經過審查流程。<br/>審查最多須5個工作天，<br/>修改後的價格通過審查後將立刻套用。 ',
  'studio.prj_prod.post_release.price_update.popup_request_cf_btn': '申請審查',
  'studio.prj_prod.post_release.price_update.stt_requested': '申請審查',
  'studio.prj_prod.post_release.price_update.request_cancel_btn': '取消',
  'studio.prj_prod.post_release.price_update.requested_guide': '審查通過後立刻套用',
  'studio.prj_prod.post_release.price_update.popup_request_cancel_msg': '確定要取消審查嗎？<br/>取消後，審查中的數據將被刪除。',
  'studio.prj_prod.post_release.price_update.popup_cancel_cf_btn': '取消審查',
  'studio.prj_prod.this_prod.release_status_in_promotion': '套用至折扣LIVE',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_discount_rate': '折扣',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_name': '上傳失敗',
  'studio.build_mgmt.case_build_upload_error.upload_failure_error_msg': '上船時發生未知錯誤。<br/>請結束上傳後再試一次。',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_name': '組建複製失敗',
  'studio.build_mgmt.case_build_upload_error.build_copy_failure_error_msg': '發生組建檔複製錯誤。<br/>請結束上傳並再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_name': '組建比較失敗',
  'studio.build_mgmt.case_build_upload_error.build_comparison_failure_error_msg': '與前一版組建比較時發生錯誤。<br/>請結束上傳並再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_name': 'InstallJaon檔案建立失敗',
  'studio.build_mgmt.case_build_upload_error.installjaon_file_creation_failure_error_msg': '安裝資訊檔案建立錯誤。<br/>請結束上傳後再試一次。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_name': '壓縮資料夾建立失敗',
  'studio.build_mgmt.case_build_upload_error.compression_folder_creation_failure_error_msg': '創建目錄時發生錯誤。<br/>請結束上傳後再試一次。',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_name': '壓縮資料夾複製失敗',
  'studio.build_mgmt.case_build_upload_error.compression_folder_copy_failure_error_msg': '組建檔複製時發生錯誤。<br/>請結束上傳並再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_name': '壓縮失敗',
  'studio.build_mgmt.case_build_upload_error.compression_failure_error_msg': '組建檔壓縮時發生錯誤。<br/>請結束上傳並再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_name': '可使用遊戲清單獲取失敗',
  'studio.build_mgmt.case_build_upload_error.game_list_fetch_failure_error_msg': '載入商品清單時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_name': '遊戲資訊取得失敗',
  'studio.build_mgmt.case_build_upload_error.game_info_fetch_failure_error_msg': '載入遊戲資訊時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_name': '歷史紀錄刪除失敗',
  'studio.build_mgmt.case_build_upload_error.history_deletion_failure_error_msg': '刪除先前上傳檔案歷史紀錄時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_name': '資料夾建立失敗',
  'studio.build_mgmt.case_build_upload_error.folder_creation_failure_error_msg': '建立資料夾時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_name': 'CheckList建立失敗',
  'studio.build_mgmt.case_build_upload_error.checklist_creation_failure_error_msg': '建立CheckList時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_name': 'BuildSetting建立失敗',
  'studio.build_mgmt.case_build_upload_error.buildsetting_creation_failure_error_msg': '建立BuildSetting時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_name': 'DRMMaker資訊建立失敗',
  'studio.build_mgmt.case_build_upload_error.drmmaker_info_creation_failure_error_msg': '建立DRMMaker資訊時發生錯誤。<br/>請結束上傳後再試一次。 ',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_name': '取消停止上傳組建',
  'studio.build_mgmt.case_build_upload_error.upload_termination_build_cancel_error_msg': '沒有上傳所需的組建資訊。',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_name': 'Build檔案下載失敗',
  'studio.build_mgmt.case_build_generate_error.build_file_download_failure_error_msg':
    '下載組建檔時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_name': 'Build檔案zip解壓縮失敗',
  'studio.build_mgmt.case_build_generate_error.build_file_zip_unzip_failure_error_msg':
    '組建檔解壓縮時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_name': 'UploadedFiles無效格式',
  'studio.build_mgmt.case_build_generate_error.uploaded_files_wrong_format_error_msg':
    '發現錯誤的組建檔格式。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_name': 'Base組建檔比較過程中發生錯誤',
  'studio.build_mgmt.case_build_generate_error.base_build_file_comparison_failure_error_msg':
    '與前一版組建比較時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_name': '確認新組建檔時發生錯誤',
  'studio.build_mgmt.case_build_generate_error.new_build_file_verification_failure_error_msg':
    '確認組建檔資訊時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_name': 'Base組建檔下載失敗',
  'studio.build_mgmt.case_build_generate_error.base_build_file_download_failure_error_msg':
    '下載前一版組建檔時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_name': 'MD5解碼失敗',
  'studio.build_mgmt.case_build_generate_error.md5_hash_failure_error_msg':
    '發生MD5雜湊失敗錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_name': '將新檔案歸類為更新檔案時出現錯誤',
  'studio.build_mgmt.case_build_generate_error.new_file_update_classification_failure_error_msg':
    '組建檔分流時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_name': 'S3失敗',
  'studio.build_mgmt.case_build_generate_error.s3_failure_error_msg':
    '發生S3失敗錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_name': '狀態更新失敗',
  'studio.build_mgmt.case_build_generate_error.status_update_failure_error_msg':
    '更新組建檔狀態時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_name': '刪除失敗',
  'studio.build_mgmt.case_build_generate_error.file_deletion_failure_error_msg':
    '刪除組建檔時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。 ',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_name': 'Metafile讀取失敗',
  'studio.build_mgmt.case_build_generate_error.metadata_file_read_failure_error_msg':
    '確認組建檔資訊時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_name': 'DRM Maker套用失敗',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg':
    'DRM Maker套用時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2971':
    'DRM Maker套用時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.drmmaker_application_failure_error_msg_2972':
    'DRM Maker套用時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_name': '未知錯誤',
  'studio.build_mgmt.case_build_generate_error.unknown_error_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_name': '執行程式時參數無效',
  'studio.build_mgmt.case_security_inspection_error.program_execution_parameter_error_error_msg':
    '發現錯誤的參數。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_name': 'Logger設定失敗',
  'studio.build_mgmt.case_security_inspection_error.logger_setup_failure_error_msg':
    '設定Logger時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_name': 'Config解析失敗',
  'studio.build_mgmt.case_security_inspection_error.config_parsing_failure_error_msg':
    '解析Config時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_name': '工作目錄設定失敗',
  'studio.build_mgmt.case_security_inspection_error.work_directory_setup_failure_error_msg':
    '設定工作目錄時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_name': 'Task INI解析失敗',
  'studio.build_mgmt.case_security_inspection_error.task_ini_parsing_failure_error_msg':
    '解析Task INI時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1099_error_msg':
    '進行安全審查時發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_name': '下載失敗',
  'studio.build_mgmt.case_security_inspection_error.download_failure_error_msg':
    '下載組建檔時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1199_error_msg':
    '進行安全審查時發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_name': '解壓縮目標路徑非檔案路徑',
  'studio.build_mgmt.case_security_inspection_error.invalid_path_for_extracted_file_error_msg':
    '確認解壓縮目標路徑時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1299_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_name': '防毒掃描時發現包含惡意程式碼',
  'studio.build_mgmt.case_security_inspection_error.possible_malware_code_found_error_msg':
    '可能存在惡意程式碼。<br/>如欲以該組建進行，請申請特殊安全審查。',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_name': '防毒掃描目標不存在',
  'studio.build_mgmt.case_security_inspection_error.no_file_found_for_scan_error_msg':
    '發生找不到審查目標檔案的錯誤。<br/>如欲以該版本進行，請申請特殊安全審查。 ',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_name': '防毒掃描超過重試次數',
  'studio.build_mgmt.case_security_inspection_error.too_many_rescan_attempts_error_msg':
    '防毒檢查的重試次數已超過。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_name': '防毒掃描超過時間限制',
  'studio.build_mgmt.case_security_inspection_error.time_limit_exceeded_for_scan_error_msg':
    '防毒檢查的限制時間已超過。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_name': '防毒掃描伺服器錯誤',
  'studio.build_mgmt.case_security_inspection_error.server_error_during_scan_error_msg':
    '防毒檢查時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_name': '目標檔案檢測被判定為惡意程式碼，遭消除風險',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_deleted_error_msg':
    '可能存在惡意程式碼。<br/>如欲以該組建進行，請申請手動安全審查。',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_name': '目標檔案檢測被判定為惡意程式碼，遭刪除',
  'studio.build_mgmt.case_security_inspection_error.malware_found_and_file_removed_error_msg':
    '可能存在惡意程式碼。<br/>如欲以該組建進行，請申請手動安全審查。',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_name': '目標檔案為無法審查類型',
  'studio.build_mgmt.case_security_inspection_error.unverifiable_file_for_security_scan_error_msg':
    '該檔案類型無法進行自動安全審查。<br/>如欲以該組建進行，請申請手動安全審查。',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_name': '目標文件使用密碼加密，無法審查',
  'studio.build_mgmt.case_security_inspection_error.file_encrypted_and_scan_unavailable_error_msg':
    '有無法進行自動安全審查的加密檔。<br/>如欲以該組建進行，請申請手動安全審查。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1399_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_name': '超過狀態更新API重試次數',
  'studio.build_mgmt.case_security_inspection_error.status_update_attempts_exceeded_error_msg':
    '檔案狀態更新時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_name': '狀態更新API回應格式無效',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_format_error_msg':
    '檔案狀態更新時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_name': '狀態更新API回應代碼不成功',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_invalid_response_error_msg':
    '檔案狀態更新時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_name':
    '因其他原因導致狀態更新API回應處理失敗',
  'studio.build_mgmt.case_security_inspection_error.status_update_api_failure_due_to_other_reason_error_msg':
    '檔案狀態更新時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1499_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_name': '工作目錄刪除失敗',
  'studio.build_mgmt.case_security_inspection_error.work_directory_deletion_failure_error_msg':
    '刪除工作目錄時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_name': '使用未定義動作的選項值',
  'studio.build_mgmt.case_security_inspection_error.unconfigured_option_error_msg':
    '發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1599_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_name': '未知錯誤',
  'studio.build_mgmt.case_security_inspection_error.unknown_error_1999_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_name': '設定時發生錯誤',
  'studio.build_mgmt.case_drm_maker.setup_failed_error_msg': '設定時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.download_failed_error_name': '下載失敗',
  'studio.build_mgmt.case_drm_maker.download_failed_error_msg': '下載檔案時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_name': '解壓縮檔案失敗',
  'studio.build_mgmt.case_drm_maker.zip_decompression_failed_error_msg': '解壓縮檔案時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_name': 'DRM Maker執行時發生錯誤',
  'studio.build_mgmt.case_drm_maker.drm_application_failed_error_msg': '套用DRM時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.api_call_error_name': '更新API呼出過程中發生錯誤',
  'studio.build_mgmt.case_drm_maker.api_call_error_msg': '伺服器連動發生問題。 ',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_name': '欲上傳的檔案壓縮失敗',
  'studio.build_mgmt.case_drm_maker.file_compression_failed_error_msg': '壓縮文件時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_name': '上傳檔案至S3時發生錯誤',
  'studio.build_mgmt.case_drm_maker.s3_upload_failed_error_msg': '上傳檔案至伺服器時發生錯誤。 ',
  'studio.build_mgmt.case_drm_maker.upload_api_error_name': '上船更新API呼出過程中發生錯誤',
  'studio.build_mgmt.case_drm_maker.upload_api_error_msg': '伺服器連動發生問題。 ',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_name': '未知錯誤',
  'studio.build_mgmt.case_drm_maker.unknown_error_error_msg': '發生未知錯誤。 ',
  'studio.prj_prod.this_prod.product_data.build.home_title': '組建管理',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_msg': '商品金鑰',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_prod_id_row1': '商品編號',
  'studio.toast.link_copied': '已複製',
  'studio.prj_prod.this_prod.product_data.build.home_sdk_guide_btn': 'SDK連動指南',
  'studio.prj_prod.this_prod.product_data.build.home_upload_btn': '上傳',
  'studio.prj_prod.this_prod.product_data.build.home_guide1': '上傳您要販售的商品組建，並準備上市！',
  'studio.prj_prod.this_prod.product_data.build.home_guide2': '如非Web、Mobile遊戲等安裝型PC遊戲，請於商品數據管理 > 執行設定選單中輸入連結。 ',
  'studio.prj_prod.this_prod.product_data.build.home_guide3': '使用STOVE提供的PC SDK即可運用Studio所提供的統計值、排名、挑戰課題、配對等附加服務。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg1': '請安裝上傳程式',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop1_msg2': '須下載上傳程式後<br/>才能上傳檔案。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_latest_badge': '最新 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_install_client_btn': '下載上傳程式',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg1': '請更新上傳程式',
  'studio.prj_prod.this_prod.product_data.build.home_upload_pop2_msg2': '已有新版本。<br/>請下載安裝檔案後進行安裝。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg': 'STOVE Studio Uploader<br/>已在執行中。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_title': '安裝STOVE Studio Uploader',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg1': '授權合約',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg2': '安裝STOVE Studio Uploader前，請詳閱授權合約內容。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg3': '如欲查看授權合約同意其餘事項，請按[Page Down]鍵。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg4':
    '最終使用者授權合約書<br/><br/>在您將“STOVE” Studio Uploader程式安裝至您的電腦前，請詳閱以下最終使用者授權合約（以下簡稱「本授權合約書」或「本授權合約」），且須同意本合約。<br/>本Uploader程式（以下簡稱「本軟體」）須於您同意本授權合約後，點選「點選」同意按鈕才能進行安裝流程，如若選擇「取消」，則可停止安裝本軟體。<br/>如您不同意本授權合約條件，請停止安裝或執行本軟體。<br/><br/>[最終使用者使用合約]<br/>軟體名稱：“STOVE” Studio Uploader程式<br/>同意在使用者電腦硬碟中安裝本軟體即表示您同意以下條款即條件。<br/>此為Smilegate STOVE Co., Ltd.欲在使用者所擁有或其個人控制之一台或多台電腦上安裝本軟體並賦予使用者相關個人使用許可請求事項。<br/>本授權協議僅適用於“STOVE” Studio Uploader軟體，與線上遊戲服務相關使用條款不同，與線上遊戲服務相關之使用條款將於加入官方網站（http://www.onstove.com）時提供。<br/><br/>1. 軟體授權<br/>①Smilegate STOVE Co., Ltd.（及所有明示擁有該軟體權利歸屬之合作公司）允許使用者透過本合約於STOVE Studio（PC套組遊戲營運平台）中登錄、修改及管理遊戲。此目的的軟體，但與本軟體相關之任何權利均不轉讓予使用者。<br/>② Smilegate STOVE Co., Ltd.有權隨時更新、修改或更改本合約中規定之條款及條件。<br/>③未事先徵求Smilegate STOVE Co., Ltd.書面同意時，使用者亦不得以本授權合約中未明示之方式使用或重新散播本軟體，亦不得修改、複製、出售、出租、散播本軟體或從事任何營利行為。<br/>④使用者不得使用本軟體進行複製、翻譯、分析、反編譯、反組譯或反向工程，亦不得使用本軟體創作衍生作品。<br/><br/>2.變更、更新相關許可<br/>①Smilegate STOVE Co., Ltd.有權更新或變更本軟體或修正錯誤，以利使用者持續於STOVE Studio註冊、修改及管理遊戲。<br/>②如您繼續使用本軟體登錄、修改或管理您的遊戲，即表示您接受本軟體的所有變更並同意合約以適用更新、變更事項及修改錯誤內容。<br/>③其他事項將依據第1條（軟體授權）規範執行。<br/><br/>3. 責任限制及免責聲明<br/>①本軟體免費提供，僅用於Smilegate STOVE Co., Ltd.提供之“STOVE” Studio（PC套組遊戲運營平台）中登錄、修改、管理遊戲目的。<br/>②本軟體依現狀提供，Smilegate STOVE Co., Ltd.不對本軟體之內容、功能、有效性、準確性、穩定性以及使用本軟體未達或喪失預期效果擔保或負責。<br/>③ Smilegate STOVE Co., Ltd.不保證本軟體的使用或操作將於所有條件下順利執行，亦不承擔因本軟體造成的損害或損失。然而，如因Smilegate STOVE Co., Ltd.故意造成之重大過失產生損害或損失之狀況則不在此限。<br/>④針對第3項但書，Smilegate STOVE Co., Ltd.僅對使用者於正常狀況下使用軟體時造成的實際且直接損失進行賠償。此外，Smilegate STOVE Co., Ltd.亦不對第三方未經授權使用造成之一切後果負責。<br/><br/>4.解除授權<br/>①使用者可以隨時透過刪除或廢棄本軟體來終止本授權合約。<br/>②如若使用者有違反本授權同意書明示條款之行為，Smilegate STOVE Co., Ltd.有權無須提供任何賠償單方面終止該使用者之授權。此時，使用者須同意立即銷毀包含本軟體副產物在內之所有部分，並刪除本軟體。<br/>③如若本授權合約因任何原因終止，則依據本合約，Smilegate STOVE Co., Ltd.授予使用者之所有與本軟體相關使用權亦將立刻終止。<br/>④雖依本條第1項或第2項終止合約，然而，本合約第1條第3項及第4項、第5項於合約終止後仍具效力。<br/><br/>5.其他事項<br/>本授權合約中所有事項均符合韓國法律，如使用者與Smilegate STOVE Co., Ltd.之間因本授權合約相關糾紛提起訴訟時，雙方當事人均可向民事訴訟法管轄法院提出訴訟。<br/><br/>附件（2020.12.10）<br/>（實施日期）本授權合約自2020年12月10日起實施。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step2_msg5':
    '如您同意內容，請按「同意」。必須同意內容才能安裝STOVE Studio Uploader。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_previous_btn': '< 返回',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_agree_btn': '同意',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_title': '設定',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_msg1': '確定要取消安裝STOVE Studio Uploader嗎？',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_yes_btn': '是',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_cancel_pop_no_btn': '否',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg1': '選擇安裝位置',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg2': '請選擇欲安裝STOVE Studio Uploader的資料夾。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg3':
    'STOVE Studio uploader將安裝於以下資料夾中。<br/>如想安裝在其他資料夾內，請點擊「搜尋」，並選擇其他資料夾。<br/>如欲開始安裝，請點擊「安裝」。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_destination_folder_title': '安裝資料夾',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_btn': '搜尋',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg4': '所須硬碟空間：{reqDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step3_msg5': '剩餘硬碟空間：{availDiskCapa}',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_install_btn': '設定',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_title': '尋找資料夾',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_msg': '將STOVE Studio Uploader安裝至以下資料夾：',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_browse_pop_new_folder_btn': '建立新資料夾',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg1': '安裝中',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg2': '安裝STOVE Studio Uploader時請稍待片刻。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step4_msg3': '正在解壓縮…',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg1': 'STOVE Studio Uploader安裝完成',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_step5_msg2': '點擊[結束]即可完成安裝。<br/>請登入STOVE Studio並進行上傳。',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_finish_btn': '結束',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_msg1': '請指定欲上船的檔案所在資料夾位置並開始上傳。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_title': '上傳檔案',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_place_holder': '請選擇組建所在的資料夾路徑',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_req_val': '請選擇組建所在的資料夾路徑。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_btn': '搜尋',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_title': '臨時檔案儲存資料夾',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_place_holder': '如未輸入，將儲存在預設的臨時檔案資料夾中',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_temp_folder_change_btn': '變更',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail': '組建說明',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_build_detail_place_holder': '請輸入可區分上傳檔案之資訊。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide_title': '通知事項',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide1': '可依據上傳進行狀態接續進行。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide2': '如上傳失敗，請重新上傳。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide3': '上傳結束後將進行安全審查、建立組建並更新上傳狀態。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_btn': '開始上傳',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_msg': '確定要結束<br/>STOVE Studio Uploader嗎？',
  'studio.prj_prod.this_prod.product_data.build.uploader_terminate_pop_cf_btn': '結束',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert1_msg': '偵測到無法上傳的檔案或資料夾。<br/>請刪除後重新嘗試。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert2_msg': '遺失dll檔案。<br/>請於下載檔案後，包含該檔案嘗試執行。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_start_upload_alert3_msg': '使用者認證資訊已過期。<br/>請重新執行Uploader。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_select_file_browse_cf_alert_msg1':
    '團隊儲存所的剩餘空間不足。<br/>請刪除前一版的組建後再重試。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_this_action_cf_alert_msg':
    '硬碟容量不族，無法上船。<br/>請重新指定臨時檔案儲存資料夾。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_title': '暫停上傳',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_msg': '有停止上傳的組建。<br/>確定要重新上傳嗎？',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_cont_upload_btn': '繼續',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_incompleted_bld_exist_popup_start_new_upload_btn': '重新開始',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg': '正在確認檔案。。。 ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_remaining_time_msg': '剩餘時間',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_cancel_upload_btn': '取消上傳',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_retry_btn': '重試',
  'studio.prj_prod.this_prod.product_data.build.uploader_quitting_attempt_pop_msg': '確定要結束STOVE Studio Uploader嗎？',
  'studio.prj_prod.this_prod.product_data.build.uploader_cannot_cont_upload_popup': '找不到暫停上傳的檔案。<br/>請刪除後重新上傳。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_paused_msg': '網路發生錯誤，已暫停上傳。<br/>請繼續上傳。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_failed_msg':
    '複製安裝資訊檔案發生錯誤，上傳失敗。<br/>請確認錯誤代碼後重試。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_error_case1_temp_paused': '暫停。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_continue_upload_btn': '繼續進行',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_2_upload_failed':
    '上傳失敗。{overallProg}% ({completedFileNum}/{totalFileNum})',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt1_checking': '正在確認檔案。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_1_compressing': '正在壓縮檔案。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt2_2_compress_failed': '檔案壓縮失敗。{overallProg}% ',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt3_1_uploading': '正在上傳。。。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_finish_btn': '審查完畢',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_sdk_sync_guide_btn': '查看SDK連動方法',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_title': 'PC客戶端執行測試',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_client_download': '客戶端下載',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_title': '統計數據',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_2': '統計數據指的是與遊戲相關的數值，<br/>可依統計數據為基準制定排名及挑戰課題。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_title': '雲端儲存',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide4_1':
    '安裝遊戲後，可透過STOVE PC客戶端將遊戲數據儲存在 雲端硬碟中，並同步更新最新檔案的服務。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_title': '配對',
  'studio.prj_prod.this_prod.product_data.build_build_count_title': '全體',
  'studio.prj_prod.this_prod.product_data.build_redirect_execution_btn': '立刻前往設定',
  'studio.prj_prod.this_prod.product_data.build_guide1': '請測試上傳的組建是否能正常執行。<br/>可在STOVE PC客戶端中分別執行各個商品。',
  'studio.prj_prod.this_prod.product_data.build_guide2': '客戶端執行測試',
  'studio.prj_prod.this_prod.product_data.build_client_download_btn': '客戶端下載',
  'studio.prj_prod.this_prod.product_data.build_group_storage_msg': '{totalCapa}GB中，已使用{usedCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_total_capacity_msg': '群組儲存空間({totalCapa} GB)',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_occupied_capacity_msg': '{usedCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_remaining_capacity_msg': '{totalCapa}GB',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_btn': '額外申請',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_sent': '申請完畢',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg1': '申請增加群組儲存空間',
  'studio.prj_prod.this_prod.product_data.build_group_storage_mouseover_request_more_storage_pop_msg2':
    '未事先徵求同意的申請可能遭到拒絕，詳情請向STOVE Studio營運人員詢問。',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_inquiry_btn': '諮詢',
  'studio.prj_prod.this_prod.product_data.build_group_storage_pop_request_btn': '申請',
  'studio.prj_prod.this_prod.product_data.build.home_build_id_header1': '組建編號',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_header2': '上傳狀態',
  'studio.prj_prod.this_prod.product_data.build.home_integrity_header4': '完整性',
  'studio.prj_prod.this_prod.product_data.build.home_file_size_header5': '容量',
  'studio.prj_prod.this_prod.product_data.build.home_edited_date_header6': '登錄日（修改日）',
  'studio.prj_prod.this_prod.product_data.build.home_prod_status_header7': '發布狀態',
  'studio.prj_prod.this_prod.product_data.build.home_list_delete_n_alert_msg': '無法刪除正在進行審查或發布的商品檔案。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg1': '暫停上傳',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_msg2': '有上傳過程中遭暫停的紀錄。<br/>請繼續上船或刪除紀錄。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_delete_build_btn': '刪除組建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop1_resume_btn': '繼續',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg1': '無法上傳',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_msg2': '該帳號無法繼續上傳。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_paused_pop2_delete_build_btn': '刪除組建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg': '上傳失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_creating_msg': '建立組建',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_msg': '安全審查',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_build_status_failed_msg': '組建建立失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_testing_pop_security_test_failed_msg': '安全審查失敗',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_request_btn': '申請手動安全審查',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_requested_msg': '正在申請手動安全審查',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_manual_test_declinded_msg': '手動安全審查遭駁回',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_title': '手動安全審查申請及同意書',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_name_place_holder': '姓名或公司名稱',
  'studio.build.request_manual_test_pop.request_form_name_req_msg': '請輸入姓名或公司名稱。',
  'studio.common.def_key.special_character_n': '無法輸入特殊文字。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_agreement_text': '本人人已確認並同意上述通知及同意事項。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_year': '年',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_req_msg': '請輸入日期。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_month': '月',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_day': '日 ',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_place_holder': '姓名或代表理事姓名',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_signature_applicant_req_msg': '請輸入姓名或代表理事姓名。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_btn': '提交',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_reason_for_requst_place_holder': '請輸入申請原因。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_title': '手動審查申請完畢',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_submit_pop_msg2':
    '您所填寫的同意書已提交。<br/>待STOVE Studio營運人員確認後將更新結果。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_title': '刪除組建',
  'studio.prj_prod.this_prod.product_data.build_del_pop_msg': '如欲刪除，請輸入「DELETE」，<br/>刪除後將無法復原。',
  'studio.prj_prod.this_prod.product_data.build_del_pop_del_cf_btn': '刪除',
  'studio.build_mgmt.build_upload_stt1_paused': '暫停上傳',
  'studio.build_mgmt.build_upload_stt2_upload_failed': '上傳失敗',
  'studio.build_mgmt.build_upload_stt3_inspecting': '審查中',
  'studio.build_mgmt.build_upload_stt4_build_gen_failed': '組建建立失敗',
  'studio.build_mgmt.build_upload_stt5_security_inspection_failed': '安全審查失敗',
  'studio.build_mgmt.build_upload_stt6_failed': '失敗',
  'studio.build_mgmt.build_upload_stt7_completed': '審查完畢',
  'studio.build_mgmt.build_detail.description_place_holder': '請輸入該版本介紹',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_build_size_row3': '容量',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_date_upload_row4': '登錄日',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_modified_date_row5': '修改日',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_release_status_row6': '發布狀態',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_row7': '上傳狀態',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status1_paused_guide':
    '有上傳過程中遭暫停的紀錄。<br/>請繼續上船或刪除紀錄。',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_resume_btn': '繼續',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_manual_test_requested_stt': '正在申請手動安全審查',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_request_manual_test_rejected_stt': '手動安全審查遭駁回',
  'studio.prj_prod.this_prod.product_data.build.details_basic_info_upload_status_testing_build_msg': '審查中',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_msg': '是否套用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_yes_msg': '套用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_option_apply_no_msg': '未套用',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_title': '審查完整性',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg1':
    '確認透過STOVE PC客戶端執行遊戲時，所需檔案是否已正確安裝在電腦上的功能。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_msg2': 'DLC檔案與上層檔案相同時，將以DLC檔案為基準執行。',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_msg': '套用檔案',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_place_holder': '請選擇要套用的檔案',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_file_selected_text': '{fileName}的{extraSelectedFileNum}個',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_files_select_file_btn': '選選擇檔案',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_setting_title': '驗證逾時',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_msg': '套用檔案',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applied': '套用完畢',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_failed': '套用失敗',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_applying': '申請套用',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_withdrawed': '申請解除',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_title': '選擇DRM Maker檔案',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_total_file': '全部',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_pop_filename_header2': '檔案名稱',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_select_file_pop_status_header3': '套用狀態',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_title': '選擇完整性審查檔案',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_hash_msg':
    'EXIST_HASH：驗證檔案是否存在並比較雜湊值，不一致時進行驗證',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_type_exist_msg': 'EXIST：確認檔案有無並驗證是否存在',
  'studio.prj_prod.this_prod.product_data.build.details_integrity_check_select_file_pop_test_type_header3': '驗證類型',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_3_rejected': '審查駁回',
  'studio.prj_prod_mngmt.rating_build_review.self_review.under_review_stt_4': '審查完畢',
  'studio.prj_prod.this_prod.home_prod_stt_terminated': '結束',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update_btn': '更新組建',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.title': '更新組建',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.badge_live_apply_y': '套用中',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item_check':
    '套用中的組建及所選的組建之間有變更的內容嗎？',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item1_bug_fix': '修改版本',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item2_background_img_vid': '變更背景、影片',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item3_ui': '變更基本系統、UI',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item4_billing_sys': '變更課金制度',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item5_scenario': '變更任務、劇情',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.updated_item6_char_item': '變更角色、道具',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_guide':
    '完成內容修改申報，通過審核後，即可從執行設定選單套用至LIVE。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_rating_menu_dir_btn': '使用等級及組建審查',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.info_change_report_stt_under_review': '正在進行審查。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.build_apply_date': '組建套用日期',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.immed_apple': '立刻',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_apply': '預約',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_req_msg1': '請選擇開始日期。',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.case_self_review.change_report_complete.schedule_invalid_msg2':
    '請選擇當前時間之後的日期。',
  'studio.prj_prod.this_prod.execution_register_btn': '登錄',
  'studio.prj_prod.this_prod.execution_guide1': '請輸入最低限度，以利於PC客戶端執行商品。',
  'studio.prj_prod.this_prod.execution_guide1_1': '請準備欲套用至客戶端的30MB以下商品圖片及ico檔案後再進行登錄。',
  'studio.prj_prod.this_prod.execution_setting_option_title': '執行選項',
  'studio.prj_prod.this_prod.execution_setting_option_msg': '請依據所選平台，輸入所需之必要項目。',
  'studio.prj_prod.this_prod.execution_setting_option_platform_msg': '平台',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_place_holder': '請選擇平台',
  'studio.prj_prod.this_prod.execution_setting_option_platform_dropbox_req_msg': '請選擇平台。',
  'studio.prj_prod.this_prod.execution_setting_option_add_btn': '新增選項',
  'studio.prj_prod.this_prod.execution_setting_option_name': '選項名稱',
  'studio.prj_prod.this_prod.execution_setting_option_name_place_holder': '請輸入選項名稱。',
  'studio.prj_prod.this_prod.execution_setting_option_name_req_msg': '請輸入選項名稱。',
  'studio.prj_prod.this_prod.execution_setting_option_name_duplicate_msg': '選項名稱重複，請重新輸入。',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_msg': '執行檔',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_place_holder': '請輸入執行檔',
  'studio.prj_prod.this_prod.execution_setting_option_executing_file_req_msg': '請輸入執行檔。',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_msg': '參數值',
  'studio.prj_prod.this_prod.execution_setting_option_parameter_place_holder': '請輸入參數值',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_msg': '工作路徑',
  'studio.prj_prod.this_prod.execution_setting_option_working_directory_place_holder': '請輸入作業路徑',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_msg': '流程檔案',
  'studio.prj_prod.this_prod.execution_setting_option_process_name_place_holder': '請輸入流程檔案',
  'studio.prj_prod.this_prod.execution_setting_option_collapse_all_msg': '簡述',
  'studio.prj_prod.this_prod.execution_setting_option_expand_all_msg': '查看更多',
  'studio.prj_prod.execution_setting_option_requirements_cpp_place_holder': '尚未選擇',
  'studio.prj_prod.execution_setting_option_platform_msg': '平台',
  'studio.prj_prod.execution_setting_option_platform_dropbox_place_holder': '請選擇平台',
  'studio.prj_prod.execution_setting_option_platform_dropbox_req_msg': '請選擇平台。',
  'studio.prj_prod.execution_setting_option_delete_btn': '刪除',
  'studio.prj_prod.execution_setting_option_delete_cf_btn': '刪除',
  'studio.prj_prod.execution_setting_option_name': '選項名稱',
  'studio.prj_prod.execution_setting_option_name_place_holder': '請輸入選項名稱。',
  'studio.prj_prod.execution_setting_option_name_req_msg': '請輸入選項名稱。',
  'studio.prj_prod.execution_setting_exe_url': '執行URL',
  'studio.prj_prod.execution_setting_exe_url_place_holder': '輸入時請包含http://或https://',
  'studio.prj_prod.execution_setting_exe_url_req_msg': '請輸入可執行之URL或首頁URL。',
  'studio.prj_prod.execution_setting_option_mob_store_url_title': '行動裝置商店URL ',
  'studio.prj_prod.execution_setting_option_mob_store_url_place_holder': '輸入時請包含http://或https://',
  'studio.prj_prod.execution_setting_option_mob_store_url_req_msg': '至少須輸入1個詳細URL。',
  'studio.prj_prod.this_prod.execution_setting_title': '安裝設定',
  'studio.prj_prod.this_prod.execution_setting_folder_title': '安裝資料夾',
  'studio.prj_prod.this_prod.execution_setting_folder_msg': '請輸入使用者下載商品時，安裝在本機磁碟上的資料夾名稱。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_placeholder': '請輸入安裝資料夾名稱。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_req_msg': '請輸入安裝資料夾名稱。',
  'studio.prj_prod.this_prod.execution_setting_folder_name_invalid_msg': '安裝資料夾名稱有誤。請重新確認。',
  'studio.prj_prod.execution_setting_pc_client_title': 'PC客戶端設定',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_title': '安裝後的Windows商品啟動圖示',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_format_guide': 'ico檔案｜30MB以下',
  'studio.prj_prod.execution_setting_pc_client_launcher_image_req_msg': '請登錄圖片。',
  'studio.prj_prod.execution_setting_pc_client_logo_image_title': 'PC客戶端商品縮略圖',
  'studio.prj_prod.execution_setting_pc_client_logo_image_format_guide': 'jpg、jpeg、png｜30MB以下',
  'studio.prj_prod.execution_setting_pc_client_logo_image_req_msg': '請登錄圖片。',
  'studio.prj_prod.execution_setting_pc_client_client_wallpaper_image_title': 'PC客戶端代表推薦圖片',
  'studio.prj_prod.execution_setting_pc_client_img_preview_btn': '預覽',
  'studio.prj_prod.execution_setting_pc_client_preview_title': 'PC客戶端圖片套用預覽',
  'studio.prj_prod.execution_setting_pc_client_preview_msg1': '協助理解的範例圖片。',
  'studio.prj_prod.execution_setting_pc_client_preview_msg2': '首頁商品推薦',
  'studio.prj_prod.execution_setting_pc_client_preview_play_btn': '遊玩',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_title': '隨機搜尋',
  'studio.prj_prod.execution_setting_pc_client_preview_random_search_msg': '點擊圖標時將推薦其他遊戲。',
  'studio.prj_prod.execution_save_btn': '儲存',
  'studio.prj_prod.this_prod.execution_setting_option_platform_alert_msg': '儲存完成。<br/>請上傳組建。',
  'studio.prj_prod.build_upload_pg_dir_btn': '上傳組建',
  'studio.prj_prod.execution_basic_guide1': '執行設定',
  'studio.prj_prod.execution_basic_guide1_1': '請輸入所有必填項目，並於STOVE PC客戶端上進行測試，確認是否可以正常執行。',
  'studio.prj_prod.execution_install_set_enabled_guide2': '安裝資料夾',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2': 'PC用戶端設定',
  'studio.prj_prod.execution_pc_client_set_enabled_guide2_1': '請註冊通過STOVE客戶端向用戶顯示的商品圖片。註冊的圖片將用於圖示、縮略圖和橫幅。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3': '執行圖標',
  'studio.prj_prod.execution_pc_client_set_enabled_guide3_1': '使用者安裝遊戲時，設定為Windows桌面捷徑圖標的圖片。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4': 'PC客戶端商品縮略圖',
  'studio.prj_prod.execution_pc_client_set_enabled_guide4_1': '在STOVE客戶端左側的STOVE遊戲選單或收藏選單中註冊的遊戲縮略圖將顯示給用戶。',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5': '推薦圖片',
  'studio.prj_prod.execution_pc_client_set_enabled_guide5_1': '僅限於經STOVE營運人員確認過後的遊戲，才能顯示在PC客戶端首頁。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2': '執行選項',
  'studio.prj_prod.execution_exe_opt_enabled_guide3_1': '可自由設定並進行測試。上市後也可進行變更，但套用錯誤的資訊時，可能無法執行，請多加留意。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_1': '執行檔案',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_1': '參數值',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_2_2': '- 請輸入執行檔案時一併呼叫的參數值。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_1': '工作路徑',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_3_2': '- 請輸入工作路徑，以防遇到exe執行檔案以及執行所需文件的位置不同的狀況。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_1': '流程檔案',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_4_2': '- 組建的安裝檔及執行檔位置不同時，請於實際的執行檔中輸入流程檔案名稱。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_1': '必備程式',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_5_2': '- 如不選擇執行遊戲時所需程式，可能導致遊戲無法正常執行，請務必選擇。',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_1': '執行URL',
  'studio.prj_prod.execution_exe_opt_enabled_guide5_2': '- 請輸入可直接透過連結執行遊戲的URL或首頁URL。',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_1': '行動裝置商店URL',
  'studio.prj_prod.execution_exe_opt_enabled_guide6_2': '- 支援從商店商品頁面連結至行動裝置商店。請輸入行動裝置商店地址。',
  'studio.prj_prod.execution_setting_folder_title': '安裝資料夾',
  'studio.prj_prod.execution_setting_folder_msg1': '請輸入使用者下載商品時，安裝在本機磁碟上的資料夾名稱。',
  'studio.prj_prod.execution_setting_folder_msg2': 'DLC將安裝於遊戲母資料夾的子路徑內。如須儲存於相同資料夾，請輸入小數點符號。',
  'studio.prj_prod.execution_setting_folder_name_placeholder': '請輸入安裝資料夾名稱。',
  'studio.prj_prod.execution_setting_folder_name_req_msg': '請輸入安裝資料夾名稱。',
  'studio.prj_prod.execution_setting_folder_name_invalid_msg': '安裝資料夾名稱有誤。請重新確認。',
  'studio.prj_prod.execution_setting_dlc_auto_install_title': 'DLC自動安裝',
  'studio.prj_prod.execution_setting_dlc_auto_install_msg1': '當使用者購買DLC後，將會自動安裝。',
  'studio.prj_prod.execution_setting_dlc_auto_install_y': '使用',
  'studio.prj_prod.execution_setting_dlc_auto_install_n': '不使用',
  'studio.prj_prod.execution_setting.post_release_update_guide': 'LIVE發布審查過程中無法修改，請待審查完畢。',
  'studio.prj_prod.execution_setting.post_release_update_info_run_option': '執行選項',
  'studio.prj_prod.execution_setting.post_release_update_info_platform': '平台',
  'studio.prj_prod.execution_setting.post_release_update_info_opt_name': '選項名稱',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_file': '執行檔',
  'studio.prj_prod.execution_setting.post_release_update_info_exe_url': '執行URL',
  'studio.prj_prod.execution_setting.post_release_update_info_folder': '安裝資料夾',
  'studio.prj_prod.execution_setting.post_release_update_info_argument_value': '參數值',
  'studio.prj_prod.execution_setting.post_release_update_info_path': '工作路徑',
  'studio.prj_prod.execution_setting.post_release_update_info_process_file': '流程檔案',
  'studio.group.collection.title': '精選商品',
  'studio.group.collection.make_btn': '創建',
  'studio.group.collection.guide1': '請收集2個以上的商品，建立精選商品清單。<br/>可綑綁多種商品一次販售。',
  'studio.group.collection.register_title': '登錄精選商品',
  'studio.group.collection.register_header_name': '設定精選商品商品',
  'studio.group.collection.register_product_config': '商品組成',
  'studio.group.collection.register_product_config_place_holder': '請搜尋商品',
  'studio.group.collection.register_product_config_nation_btn': '各商品顯示國家',
  'studio.group.collection.register_product_config_list_msg1': '請選擇2個以上的商品。',
  'studio.group.collection.register_product_config_list_msg2': '有轉移商品。請刪除{prodNo}商品。',
  'studio.group.collection.register_product_config_list_msg3': '有轉移商品。請刪除{prodNo}。',
  'studio.group.collection.register_product_config_list_msg4': '尚未選擇商品。 ',
  'studio.group.collection.register_product_config_place_holder_msg1': '搜尋結果不存在。',
  'studio.group.collection.register_product_config_list_no': '商品編號',
  'studio.group.collection.register_product_config_list_type': '類型',
  'studio.group.collection.register_product_config_list_name': '商品名稱',
  'studio.group.collection.register_product_config_list_status': '狀態',
  'studio.group.collection.register_product_config_check_box': '載入代表商品情報',
  'studio.group.collection.register_product_config_check_box_guide': '基本精選商品資訊及商品頁面是依據所選的代表商品資訊自動建立的，亦可自由編輯。',
  'studio.group.collection.register_product_config_select_apply_btn': '套用',
  'studio.group.collection.register_product_config_nation_btn_select_region': '選擇區域',
  'studio.group.collection.register_basic_info': '基本資訊',
  'studio.group.collection.register_lang_setting_btn': '設定多國語言',
  'studio.group.collection.register_basic_info_name': '商品名稱',
  'studio.group.collection.register_basic_info_name_place_holder': '請輸入商品名稱',
  'studio.group.collection.register_basic_info_name_msg1': '請輸入商品名稱。',
  'studio.group.collection.register_basic_info_name_msg2': '已有相同名稱的商品。請輸入其他商品名稱。',
  'studio.group.collection.register_basic_info_creator_name': '創作者名',
  'studio.group.collection.register_basic_info_creator_name_place_holder': '請輸入創作者名稱',
  'studio.group.collection.register_basic_info_creator_name_msg1': '請輸入創作者名稱。',
  'studio.group.collection.register_basic_info_distributor_name': '發行商名',
  'studio.group.collection.register_basic_info_distributor_name_place_holder': '請輸入發行公司名稱',
  'studio.group.collection.register_basic_info_distributor_name_msg1': '請輸入發行商名稱。',
  'studio.group.collection.register_product_page': '商品頁面',
  'studio.group.collection.register_product_page_guide': '可編輯於商店中顯示的精選商品商品頁面。',
  'studio.group.collection.register_product_page_edit_btn': '編輯商品頁面',
  'studio.group.collection.register_sales_settings': '設定販售',
  'studio.group.collection.register_sales_settings_previous_price': '精選商品折扣套用前價格',
  'studio.group.collection.register_launch_discount': '發布折扣',
  'studio.group.collection.register_launch_discount_y': '使用',
  'studio.group.collection.register_launch_discount_n': '不使用',
  'studio.group.collection.register_discount_period': '折扣期間',
  'studio.group.collection.register_discount_period_text1': '自正式發布日起 ',
  'studio.group.collection.register_discount_period_text2': '天內',
  'studio.group.collection.register_discount_rate': '折扣率',
  'studio.group.collection.register_discount_rate_msg1': '請輸入精選商品折扣。',
  'studio.discount.register_rate_valid_msg': '請輸入1到100之間的值。',
  'studio.group.collection.register_price_preview': '預覽價格',
  'studio.group.collection.register_price_preview_guide':
    '以下價格是以目前販售價格為基準計算，販售價格變更時，折扣價格也會產生變化。<br/>商店中顯示的價格將依匯率不同有所變化。',
  'studio.group.collection.register_price_preview_select1': '商店顯示價格',
  'studio.group.collection.register_price_preview_select2': '支付價格',
  'studio.group.collection.register_price_preview_sub_title1': '已含在精選商品內的商品',
  'studio.group.collection.register_price_preview_sub_title2': '總共{prodNum}個 ',
  'studio.group.collection.register_price_preview_pay_info1': '商品價格',
  'studio.group.collection.register_price_preview_pay_info2': '精選商品折扣',
  'studio.group.collection.register_price_preview_pay_info3': '精選商品折扣金額',
  'studio.group.collection.register_price_preview_pay_info4': '最終販售價格',
  'studio.group.collection.register_limited_sale': '設定限定販售',
  'studio.group.collection.register_limited_sale_guide': '正式發布後，將於販售數量賣完或折扣期間結束後停止販售。',
  'studio.group.collection.register_limited_sale_option1': '販售數量賣完後暫停',
  'studio.group.collection.register_limited_sale_option2': '期間結束時停止',
  'studio.group.collection.register_limited_sale_option3': '不使用',
  'studio.group.collection.register_sales_quantity': '販售數量',
  'studio.group.collection.register_sales_quantity_text': '個',
  'studio.group.collection.register_sales_quantity_msg1': '請輸入販售數量。',
  'studio.group.collection.register_end_date': '設定結束日期',
  'studio.group.collection.register_end_date_msg1': '請將結束日期設為正式發布日後。',
  'studio.group.collection.register_plan': '發布',
  'studio.group.collection.register_plan_open_date': '商品頁面開放日',
  'studio.group.collection.register_plan_utc_view_btn': '顯示主要城市UTC',
  'studio.group.collection.register_plan_pre_order': '設定預購',
  'studio.group.collection.register_plan_pre_order_guide': '若想在正式發布前提前販售，可設定預售。',
  'studio.group.collection.register_plan_pre_order_y': '使用',
  'studio.group.collection.register_plan_pre_order_n': '不使用',
  'studio.group.collection.register_plan_pre_order_period': '設定預購期間',
  'studio.group.collection.register_plan_pre_order_period_start': '起始日',
  'studio.group.collection.register_plan_pre_order_period_end': '結束日',
  'studio.group.collection.register_plan_pre_order_period_msg1': '請將開始日期設定為商品頁面開放後。',
  'studio.group.collection.register_plan_pre_order_period_msg2': '請將結束日期設定為開始日期後。',
  'studio.group.collection.register_plan_pre_order_period_msg3': '請將結束日期設定為正式發布日期前。',
  'studio.group.collection.register_plan_official_release_date_option': '預計正式發布日顯示選項',
  'studio.group.collection.register_plan_official_release_date_option_def_value': '預計發布',
  'studio.group.collection.register_plan_official_release_date': '正式發布日',
  'studio.group.collection.register_plan_official_release_date_msg1': '請選擇正式發布日期。',
  'studio.group.collection.register_banner_img': '橫幅圖片',
  'studio.group.collection.register_banner_img_preview_btn': '預覽',
  'studio.group.collection.register_banner_img_rectangular': '方形圖片',
  'studio.group.collection.register_banner_img_portrait': '直向圖片',
  'studio.group.collection.register_banner_img_landscape': '橫向圖片',
  'studio.group.collection.register_banner_img_preview_title': '預覽圖片',
  'studio.group.collection.register_banner_img_preview_guide': '協助理解的範例圖片。',
  'studio.group.collection.register_pass_validation': '確定要將精選商品套用至LIVE嗎？',
  'studio.group.collection.list_total': '全部',
  'studio.group.collection.list_header_status': '狀態',
  'studio.group.collection.list_header_display': '展示',
  'studio.group.collection.list_header_collection_name': '精選商品名稱',
  'studio.group.collection.list_header_product_count': '商品數',
  'studio.group.collection.list_header_discount_rate': '折扣率',
  'studio.group.collection.list_header_release_date': '發布（預計）日',
  'studio.group.collection.list_header_discount_btn': '設定折扣',
  'studio.group.collection.list_search_place_holder': '搜尋精選商品',
  'studio.group.collection.list_more_btn_sales_suspention': '停售',
  'studio.group.collection.list_more_btn_display_suspention': '暫停展示',
  'studio.group.collection.list_more_btn_go_to_store': '立即前往商店',
  'studio.group.collection.list_more_btn_opening_suspention': '停止開放',
  'studio.group.collection.list_more_btn_reopening': '恢復展示',
  'studio.group.collection.list_more_btn_delete_request': '申請刪除',
  'studio.group.collection.list_more_btn_cancel_delete_request': '取消申請刪除',
  'studio.group.collection.list_more_btn_delete_request_pop_guide':
    '如欲申請刪除請輸入「DELETE」，經STOVE營運人員批准後（2~3天）即會刪除。刪除後將無法復原。',
  'studio.group.collection.list_more_btn_delete_request_place_holder': 'DELETE',
  'studio.group.collection.list_more_btn_delete_request_del_btn': '刪除',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg1': '已完成刪除請求。',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_guide': '如欲再次販售，請輸入「START」。 ',
  'studio.prj_prod.this_prod.stt_release_sale_resumed_place_holder': 'START',
  'studio.prj_prod.this_prod.stt_release_resumed_btn': '恢復',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_guide': '如欲停止開放商品頁面，請輸入「SUSPEND」。 ',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_place_holder': 'SUSPEND',
  'studio.prj_prod.this_prod.stt_product_page_withdrawn_btn': '暫停',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg2': '無法刪除的精選商品。',
  'studio.prj_prod.this_prod.stt_release_display_resumed': '恢復展示',
  'studio.prj_prod.this_prod.stt_release_display_resumed_guide': '如欲重新開始展示，請輸入「ON」。 ',
  'studio.prj_prod.this_prod.stt_release_display_resumed_place_holder': 'ON',
  'studio.prj_prod.this_prod.stt_release_display_suspended': '暫停顯示',
  'studio.prj_prod.this_prod.stt_release_display_suspended_guide': '如欲停止展示，請輸入「OFF」。 ',
  'studio.prj_prod.this_prod.stt_release_display_suspended_place_holder': 'OFF',
  'studio.group.collection.list_more_btn_delete_request_del_btn_msg3': '已取消申請刪除。',
  'studio.group.collection.list_search_result': '{searchKeyWord}搜尋結果 ',
  'studio.group.collection.list_search_result_no': '無符合搜尋條件的結果。',
  'studio.group.collection.list.details_title': '精選商品詳情',
  'studio.group.collection.list.details_del_statuts_info': '正在申請刪除的商品訊息。無法變更商品資訊。',
  'studio.group.collection.list.details_restriction_info1':
    '因<span class="font-medium text-tint-red-a400">{reportedReason}</span>暫停發布。<br/>如欲重新發布，請修改內容後透過<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.group.collection.list.details_restriction_info2':
    '因營運人員<span class="font-medium text-tint-red-a400">{restrictionType}</span>暫停發布。<br/>如欲重新發布，請修改內容後透過<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.group.collection.list.details_restriction_info3': '有不恰當內容。',
  'studio.group.collection.list.details_collection_restriction_info':
    '已因<span class="font-medium text-tint-red-a400">{restrictionType}</span>停止上市。欲重新進行上市，請刪除轉移的商品後再儲存。',
  'studio.group.collection.discount_title': '折扣',
  'studio.group.collection.discount_registration_btn': '登錄',
  'studio.group.collection.discount_main_guide':
    '可針對精選商品新增折扣。<br/>折扣率將依精選商品中的所輸入的價格為基準計算折扣。<br/>亦可進行限定數量折扣販售。',
  'studio.breadcrumb.discount_registration': '登錄折扣',
  'studio.group.collection.discount_registration_title': '登錄折扣',
  'studio.group.collection.discount_registration_discount_name': '折扣名稱',
  'studio.group.collection.discount_registration_discount_name_place_holder': '請輸入折扣名稱',
  'studio.group.collection.discount_registration_discount_name_msg1': '請輸入折扣名稱。',
  'studio.group.collection.discount_registration_start_date': '起始日',
  'studio.group.collection.discount_registration_start_date_option1': '立刻',
  'studio.group.collection.discount_registration_start_date_option2': '預約',
  'studio.group.collection.discount_registration_end_date': '結束日',
  'studio.group.collection.discount_registration_end_date_msg1': '該期限內已有重複折扣。請變更期限後重試。',
  'studio.group.collection.discount_registration_end_date_msg2': '請將預約日期請設定為目前日期以後。',
  'studio.group.collection.discount_registration_rate': '折扣率',
  'studio.group.collection.discount_registration_rate_msg1': '請輸入折扣率。',
  'studio.group.collection.discount_registration_limited_sale': '限定數量折扣販售',
  'studio.group.collection.discount_registration_limited_sale_y': '使用 ',
  'studio.group.collection.discount_registration_limited_sale_n': '不使用',
  'studio.group.collection.discount_registration_limited_quantity': '限定販售數量',
  'studio.group.collection.discount_registration_limited_quantity_text': '個',
  'studio.group.collection.discount_registration_limited_quantity_msg1': '數量應介於1至9,999,999之間。',
  'studio.group.collection.discount_registration_header_info': '價格設定為免費，折扣僅適用於付費商品。',
  'studio.group.collection.discount_registration_header_info_free': '付費',
  'studio.group.collection.discount_registration_list_sorting1': '全部',
  'studio.group.collection.discount_registration_list_sorting2': '套用／預計套用至LIVE',
  'studio.group.collection.discount_registration_list_sorting3': '結束',
  'studio.transfer.mgmt_history.detail_pg_tittle': '轉移詳情',
  'studio.transfer.mgmt_history.detail_pg_guide1':
    '為了接受轉移團隊，須輸入基本資料。<br/>我們將依照您輸入的資料申請STOVE審查；審查完成後即可接受轉移。<br/>STOVE審查期間最長需要一週。',
  'studio.transfer.mgmt_history.detail_pg_guide2': 'STOVE由原團隊依照相關法律，將專案和相關智慧財產權等所有權利及義務轉讓給新團隊，',
  'studio.transfer.mgmt_history.detail_pg_guide3': '唯有在新團隊依法有效接受此權利及義務的情況下，專案轉移才能有效進行。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name': '團隊名稱',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_place_holder': '請輸入團隊名稱',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_req_msg': '請輸入團隊名稱。',
  'studio.transfer.mgmt_history.detail_pg_info1_grp_name_dup_msg': '無法使用重複的團隊名稱，<br/>請輸入其他團隊名稱。',
  'studio.transfer.mgmt_history.request_review_btn': '申請審查',
  'studio.transfer.mgmt_history.request_review_cf_popup_msg': '確定要使用輸入的資料申請審查嗎？',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg1': '刪除團隊時，將刪除所有相關資料。<br/>資料一經刪除即無法復原。',
  'studio.business_bank_setting.group_discontinue_guide_popup_msg2': '確定要執行嗎？',
  'studio.business_bank_setting.group_discontinue_completed_popup_msg': '已刪除團隊。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg1': '無法刪除團隊。',
  'studio.business_bank_setting.group_discontinue_not_allowed_popup_msg2': '已有專案或處於轉移狀態時，無法刪除團隊。',
  'studio.business_bank_setting.title': '設定公司銀行資訊',
  'studio.business_bank_setting.individual.select_gender_required_msg': '請選擇代表人的性別。',
  'studio.business_bank_setting.individual.select_birth_wrong_format_msg': '此日期無效。請重新確認。',
  'studio.business_bank_setting.individual.game_production_no_guide_req_msg': '請附上遊戲製造（發行）業登記證。',
  'studio.business_bank_setting.individual.telecom_sales_no_guide_req_msg': '請附上通信販售業登記證。',
  'studio.business_bank_setting.account.question4_invalid_msg': '輸入的帳號無效。請重新輸入。',
  'studio.business_bank_setting.account.question5_invalid_msg': '輸入的戶名無效。請重新輸入。',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_game': '正式版Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_game': 'Demo版Game',
  'studio.prj_prod.this_prod.home_product_setting_prod_link': '連結商品 ',
  'studio.prj_prod.this_prod.home_product_setting_prod_link_guide': '請新增連結的商品。連結的商品將自動變更為該類型。',
  'studio.prj_prod.this_prod.home_product_setting_info_mismatch_new_reg_popup': '您輸入的基本資料與GRAC STOVE審議分級不符。<br/>請申請新的年齡分級。',
  'studio.prj_prod.this_prod.home_product_setting__new_reg_btn': '新增申請',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_content': '正式Content',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_content': 'Demo Content',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_basic_util': '正式Utility',
  'studio.prj_prod.this_prod.home_product_setting_prod_type_demo_util': 'Demo Utility',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_america': '北美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_america': '中美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_south_america': '南美洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_europe': '西歐',
  'studio.prj_prod.this_prod.edit_display_countries_regions_eastern_europe': '東歐',
  'studio.prj_prod.this_prod.edit_display_countries_regions_northern_europe': '北歐',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_asia': '東亞',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southeast_asia': '東南亞',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_asia': '西亞',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_asia': '南亞',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_asia': '中亞',
  'studio.prj_prod.this_prod.edit_display_countries_regions_oceania': '大洋洲',
  'studio.prj_prod.this_prod.edit_display_countries_regions_north_africa': '北非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_western_africa': '西非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_central_africa': '中非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_east_africa': '東非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_southern_africa': '南非',
  'studio.prj_prod.this_prod.edit_display_countries_regions_other': '其他',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_req_val_msg1': '請設定販售價格基準。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_standard_price_manual_input_invalid_val_msg3': '請輸入USD 0.99以上的金額。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_price_invalid_val_msg5': '包含小數點後兩位，最大金額最多可輸入8位數。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_req_val_msg1': '請輸入交易價格。',
  'studio.prj_prod.this_prod.prod_mgmt_price_reg_payment_price_invalid_val_msg2': '請輸入KRW 10以上、以10為單位的價格。 ',
  'studio.member_manage.member.invite_link_popup_case_4809': '您已向{grpName}<br/>申請加入團隊。<br/>待團隊管理者確認後即可批准加入。',
  'studio.member_manage.role_manage_list_by_menu_coupon': '序號',
  'studio.member_manage.role_manage_list_by_menu_event': '活動',
  'studio.member_manage.role_manage_list_by_menu_banner_img': '橫幅圖片',
  'studio.member_manage.member_details_pg_title': '成員詳情',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content1':
    '本手動安全審查申請及同意書（以下簡稱「本同意書」）旨在確立合作夥伴（以下簡稱「合夥人」）透過Smilegate Holdings, Inc.經由線上平台所提供之STOVE Studio服務（以下簡稱「STOVE」）進行進駐並販售商品（程式等）時的商品手動審查申請、相關合夥人責任及有關同意事項。',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_content2':
    '合夥人須保證其欲上傳至STOVE之所有商品不含病毒、蠕蟲、特洛伊木馬病毒、軟體後門、間諜軟體、勒索軟體、廣告軟體、惡意機器人等惡意Utility（以下簡稱「惡意Utility」），卻因某種原因未能通過進行之自動安全審查，故同意下述內容，同意進行手動安全審查。通過審查時即可販售商品。本同意書之同意事項適用於合夥人提交本同意書後上傳至所有商品。<br/>①合夥人所上傳之所有商品均不包含惡意Utility，亦應對所上傳之商品及相關後果負全責，<br/>②除STOVE刻意或嚴重過失外，STOVE不對合夥人上傳之產品產生的任何相關損失或問題負責，如因此與STOVE產生法律紛爭時，須自行承擔費用，免除STOVE負擔費用及責任，並賠償STOVE產生之所有損失。',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_header2': '安全水準',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_high': '高',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_basic': '一般',
  'studio.build_mgmt.build_gen_steps_0_build_prep': '正在等待建立組建',
  'studio.build_mgmt.build_steps_count': '（{currentStep}/{totalStep}階段）',
  'studio.build_mgmt.build_gen_steps_1_build_download': '正在下載組建原檔',
  'studio.build_mgmt.build_gen_steps_2_build_extract': '正在解壓縮組建原檔',
  'studio.build_mgmt.build_gen_steps_3_prev_build_check': '正在確認上一版組建',
  'studio.build_mgmt.build_gen_steps_4_drm_apply': '正在套用DRM',
  'studio.build_mgmt.build_gen_steps_5_build_file_compare': '正在比較組建檔',
  'studio.build_mgmt.build_gen_steps_6_generate': '正在建立組建檔',
  'studio.build_mgmt.build_gen_steps_7_waiting_for_completion': '正在等待完成',
  'studio.build_mgmt.security_inspection_steps_0_waiting': '正在等待安全審查',
  'studio.build_mgmt.security_inspection_steps_1_download': '正在下載組建原檔',
  'studio.build_mgmt.security_inspection_steps_2_extract': '正在解壓縮組建原檔',
  'studio.build_mgmt.security_inspection_steps_3_scan': '正在掃描組建檔',
  'studio.build_mgmt.security_inspection_steps_4_waiting_for_completion': '正在等待完成',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_failed_title': '安全審查失敗',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_inspection_success_title': '安全審查完成',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_msg': '已完成。 ',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_success_title': '組建建立完成',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_name': '姓名',
  'studio.prj_prod.this_prod.product_data.build.detph_request_manual_test_pop_request_form_applicant_signature': '（簽章）',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_files_num': '{numByItems}個',
  'studio.prj_prod_mngmt.prj_prod_reg_done.prj_file_tooltip': '可先將專案共用的圖片或影片上傳至儲存空間，並可用於管理商品頁面。',
  'studio.prod_pg.img_edit_popup.img_type1_prod_pg_bg_img': '商品頁面背景圖片',
  'studio.prod_pg.img_edit_popup.img_type2_display_vid_thumbnail': '展示影片及圖片（縮圖影片）',
  'studio.prod_pg.img_edit_popup.img_type3_display_img': '展示影片及圖片（圖片）',
  'studio.prod_pg.img_edit_popup.img_type4': '1:1圖片',
  'studio.prod_pg.img_edit_popup.img_type5': '16:9圖片',
  'studio.prod_pg.img_edit_popup.img_type6_title_bg_img': '標題背景圖片',
  'studio.prod_pg.img_edit_popup.img_type7_one_line_intro_img': '單行介紹文',
  'studio.prod_pg.img_edit_popup.img_type8_award_img': '得獎圖片',
  'studio.prod_pg.img_edit_popup.img_type9': '內容橫幅_方形圖片_2x2',
  'studio.prod_pg.img_edit_popup.img_type10': '內容橫幅_直向圖片_1x2',
  'studio.prod_pg.img_edit_popup.img_type11': '內容橫幅_橫向圖片_2x1',
  'studio.prod_pg.img_edit_popup.img_type12_pc_logo_img': 'PC客戶端商品縮略圖',
  'studio.prod_pg.img_edit_popup.img_type13_pc_recommended_img': 'PC客戶端代表推薦圖片',
  'studio.common.popup_case_lang_setting_input_required': '輸入{reqValue}後，即可設定多國語言。<br/>請輸入內容後再重試。',
  'studio.common.file_upl_guide1_1': '{acceptFileExtAttributeLabel}',
  'studio.common.file_upl_guide1_2': '{size}MB以下',
  'studio.prj_prod.execution_pc_client_logo_img_content1_fav_search': '我的最愛',
  'studio.prj_prod.execution_pc_client_logo_img_content2': '失落的方舟',
  'studio.prj_prod.execution_pc_client_logo_img_content3': '權力之望',
  'studio.prj_prod.execution_pc_client_logo_img_content4_guide1': '透過高自由度的武器選擇與成長，體驗專屬於你的戰鬥風格。',
  'studio.prj_prod.execution_pc_client_logo_img_content5': 'MMORPG · 19+',
  'studio.prj_prod.execution_pc_client_logo_img_content6_play': '遊玩',
  'studio.prj_prod.execution_pc_client_logo_img_content7_random_search': '隨機搜尋',
  'studio.prj_prod.execution_pc_client_logo_img_content8_guide2': '按下圖示<br>將推薦其他帳號。',
  'studio.common.def_key.space_not_allowed': '不可輸入空白。請重新輸入。 ',
  'studio.common.popup_case_no_access_per': '無編輯權限。<br/>請詢問團隊負責人。 ',
  'studio.lnb.common_2depth_tutorial_vid': 'Studio公告事項',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.build_required_msg': '請選擇組建。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_place_holder': '選擇',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.origin_country_required_msg': '請選擇原著國家。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reg.grac_self_review.description_required_msg': '請撰寫一行說明介紹Game。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.review_request_required_msg': '請輸入所有必要資訊後再申請審查。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_by_age': '{rating}+',
  'studio.prj_prod_mngmt.rating_build_review.self_review.post_review_guide1_rating_all': '0+',
  'studio.prj_prod_mngmt.rating_build_review.self_review_req.qtn_required_msg': '請選擇問卷項目。 ',
  'studio.prj_prod_mngmt.rating_build_review.self_review.appeal_select_content_required_msg': '請至少選擇1個以上Game所包含的內容。',
  'studio.rating_build_review.reason_input_place_holder': '請輸入申辯內容',
  'studio.prj_prod_mngmt.rating_build_review.self_review.rating_reject_appeal_required_msg': '請輸入申辯內容。 ',
  'studio.prj_prod_mngmt.rating_build_review.intl_org_save_msg':
    '儲存<span class="font-bold">國際等級分類號碼資訊<br/>。</span><br/><br/>將立即反映目前所套用的<br/>年齡分級資訊。',
  'studio.prj_prod_mngmt.rating_build_review.report_change_required_msg': '請至少選擇1個變更事項。 ',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_kr': '韓文名稱：',
  'studio.prj_prod_mngmt.rating_build_review.report_change_item_name_en': '英文名稱：',
  'studio.gnb.group_myinfo.pg_title': 'Studio我的資訊',
  'studio.registration.agreement-required': '註冊Studio時需同意服務使用條款。',
  'studio.registration.email': '電子信箱',
  'studio.registration.terms-privacy-agree': '請同意Studio使用條款及使用個人資訊。',
  'studio.registration.all-agree': '全部同意',
  'studio.stove.terms-service-required': '[STOVE]服務使用條款（必選）',
  'studio.stove.privacy-required': '[STOVE]同意收集及使用個人資訊（必選）',
  'studio.stove.ads-consent-optional': '[STOVE]同意接收廣告訊息（選擇）',
  'studio.registration.terms-service-required': '[Studio]服務使用條款（必選）',
  'studio.registration.privacy-required': '[Studio]同意收集及使用個人資料（必選）',
  'studio.registration.ads-consent-optional': '[Studio]同意接收廣告訊息（選擇）',
  'studio.registration.view-terms': '查看條款',
  'studio.registration.sign_up_btn': '註冊',
  'studio.registration.cancel-confirm': '確定要取消註冊Studio嗎？<br/>取消時，輸入的內容將會消失。',
  'studio.national_code.af': '阿富汗',
  'studio.national_code.al': '阿爾巴尼亞',
  'studio.national_code.ax': '奧蘭群島',
  'studio.national_code.an': '荷屬安地列斯',
  'studio.national_code.bv': '布威島',
  'studio.national_code.hm': '赫德島及麥唐納群島',
  'studio.national_code.tf': '法國南部地區',
  'studio.national_code.um': '美屬邊疆群島',
  'studio.national_code.dz': '阿爾及利亞',
  'studio.national_code.as': '美屬薩摩亞',
  'studio.national_code.ad': '安道爾',
  'studio.national_code.ao': '安哥拉',
  'studio.national_code.ai': '安吉拉',
  'studio.national_code.aq': '南極大陸',
  'studio.national_code.ag': '安地卡及巴布達',
  'studio.national_code.ar': '阿根廷',
  'studio.national_code.am': '亞美尼亞',
  'studio.national_code.aw': '阿魯巴',
  'studio.national_code.au': '澳洲',
  'studio.national_code.at': '奧地利',
  'studio.national_code.az': '亞塞拜然',
  'studio.national_code.bs': '巴哈馬',
  'studio.national_code.bh': '巴林',
  'studio.national_code.bd': '孟加拉',
  'studio.national_code.bb': '巴貝多',
  'studio.national_code.by': '白俄羅斯',
  'studio.national_code.be': '比利時',
  'studio.national_code.bz': '貝里斯',
  'studio.national_code.bj': '貝南',
  'studio.national_code.bm': '百慕達',
  'studio.national_code.bt': '不丹',
  'studio.national_code.bo': '玻利維亞',
  'studio.national_code.bq': '波奈島',
  'studio.national_code.ba': '波士尼亞與赫塞哥維納',
  'studio.national_code.bw': '波札那',
  'studio.national_code.br': '巴西',
  'studio.national_code.io': '英屬印度洋領地',
  'studio.national_code.vg': '英屬維京群島',
  'studio.national_code.bn': '汶萊',
  'studio.national_code.bg': '保加利亞',
  'studio.national_code.bf': '布吉納法索',
  'studio.national_code.bi': '蒲隆地',
  'studio.national_code.kh': '柬埔寨',
  'studio.national_code.cm': '喀麥隆',
  'studio.national_code.ca': '加拿大',
  'studio.national_code.cv': '維德角',
  'studio.national_code.ky': '開曼群島',
  'studio.national_code.cf': '中非共和國',
  'studio.national_code.td': '查德',
  'studio.national_code.cl': '智利',
  'studio.national_code.cn': '中國',
  'studio.national_code.cx': '聖誕島',
  'studio.national_code.cc': '科克斯群島',
  'studio.national_code.co': '哥倫比亞',
  'studio.national_code.km': '葛摩聯盟',
  'studio.national_code.cg': '剛果(布拉薩)',
  'studio.national_code.ck': '庫克群島',
  'studio.national_code.cr': '哥斯大黎加',
  'studio.national_code.ci': '象牙海岸',
  'studio.national_code.hr': '克羅埃西亞',
  'studio.national_code.cu': '古巴',
  'studio.national_code.cw': '古拉索',
  'studio.national_code.cy': '賽普勒斯',
  'studio.national_code.cz': '捷克',
  'studio.national_code.dk': '丹麥',
  'studio.national_code.dj': '吉布地',
  'studio.national_code.dm': '多明尼加',
  'studio.national_code.do': '多明尼加共和國',
  'studio.national_code.ec': '厄瓜多',
  'studio.national_code.eg': '埃及',
  'studio.national_code.sv': '薩爾瓦多',
  'studio.national_code.gq': '赤道幾內亞',
  'studio.national_code.er': '厄利垂亞',
  'studio.national_code.ee': '愛沙尼亞',
  'studio.national_code.et': '衣索比亞',
  'studio.national_code.fk': '福克蘭群島',
  'studio.national_code.fo': '法羅群島',
  'studio.national_code.fj': '斐濟',
  'studio.national_code.fi': '芬蘭',
  'studio.national_code.fr': '法國',
  'studio.national_code.gf': '法屬圭亞那',
  'studio.national_code.pf': '法屬玻里尼西亞',
  'studio.national_code.ga': '加彭',
  'studio.national_code.gm': '甘比亞',
  'studio.national_code.ge': '喬治亞',
  'studio.national_code.de': '德國',
  'studio.national_code.gh': '迦納',
  'studio.national_code.gi': '直布羅陀',
  'studio.national_code.gr': '希臘',
  'studio.national_code.gl': '格陵蘭',
  'studio.national_code.gd': '格瑞那達',
  'studio.national_code.gp': '瓜地洛普',
  'studio.national_code.gu': '關島',
  'studio.national_code.gt': '瓜地馬拉',
  'studio.national_code.gg': '根西島',
  'studio.national_code.gn': '幾內亞',
  'studio.national_code.gw': '幾內亞比索',
  'studio.national_code.gy': '蓋亞那',
  'studio.national_code.ht': '海地',
  'studio.national_code.hn': '宏都拉斯',
  'studio.national_code.hk': '香港',
  'studio.national_code.hu': '匈牙利',
  'studio.national_code.is': '冰島',
  'studio.national_code.in': '印度',
  'studio.national_code.id': '印尼',
  'studio.national_code.ir': '伊朗',
  'studio.national_code.iq': '伊拉克',
  'studio.national_code.ie': '愛爾蘭',
  'studio.national_code.im': '曼島',
  'studio.national_code.il': '以色列',
  'studio.national_code.it': '義大利',
  'studio.national_code.jm': '牙買加',
  'studio.national_code.jp': '日本',
  'studio.national_code.je': '澤西島',
  'studio.national_code.jo': '約旦',
  'studio.national_code.kz': '哈薩克',
  'studio.national_code.ke': '肯亞',
  'studio.national_code.sz': '史瓦帝尼',
  'studio.national_code.ki': '吉里巴斯',
  'studio.national_code.kw': '科威特',
  'studio.national_code.kg': '吉爾吉斯',
  'studio.national_code.la': '寮國',
  'studio.national_code.lv': '拉脫維亞',
  'studio.national_code.lb': '黎巴嫩',
  'studio.national_code.ls': '賴索托',
  'studio.national_code.lr': '賴比瑞亞',
  'studio.national_code.ly': '利比亞',
  'studio.national_code.li': '列支敦斯登',
  'studio.national_code.lt': '立陶宛',
  'studio.national_code.lu': '盧森堡',
  'studio.national_code.mo': '澳門',
  'studio.national_code.mk': '北馬其頓',
  'studio.national_code.mg': '馬達加斯加',
  'studio.national_code.mw': '馬拉威',
  'studio.national_code.my': '馬來西亞',
  'studio.national_code.mv': '馬爾地夫',
  'studio.national_code.ml': '馬利',
  'studio.national_code.mt': '馬爾他',
  'studio.national_code.mh': '馬紹爾群島',
  'studio.national_code.mq': '馬丁尼克',
  'studio.national_code.mr': '茅利塔尼亞',
  'studio.national_code.mu': '模里西斯',
  'studio.national_code.yt': '馬約特',
  'studio.national_code.mx': '墨西哥',
  'studio.national_code.fm': '密克羅尼西亞',
  'studio.national_code.md': '摩爾多瓦',
  'studio.national_code.mc': '摩納哥',
  'studio.national_code.mn': '蒙古',
  'studio.national_code.me': '蒙特內哥羅',
  'studio.national_code.ms': '蒙哲臘',
  'studio.national_code.ma': '摩洛哥',
  'studio.national_code.mz': '莫三比克',
  'studio.national_code.mm': '緬甸',
  'studio.national_code.na': '納米比亞',
  'studio.national_code.nr': '諾魯',
  'studio.national_code.np': '尼泊爾',
  'studio.national_code.nl': '荷蘭',
  'studio.national_code.nc': '新喀里多尼亞',
  'studio.national_code.nz': '紐西蘭',
  'studio.national_code.ni': '尼加拉瓜',
  'studio.national_code.ne': '尼日',
  'studio.national_code.ng': '奈及利亞',
  'studio.national_code.nu': '紐埃',
  'studio.national_code.nf': '諾福克島',
  'studio.national_code.kp': '朝鮮民主主義人民共和國',
  'studio.national_code.mp': '北馬利安納群島',
  'studio.national_code.no': '挪威',
  'studio.national_code.om': '阿曼',
  'studio.national_code.pk': '巴基斯坦',
  'studio.national_code.pw': '帛琉',
  'studio.national_code.ps': '巴勒斯坦',
  'studio.national_code.pa': '巴拿馬',
  'studio.national_code.pg': '巴布亞紐幾內亞',
  'studio.national_code.py': '巴拉圭',
  'studio.national_code.pe': '祕魯',
  'studio.national_code.ph': '菲律賓',
  'studio.national_code.pn': '皮特肯群島',
  'studio.national_code.pl': '波蘭',
  'studio.national_code.pt': '葡萄牙',
  'studio.national_code.pr': '波多黎各',
  'studio.national_code.qa': '卡達',
  'studio.national_code.re': '留尼旺',
  'studio.national_code.ro': '羅馬尼亞',
  'studio.national_code.ru': '俄羅斯',
  'studio.national_code.rw': '盧安達',
  'studio.national_code.bl': '聖巴瑟米',
  'studio.national_code.sh': '聖海倫娜島',
  'studio.national_code.kn': '聖克里斯多福及尼維斯',
  'studio.national_code.lc': '聖露西亞',
  'studio.national_code.mf': '法屬聖馬丁',
  'studio.national_code.pm': '聖皮埃與密克隆',
  'studio.national_code.vc': '聖文森及格瑞那丁',
  'studio.national_code.ws': '薩摩亞',
  'studio.national_code.sm': '聖馬利諾',
  'studio.national_code.st': '聖多美普林西比',
  'studio.national_code.sa': '沙烏地阿拉伯',
  'studio.national_code.sn': '塞內加爾',
  'studio.national_code.rs': '塞爾維亞',
  'studio.national_code.sc': '塞席爾',
  'studio.national_code.sl': '獅子山',
  'studio.national_code.sg': '新加坡',
  'studio.national_code.sx': '荷屬聖馬丁',
  'studio.national_code.sk': '斯洛伐克',
  'studio.national_code.si': '斯洛維尼亞',
  'studio.national_code.sb': '索羅門群島',
  'studio.national_code.so': '索馬利亞',
  'studio.national_code.za': '南非共和國',
  'studio.national_code.gs': '南喬治亞與南桑威奇群島',
  'studio.national_code.kr': '韓國',
  'studio.national_code.ss': '南蘇丹',
  'studio.national_code.es': '西班牙',
  'studio.national_code.lk': '斯里蘭卡',
  'studio.national_code.sd': '蘇丹',
  'studio.national_code.sr': '蘇利南',
  'studio.national_code.sj': '斯瓦巴和揚馬延',
  'studio.national_code.se': '瑞典',
  'studio.national_code.ch': '瑞士',
  'studio.national_code.sy': '敘利亞',
  'studio.national_code.tw': '台灣',
  'studio.national_code.tj': '塔吉克',
  'studio.national_code.tz': '坦尚尼亞',
  'studio.national_code.th': '泰國',
  'studio.national_code.cd': '剛果(金夏沙)',
  'studio.national_code.tl': '東帝汶',
  'studio.national_code.tg': '多哥',
  'studio.national_code.tk': '托克勞',
  'studio.national_code.to': '東加',
  'studio.national_code.tt': '千里達及托巴哥',
  'studio.national_code.tn': '突尼西亞',
  'studio.national_code.tr': '土耳其',
  'studio.national_code.tm': '土庫曼',
  'studio.national_code.tc': '土克凱可群島',
  'studio.national_code.tv': '吐瓦魯',
  'studio.national_code.vi': '美屬維京群島',
  'studio.national_code.ug': '烏干達',
  'studio.national_code.ua': '烏克蘭',
  'studio.national_code.ae': '阿拉伯聯合大公國',
  'studio.national_code.gb': '英國',
  'studio.national_code.us': '美國',
  'studio.national_code.uy': '烏拉圭',
  'studio.national_code.uz': '烏茲別克',
  'studio.national_code.vu': '萬那杜',
  'studio.national_code.va': '教廷',
  'studio.national_code.ve': '委內瑞拉',
  'studio.national_code.vn': '越南',
  'studio.national_code.wf': '瓦利斯群島與富圖那群島',
  'studio.national_code.eh': '西撒哈拉',
  'studio.national_code.ye': '葉門',
  'studio.national_code.zm': '尚比亞',
  'studio.national_code.zw': '辛巴威',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_maint': '遊戲維護',
  'studio.gnb.group_myinfo.my_group.detailed_group_edit_per_descr7': '各商品維護登錄、修改、刪除',
  'studio.gnb.group_myinfo.my_group.detailed_group_my_prj': '我的專案',
  'studio.gnb.group_myinfo.my_group.detailed_group_prj_product_list': '{prjName} 的商品 [{prodNum}]',
  'studio.gnb.group_myinfo_btn_join_req_accept': '接受',
  'studio.gnb.group_myinfo_btn_join_req_reject': '拒絕',
  'studio.gnb.group_myinfo.invitation.detailed_group_group_name': '{grpName} 群組',
  'studio.gnb.group_myinfo.invitation.detailed_group_join_time': '邀請日期與時間',
  'studio.gnb.group_myinfo.invitation.detailed_group_invite_status': '狀態',
  'studio.gnb.group_myinfo.invitation.detailed_invited_permissions': '受邀群組選單權限',
  'studio.gnb.group_myinfo.invitation.detailed_invited_prj': '受邀專案',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_list': '{prjName} 的商品 [{prodNum}]',
  'studio.gnb.group_myinfo.invitation.detailed_prj_product_name': '商品名稱',
  'studio.gnb.group_myinfo.invitation.detailed_prj_role': '角色',
  'studio.gnb.group_myinfo.invitation.detailed_permission_given_date': '權限授予日期',
  'studio.gnb.group_myinfo.invitation.detailed_prj_name': '專案名稱',
  'studio.gnb.group_myinfo.invitation.detailed_product_num': '商品數量',
  'studio.gnb.group_myinfo.invitation.detailed_btn_accept': '接受',
  'studio.gnb.group_myinfo.invitation.detailed_btn_reject': '拒絕',
  'studio.gnb.group_myinfo.join_req_btn_reject_msg': '是否要拒絕群組邀請？',
  'studio.gnb.group_myinfo.join_req_btn_reject_cf': '拒絕',
  'studio.gnb.group_myinfo.join_req_btn_accept_msg': '是否要接受群組邀請？',
  'studio.gnb.group_myinfo.join_req_btn_accept_cf': '接受',
  'studio.gnb.group_myinfo.join_req_reject_done_msg': '群組邀請已拒絕。',
  'studio.gnb.group_myinfo.join_req_accept_done_msg': '群組邀請已接受。',
  'studio.gnb.group_myinfo.join_req_btn_close': '關閉',
  'studio.gnb.group_myinfo.join_req_btn_visit_group': '訪問群組',
  'studio.gnb.group_myinfo.join_req_unknown_err_msg': '請重新整理頁面或重試。<br/>此邀請請求已被取消。',
  'studio.gnb.group_myinfo.join_req_join_req_withdrawn_msg': '此邀請請求已被取消。',
  'studio.group.home.notice': 'Studio 公告',
  'studio.group.home.notice_no': '尚無公告。',
  'studio.group.home.notice_read_more': '更多',
  'studio.group.home.board_type2_data1': '新成員已加入。',
  'studio.group.home.board_type4_data1': '與上個月相比 ',
  'studio.group.home.board_type5_plan_stt_released': '發行',
  'studio.group.home.board_type5_plan_stt_expected': '預定',
  'studio.group.notice.details_popup_title': 'Studio 公告',
  'studio.group.notice.details_popup_download': '下載',
  'studio.member_manage.member.member_title.email_header': '電子郵件',
  'studio.member_manage.member.guide4': '選單權限',
  'studio.member_manage.member.guide5': '商品權限',
  'studio.member_manage.member.guide6': '邀請成員',
  'studio.member_manage.member.guide7': '授予選單權限、商品權限',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use': '最大使用次數',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_guide': '若變更使用次數，且已有成員超過變更後的次數，則該連結將無法使用。',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_def_100': '100次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_1': '1次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_5': '5次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_10': '10次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_25': '25次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_50': '50次',
  'studio.member_manage.member_invite.mem_invite_set_link_limit_use_n': '無限制',
  'studio.member_manage.member_invite.msg2': '邀請成員名單 (1/50)',
  'studio.member_manage.member_invite.inviting_member_perm_btn': '權限',
  'studio.member_manage.member_invite.invite_btn': '邀請',
  'studio.member_manage.member_invite.invite_pop_msg': '成員邀請已完成。',
  'studio.member_manage.member_invite.email_add_step0_msg': '輸入的電子郵件對應到 N 個 STOVE 帳號。<br/>請選擇要邀請的帳號。',
  'studio.member_manage.member_invite.email_add_step0_header2': '類型',
  'studio.member_manage.member_invite.email_add_step0_header3': '暱稱',
  'studio.member_manage.member_invite.email_add_step0_cnf_btn': '確認',
  'studio.member_manage.member_invite.email_add_step0_alert1_msg': '已加入群組的帳號無法被邀請。',
  'studio.member_manage.member_invite.email_add_step0_alert2_msg': '該帳號已收到群組邀請請求。',
  'studio.member_manage.role_manage_role_name_header1': '角色名稱',
  'studio.member_manage.member_email_header1': '電子郵件',
  'studio.member_manage.project_list_email_header2': '電子郵件',
  'studio.member_manage.member_details_msg1': '電子郵件',
  'studio.member_manage.member_details_remove_cf_btn': '匯出',
  'studio.member_manage.member_details_save_alert_msg': '已儲存。',
  'studio.member_manage.history_selbox_status_all': '狀態: 全部',
  'studio.prj_prod.this_prod.edit_display_show_msg0': '顯示選項',
  'studio.prj_prod.this_prod.edit_display_show_exposed_btn': '顯示',
  'studio.prj_prod.this_prod.edit_display_show_unexposed_btn': '不顯示',
  'studio.prj_prod.this_prod.edit_gamepreview_image_guide1': '{acceptFileExtAttributeLabel}檔案｜{size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_video_guide1': '{acceptFileExtAttributeLabel}檔案｜{size}MB以下',
  'studio.prj_prod.this_prod.edit_gamepreview_msg9_2': '可新增單行介紹文上方顯示的圖片。',
  'studio.prj_prod.this_prod.edit_additional_requirements_component_val_msg': '請輸入話題。 ',
  'studio.prj_prod_mngmt.prj_prod_reg.prod_mass_reg.reg_pg_prj_name': '項目名稱',
  'studio.mail.this_release_info_del_completed_detail_msg3': '根據STOVE的運營政策，已刪除商品的銷售歷史和支付信息將被保存。',
  'studio.prj_prod.this_prod.home_product_setting_category_msg': '請選擇代表類別。',
  'studio.member_manage.member_invite.email_add_btn': '新增',
  'studio.prj_prod.this_prod.home_product_setting_msg1': 'Demo',
  'studio.prj_prod.this_prod.home_product_setting_msg2': 'DLC',
  'studio.prj_prod.this_prod.home_product_setting_msg4': 'Utility',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg1': '包含了正在發行的商品。',
  'studio.prj_prod_mngmt.popup_release_prod_exist_msg2': '請前往商品首頁 > 停止發行後再試。',
  'studio.prj_prod_mngmt.btn_prod_del': '刪除',
  'studio.prj_prod_mngmt.popup_prod_del_guide1': '刪除商品',
  'studio.prj_prod_mngmt.popup_prod_del_guide2': '如欲刪除，請輸入「DELETE」。 ',
  'studio.prj_prod_mngmt.popup_prod_del_guide3': '刪除後無法復原。',
  'studio.prj_prod_mngmt.popup_prod_del_place_holder': 'DELETE',
  'studio.business_bank_setting.guide1_3': '<span>居民登記證明書</span>',
  'studio.business_bank_setting.guide1_5': '<span>商業登記證明書</span>',
  'studio.business_bank_setting.individual.select_birth_msg2': '請僅輸入數字。',
  'studio.business_bank_setting.individual.select_birth_msg3': '註冊格式錯誤，請檢查出生日期。',
  'studio.business_bank_setting.individual.info_global_o_btn_adress': '查找地址',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder3': '郡',
  'studio.business_bank_setting.individual.info_global_o_adress_box_place_holder4': '區',
  'studio.business_bank_setting.individual.info_global_o_adress_box_required_n': '請選擇地址。',
  'studio.business_bank_setting.individual.btn_no_check': '查詢',
  'studio.business_bank_setting.individual.btn_attach_alert1': '副檔名不同，無法上傳。',
  'studio.business_bank_setting.individual.btn_attach_alert2': '超過檔案大小上限，無法上傳。',
  'studio.business_bank_setting.individual.game_production_no': '遊戲製作（發行）業登記號碼',
  'studio.business_bank_setting.individual.telecom_sales_no': '通訊銷售業登記號碼',
  'studio.business_bank_setting.individual.nation_change_alert1': '更改國家資訊時，根據最後一個國家資訊進行審查後，將於下個月1日處理變更。',
  'studio.business_bank_setting.individual.game_business_no_kr': '韓國商業登記證號',
  'studio.gnb.common_2depth_metrics': '指標',
  'studio.gnb.group_myinfo.my_group.detailed_group_role_type': '類型',
  'studio.group.home.board_type10_select_box1': 'ACU',
  'studio.group.home.board_type10_select_box2': 'NRU',
  'studio.group.home.board_type10_select_box3': 'DAU',
  'studio.member_manage.member_invite.email_add_msg1': '已經加入群組的帳戶無法邀請。',
  'studio.member_manage.member_invite.email_add_msg2': '已經請求過群組邀請的帳戶。',
  'studio.member_manage.member_invite.email_add_msg3': '該帳戶未註冊於STOVE。',
  'studio.member_manage.member_invite.email_add_msg4': '請輸入有效的電子郵件地址。',
  'studio.member_manage.member_invite.email_add_msg5': '不能超過最大可邀請的成員數量。',
  'studio.member_manage.member_invite.msg4': '邀請的電子郵件地址',
  'studio.member_manage.member_invite.msg5': '可以邀請已註冊STOVE的用戶加入Studio。僅會向已註冊STOVE的用戶發送邀請郵件！',
  'studio.member_manage.member_invite.email_add_step1_msg1': '選擇群組菜單權限',
  'studio.member_manage.member_invite.email_add_step1_msg2': '請選擇要授予成員的群組菜單權限。',
  'studio.member_manage.member_invite.email_add_step1_all_check': '全選',
  'studio.member_manage.member_invite.email_add_step1_menuname_header1': '菜單名稱',
  'studio.member_manage.member_invite.email_add_step1_view_header2': '查看',
  'studio.member_manage.member_invite.email_add_step1_edit_header3': '編輯',
  'studio.member_manage.member_invite.email_add_step1_msg3': '郵件/通知',
  'studio.member_manage.member_invite.email_add_step1_msg4': '對具有此權限的商品，將接收郵件或通知。',
  'studio.member_manage.member_invite.email_add_step1_msg5': '結算',
  'studio.member_manage.member_invite.email_add_step1_msg6': '審查',
  'studio.member_manage.member_invite.email_add_step1_msg7': '合同',
  'studio.member_manage.member_invite.email_add_step1_pro_btn': '下一步',
  'studio.member_manage.member_invite.email_add_step2_msg1': '選擇商品權限',
  'studio.member_manage.member_invite.email_add_step2_fullscreen_btn': '全屏',
  'studio.member_manage.member_invite.email_add_step2_msg2': '請選擇要授予成員的商品和角色。',
  'studio.member_manage.member_invite.email_add_step2_msg3': '必須選擇至少一個權限。',
  'studio.member_manage.member_invite.email_add_step2_selbox_place_holder': '選擇',
  'studio.member_manage.member_invite.email_add_step2_prjnproduct_header1': '專案名稱和商品名稱',
  'studio.member_manage.member_invite.email_add_step2_msg5': '當將商品添加到群組時，所選角色將自動設置。',
  'studio.member_manage.member_invite.email_add_step2_pre_btn': '上一步',
  'studio.member_manage.member_invite.email_add_step2_msg6': '沒有可授予權限的商品。<br/>群組內至少應有一個商品。',
  'studio.member_manage.member_invite.email_add_step2_help_menuname_header1': '菜單名稱',
  'studio.member_manage.member_invite.email_add_step2_help_perm_detail_header2': '編輯權限內容',
  'studio.member_manage.member_invite.email_add_step2_help_msg1': '儀表板設置',
  'studio.member_manage.member_invite.email_add_step2_help_msg2': '創建、編輯、刪除項目',
  'studio.member_manage.member_invite.email_add_step2_help_msg3': '創建、編輯、刪除商品',
  'studio.member_manage.member_invite.email_add_step2_help_msg4': '創建、編輯、刪除收藏',
  'studio.member_manage.member_invite.email_add_step2_help_msg5': '創建、編輯、刪除社區',
  'studio.member_manage.member_invite.email_add_step2_help_msg6': '邀請成員、更改權限、導出',
  'studio.member_manage.member_invite.email_add_step2_help_msg7': '註冊、修改、審查商業資訊',
  'studio.member_manage.member_invite.email_add_step2_help_msg8': '註冊和修改銀行資訊、審查',
  'studio.member_manage.member_invite.email_add_step2_help_msg9': '註冊、修改、刪除商品檢查',
  'studio.member_manage.member.list_resend_invite_pop_msg': '將再次發送邀請請求到該電子郵件。',
  'studio.member_manage.member.list_resend_invite_pop_resend_btn': '重新發送',
  'studio.member_manage.member.list_cancel_invite_pop_msg': '取消邀請請求。<br/>如果註冊已在進行中，可能無法取消。',
  'studio.member_manage.member.list_cancel_invite_pop_close_btn': '關閉',
  'studio.member_manage.member.list_cancel_invite_pop_cancel_invite.btn': '取消邀請',
  'studio.member_manage.member.list_action_alert1_msg': '請刷新或再試一次。',
  'studio.member_manage.member.list_action_alert1_cnf_btn': '確認',
  'studio.member_manage.member.list_action_alert2_msg': '該成員已經接受了群組邀請。',
  'studio.member_manage.member.list_action_alert3_msg': '該成員已拒絕群組邀請。',
  'studio.member_manage.role_manage_modified_date_header2': '修改日期',
  'studio.build_rating_review.self_review.build_search_place_holder': '搜尋',
  'studio.build_rating_review.self_review.build_search_none_registered_build': '無已登錄的組建。',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_title': '未成年禁止使用範例',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_category': '類別',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_example_description': '內容',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual': '煽情性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type1_sexual_descr': '有暴露臀部、乳頭和局部下半身、發生性關係的少量呻吟聲',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type2_violence': '暴力性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_violence_descr': '有身體毀損、器官、支解的身體、寫實的武器、過於逼真的血跡',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror': '恐怖',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type3_horror_descr':
    '有外表過於血腥的NPC(肉塊、骨頭、血跡)、驚悚的犯罪場地(屠宰場等)、令人驚嚇的要素',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language': '語言',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type4_language_descr': '有偏激用詞(幹、他媽的、智障、畜生、狗東西)等的要素',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug': '藥物',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type5_drug_descr': '有酒、菸、毒品等過多的成癮要素',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime': '犯罪',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type6_crime_descr': '有過度描述綁架、強姦、性暴力、殺人等的圖片與文字',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling': '賭博性',
  'studio.prj_prod_mngmt.rating_build_review.teen_prohibited_type7_gambling_descr':
    '有撲克牌遊戲、二十一點、One Card、Go-stop等過多賭博成分、分紅(籌碼、現金)的圖片要素',
  'studio.prj_prod_mngmt.rating_build_review.self_review.info_game_descr_sample':
    '範例)遊戲類型：<br/><br/>遊戲故事：<br/><br/><br/>遊戲說明：<br/><br/>登場人物：',
  'studio.prj_prod_mngmt.rating_build_review.direct_input.reg_completed.rating_existed_new_reg_btn': '新登錄',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.dropbox_oldest_order': '由舊到新',
  'studio.prj_prod_mngmt.rating_build_review.self_review.see_history.review_info_title': '審查資訊',
  'studio.prj_prod_mngmt.rating_build_review.see_history.case_no_data_msg': '沒有可查詢的審查資訊。 ',
  'studio.prj_prod_mngmt.rating_build_review.pre_release_change.case_info_mismatch_guide':
    '與登錄於商品設定的資訊({fields})不一致。請刪除最新審查完成資訊後再重新申請。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_btn': '刪除審查資訊',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_popup': '是否要刪除審查資訊？<br/>刪除時，須重新進行使用等級審查。',
  'studio.prj_prod_mngmt.rating_build_review.case_info_mismatch.rel_info_del_cf_btn': '刪除',
  'studio.notice.category_stu_notice': 'Studio公告',
  'studio.group.home.board_type2_mem_invite_mgmt_guide': '可邀請成員加入團隊及管理團體。',
  'studio.group.home.board_type3_no_data2': '尚無售出的商品。',
  'studio.common.popup_case_i_logout': '是否要登出？<br/>登出後未儲存的內容將會消失。',
  'studio.common.popup_case_logout_btn': '登出',
  'studio.common.footer.stu_usage_term': 'Studio使用條款',
  'studio.common.footer.stove_usage_term': '使用條款',
  'studio.common.footer.stu_personal_info_protection': '個人資料處理政策',
  'studio.common.popup_case_ai_trans_failed': 'AI自動翻譯失敗。<br/>請重新嘗試或直接輸入。',
  'studio.common.popup_case_ai_trans_required_field': '有必填項目尚未輸入內容，<br/>須輸入所有必填項目才能登錄上市計畫。',
  'studio.ai_translation.badge': 'AI翻譯',
  'studio.common.calendar_week_day.sun': '日',
  'studio.common.calendar_week_day.mon': '一',
  'studio.common.calendar_week_day.tue': '二',
  'studio.common.calendar_week_day.wed': '三',
  'studio.common.calendar_week_day.thurs': '四',
  'studio.common.calendar_week_day.fri': '五',
  'studio.common.calendar_week_day.sat': '六',
  'studio.prj_prod.this_prod.execution_setting_option_add_limit_popup': '最多可以新增至100個執行選項。',
  'studio.member_manage.member_details_role_setting_required_popup': '請選擇職務。',
  'studio.group.collection.register_discount_rate_placeholder': '0',
  'studio.group.collection.register_discount_period_req_msg': '請輸入折扣期間。 ',
  'studio.group.collection.register_discount_period_placeholder': '1~99',
  'studio.group.collection.list.details_save_completed_popup': '已儲存<br/>組合資訊。',
  'studio.build_mgmt.step_waiting': '等待中',
  'studio.build_mgmt.step_file_download': '下載檔案中',
  'studio.build_mgmt.step_file_scan': '掃描檔案中',
  'studio.build_mgmt.step_waiting_for_completion': '正在等待完成',
  'studio.build_mgmt.step_build_check': '確認組建中',
  'studio.build_mgmt.step_make_build': '建立組建中',
  'studio.build_mgmt.step_drm_apply': '正在套用DRM',
  'studio.build_mgmt.case_build_upload_error.db_gen_error_msg': '建立DB時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.path_check_error_msg': '確認路徑時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.previous_build_check_error_msg': '確認上一版組建時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.file_compare_error_msg': '比較檔案時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.storage_check_error_msg': '確認儲存空間時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.file_list_gen_error_msg': '建立檔案目錄時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.build_regist_error_msg': '登錄組建時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.upload_prep_error_msg': '準備上傳時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.upload_error_msg': '上傳時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.case_build_upload_error.upload_complete_error_msg': '完成上傳時發生錯誤。<br/>請結束上傳工具後再重新嘗試。',
  'studio.build_mgmt.build_pipeline_common_error.unknown_error_msg':
    '發生未知的錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.build_pipeline_common_error.process_prep_error_msg':
    '準備程序時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.vaccine_task_error.file_download_error_msg':
    '檔案下載時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.vaccine_task_error.file_scan_error_msg':
    '掃描檔案時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.vaccine_task_error.malicious_code_error_msg': '發現疑似惡意程式碼的檔案。<br/>如欲繼續進行，請申請手動安全審查。',
  'studio.build_mgmt.vaccine_task_error.vaccine_task_impossible_error_msg': '發現無法進行安全審查的檔案。<br/>如欲繼續進行，請申請手動安全審查。',
  'studio.build_mgmt.make_build_task_error.build_check_error_msg':
    '確認組建時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.make_build_task_error.make_build_error_msg':
    '建立組建時發生錯誤。<br/>請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.make_build_task_error.drm_apply_error_msg':
    '套用DRM時發生錯誤。<br/>請向請於<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.build_mgmt.drm_maker_task_error.process_prep_error_msg': '準備程序時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.prod_info_check_error_msg': '確認商品資訊時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.build_info_check_error_msg': '確認組建資訊時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.file_check_error_msg': '確認檔案時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.storage_check_error_msg': '確認儲存空間時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.drm_apply_error_msg': '套用DRM時發生錯誤。',
  'studio.build_mgmt.drm_maker_task_error.build_reconfig_error_msg': '重新建構組建時發生錯誤。',
  'studio.prj_prod.this_prod.product_data.build.home_product_key_tooltip_game_id': '遊戲ID',
  'studio.prj_prod.this_prod.product_data.build.home_upload_alert_msg2': 'STOVE上傳工具<br/>僅支援Windows作業系統。',
  'studio.build_mgmt.build_upload.existing_upload_guide_popup_title': '上傳說明',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg1': '有停止上傳的組建。<br/>如欲重新開始，該組建將依失敗處理。',
  'studio.build_mgmt.build_upload.existing_upload_guide_msg2': '※ 繼續進行時僅能使用相同的帳戶。',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg1': '有上傳中的組建。<br/>確定要重新上傳嗎？',
  'studio.build_mgmt.upload_in_progress_exist_popup_msg2': '※ 上傳中的組建將依失敗處理。',
  'studio.build_mgmt.upload_terminate_btn': '結束',
  'studio.build_mgmt.upload_start_new_btn': '重新開始',
  'studio.build_mgmt.build_aborted_for_new_start_popup_msg': '由於已在其他PC上開始上傳，<br/>正在進行的上傳已被取消。',
  'studio.build_mgmt.uploader.exe_impossible_guide_popup': '執行程式時發生錯誤。<br/>請向STOVE Studio營運人員詢問。',
  'studio.build_mgmt.uploader.exe_impossible_inquiry_btn': '諮詢',
  'studio.build_mgmt.uploader.terminate_guide_popup': '確定要結束<br/>STOVE Studio Uploader嗎？',
  'studio.build_mgmt.uploader.terminate_cf_btn': '結束',
  'studio.build_mgmt.uploader.error_retry_guide_popup': '發生錯誤。<br/>請稍後再重新嘗試。',
  'studio.build_mgmt.uploader.info_not_found_guide_popup': '查無商品資訊。<br/>請確認商品後再重新嘗試。',
  'studio.build_mgmt.uploader.verified_info_expired_guide_popup': '使用者驗證資訊更新失敗。<br/>請重新執行上傳工具。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg1': '正在建立檔案目錄…',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_msg2': '正在準備上傳…',
  'studio.build_mgmt.uploader.guide_popup_path_not_found': '查無檔案。<br/>請重新選擇資料夾路徑。 ',
  'studio.build_mgmt.uploader.guide_popup_invalid_folder_file_name': '請確認欲上傳的資料夾和檔名。<br/>（不得包含\\ / : * ? ＂ < > \\|。）',
  'studio.build_mgmt.uploader.guide_popup_invalid_file_exist': '有無法上傳的檔案。<br/>請刪除該檔案後再重新嘗試。',
  'studio.build_mgmt.uploader.guide_popup_build_no_change': '沒有已更新的檔案。<br/>請確認檔案後再重新嘗試。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg1': '團隊儲存所的剩餘空間不足。<br/>請刪除未上市的組建後再重新進行。',
  'studio.build_mgmt.uploader.guide_popup_inefficient_storage_msg2': '需要<span class="lackingCapa"></span>的額外容量',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_progress_stt4_upload_completed': '上傳完畢。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_terminate_upload_btn': '上傳結束',
  'studio.build_mgmt.build_upload_stt0_in_progress': '上傳中',
  'studio.prj_prod.this_prod.product_data.build.security_test_failed_learn_more_btn': '查看詳情',
  'studio.build_mgmt.build_detail.pg_title': '組建詳情',
  'studio.prj_prod.this_prod.product_data.build.details_select_file_security_standard_tooltip':
    '套用DRM Maker時，為確保商品安全將以高標準套用，失敗時請變更為一般標準後再重新嘗試。',
  'studio.business_bank_setting.individual.info_passport_copy': '護照影本',
  'studio.business_bank_setting.individual.info_passport_attach_guide': '請附上護照影本。',
  'studio.business_bank_setting.individual.info_passport_copy_req_msg': '請附上護照影本。',
  'studio.business_bank_setting.individual.query_req_msg': '請查詢營業執照編號。',
  'studio.file_upload.val_popup_size_exceed': '請確認檔案容量。',
  'studio.file_upload.val_popup_select_one': '只能選擇1個檔案。',
  'studio.file_upload.val_popup_file_format_not_supported': '不支援此檔案類型。<br/>請確認檔案的副檔名後再上傳。',
  'studio.business_bank_setting.individual.upload_resident_req_msg': '請上傳住民登錄謄本。',
  'studio.business_bank_setting.individual.game_production_no_kr_req_msg': '請附上韓國遊戲製造（發行）業登記證。',
  'studio.business_bank_setting.individual.telecom_sales_no_kr_req_msg': '請附上韓國通信販售業登記證。',
  'studio.business_bank_setting.individual.game_business_no_kr_req_msg': '請附上韓國商業登記證。 ',
  'studio.business_bank_setting.account.question6_req_msg': '請附上存摺影本。',
  'studio.business_bank_setting.account.guide1': '帳號資訊有何用途？',
  'studio.business_bank_setting.account.guide1_1': '將結算銷售款項至所輸入帳號資訊！',
  'studio.business_bank_setting.account.guide2': '如何變更帳號資訊？',
  'studio.business_bank_setting.account.guide2_1':
    '如結算及支付均已完成，則審查完畢後，將自下次支付日期開始匯至變更後的新帳號。<br/>結算明細可於「結算」選單中確認。',
  'studio.business_bank_setting.list_stt_approve': '批准',
  'studio.business_bank_setting.list_stt_reject': '退回',
  'studio.business_bank_setting.list_stt_in_review': '審查中',
  'studio.business_bank_setting.list_biz_type_indiv': '個人',
  'studio.business_bank_setting.list_biz_type_indiv_biz_owner': '個人事業者',
  'studio.business_bank_setting.list_biz_type_business': '法人事業者',
  'studio.prj_prod_mngmt.storage_upload_done.popup_del_cf_btn': '刪除',
  'studio.prj_prod_mngmt.prod_home.create_term.term_name_req_msg': '請輸入條款管理名稱。',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_place_holder': '請輸入條款內容',
  'studio.prj_prod_mngmt.prod_home.create_term.eula_content_req_msg': '請輸入條款內容。',
  'studio.prod_home.pur_cond.select_prod_req_msg': '請選擇商品。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_link': '縮圖{thumbnailSize}',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_file_thumbnail_guide': '* 如未選擇縮圖，將自動選擇影片檔的第一格畫面！',
  'studio.prj_prod.this_prod.edit_summary_place_holder0': '請輸入商品說明。',
  'studio.supported_lang.en': '英文',
  'studio.supported_lang.ko': '韓文',
  'studio.supported_lang.zh_tw': '繁體中文',
  'studio.supported_lang.zh_cn': '简体中文',
  'studio.supported_lang.ja': '日文',
  'studio.supported_lang.ge': '德文',
  'studio.supported_lang.fr': '法文',
  'studio.supported_lang.es': '西班牙文',
  'studio.supported_lang.pt': '葡萄牙文',
  'studio.supported_lang.vi': '越南文',
  'studio.supported_lang.id': '印尼文',
  'studio.supported_lang.th': '泰文',
  'studio.supported_lang.it': '義大利文',
  'studio.supported_lang.ru': '俄文',
  'studio.supported_lang.pt_br': '葡萄牙文（巴西）',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg1': '連結標題必須為1到35個字。',
  'studio.prj_prod.this_prod.edit_additional_links_name_length_val_msg2': '連結標題必須為1到15個字。',
  'studio.prj_prod.this_prod.edit_additional_links_url_req_msg1': '請輸入連結網址。',
  'studio.prj_prod.this_prod.edit_additional_links_url_length_val_msg1': '網址必須為1到2000個字。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_logo': '標誌',
  'studio.prj_prod.this_proj.this_prod.list_kebab_delete_pop_msg_case2': '確定要刪除商品頁面嗎？',
  'studio.group.collection.guide1_1': '是什麼組合？',
  'studio.group.collection.guide1_2': '組合是將團隊內最少2個、最多100個商品綑綁販售的組合商品。<br/>若商品組成中包含無法販售的商品時，將排除該商品。',
  'studio.group.collection.guide2': '可組成組合的商品是否設有條件？',
  'studio.group.collection.guide2_1': '僅能選擇符合下列所有條件的商品。',
  'studio.group.collection.guide2_1_a': '在團隊中擁有該商品的專案管理員權限',
  'studio.group.collection.guide2_1_b': '類型為遊戲、內容、Utility、DLC的商品',
  'studio.group.collection.guide2_1_c': '狀態為預購中或正式上市的商品',
  'studio.group.collection.guide3': '已購買組合中部分商品的使用者也可以購買組合嗎？',
  'studio.group.collection.guide3_1': '如果已經購買了其中的部分遊戲，可以只對尚未擁有的遊戲，以組合的折扣率計算後的價格進行購買。',
  'studio.group.collection.guide4': '組合價格是怎麼決定的？',
  'studio.group.collection.guide4_1':
    '您可以指定組成商品之販售總金額的折扣率，並設定價格。在已套用各商品折扣的情況下，將以套用商品折扣率+組合折扣率後的價格進行販售。 ',
  'studio.group.collection.guide5': '一定要登錄橫幅圖片嗎？',
  'studio.group.collection.guide5_1':
    '橫幅圖片非必要項目。<br/>登錄橫幅圖片後，STOVE商店的營運人員可讓橫幅圖片顯示於商品列表頁面，<br/>使登錄的商品在列表中更加顯眼。',
  'studio.group.collection.del_prod_from_list_btn': '刪除',
  'studio.group.collection.register_product_page_req_info_val': '尚有未輸入至商品頁面的必填資訊。',
  'studio.group.collection.register_sales_quantity_place_holder': '可輸入至1,000,000。',
  'studio.registration.email_title': '電子信箱',
  'studio.registration.email_place_holder': '請輸入電子信箱地址',
  'studio.registration.email_req_msg': '請輸入電子信箱地址。',
  'studio.registration.email_invalid_msg': '電子信箱格式不正確。',
  'studio.registration.send_verification_code_btn': '發送驗證碼',
  'studio.registration.resend_verification_code_btn': '重新發送',
  'studio.registration.send_verification_code_completed_popup': '已發送驗證碼至您輸入的電子信箱。',
  'studio.registration.verification_code_not_received_guide': '如果沒有收到驗證碼，請確認電子信箱的垃圾郵件匣，或按下重新發送按鈕。',
  'studio.registration.verification_stt_complete': '驗證完成',
  'studio.registration.verification_stt_failed': '驗證失敗',
  'studio.registration.verification_stt_code_expired': '驗證已過期',
  'studio.registration.verification_code_place_holder': '請輸入驗證碼。',
  'studio.registration.verification_code_req_msg': '請輸入驗證碼。',
  'studio.build_run_test.lnb_stu_build_test': 'Studio組建測試',
  'studio.build_run_test.stu_redir_btn': '立即前往Studio',
  'studio.build_run_test.select_prod_guide': '請選擇專案和商品。',
  'studio.build_run_test.select_pj_prod_dropbox_place_holder': '選擇專案/商品',
  'studio.build_run_test.select_pj_prod.case_no_pj_msg': 'There is no registered project.',
  'studio.build_run_test.select_pj_prod.case_no_prod_msg': '沒有已登錄的商品。',
  'studio.build_run_test.filter_search_by_prod_no': '商品編號',
  'studio.build_run_test.filter_search_by_build_no': '組建編號',
  'studio.build_run_test.no_search_results_msg': '沒有符合的搜尋結果。',
  'studio.build_run_test.no_access_per_msg1': '您沒有該商品的存取權限。',
  'studio.build_run_test.no_access_per_msg2': '請在Studio的成員管理中賦予職務。',
  'studio.build_run_test.no_build_uploaded_msg1': '沒有可測試的組建。',
  'studio.build_run_test.build_list': '組建列表',
  'studio.build_run_test.build_list.header1_build_no': '組建編號',
  'studio.build_run_test.build_list.header2_build_descr': '組建說明',
  'studio.build_run_test.build_list.header3_build_stt': '組建狀態',
  'studio.build_run_test.build_list.build_stt_test': '測試',
  'studio.build_run_test.build_list.build_stt_released': '發布',
  'studio.build_run_test.build_list.header4_release_stt': '發布狀態',
  'studio.build_run_test.build_list.test_btn': '測試',
  'studio.back_to_list_btn': '前往列表',
  'studio.build_run_test.build_info': '組建資訊',
  'studio.build_run_test.build_info1_grp': '團隊',
  'studio.build_run_test.build_info2_prj_name': '專案名稱',
  'studio.build_run_test.build_info3_prod_name': '商品名稱',
  'studio.build_run_test.build_info4_prod_type': '商品類型',
  'studio.build_run_test.build_info5_build_no': '組建編號',
  'studio.build_run_test.build_info6_decsr': '說明',
  'studio.build_run_test.build_info7_reg_date': '登錄日',
  'studio.build_run_test.build_info8_build_stt': '組建狀態',
  'studio.build_run_test.build_info9_release_stt': '發布狀態',
  'studio.prj_prod.this_prod.release_details.opt_1to2_switch_popup': '是否要和組建一起正式上市？<br/>請輸入商品頁面以外的必填資訊並申請審查。',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_period_place_holder': '1~99',
  'studio.prj_prod.this_prod.release_details_sales_setting_price_setting_introductory_discount_rate_place_holder': '0',
  'studio.age-restriction-message':
    '未滿14歲時無法使用Studio服務。<br/>詳情請透過<a href="{link}" class="font-medium underline">商店遊戲客服中心</a>進行諮詢。',
  'studio.brand_page.sign_up_btn': '開始使用STOVE Studio',
  'studio.brand_page.sign_up_btn_alert': '請於PC環境下加入。',
  'studio.brand_page.easy_and_fast_title': '讓您的遊戲<br/>簡單又迅速地<br/>在商店中上市！',
  'studio.brand_page.easy_and_fast_guide': '讓您親自製作的遊戲進駐STOVE Studio。<br/>透過教學即可簡單又迅速地快速將遊戲上市。',
  'studio.brand_page.feature_preview': '一次查看STOVE Studio的功能',
  'studio.brand_page.global_service_guide0':
    '語言問題<br/>也不必擔心。<br/>與AI翻譯一同<br/><span class="text-[#13D4FF] md:text-brand-primary">將遊戲上市全球</span>。',
  'studio.brand_page.global_sevice_guide': '提供AI解決方案，支援製作人更為簡便的全球發行及翻譯功能。',
  'studio.brand_page.global_sevice_interaction': '擁有所有類型遊戲的STOVE商店！<br/>透過AI體驗更加簡便的全球服務。',
  'studio.brand_page.store_btn': '立即前往STOVE商店',
  'studio.brand_page.all_in_one_go_title': '從審查到行銷都可以在STOVE Studio一次解決！',
  'studio.brand_page.all_in_one_go_guide':
    '困難的遊戲審查過程<br class="sm:hidden" /><br/>就由<span class="text-brand-primary">STOVE Studio</span><br />來支援吧。',
  'studio.brand_page.stove_rating_title': 'STOVE Studio提供遊戲等級分類的協助',
  'studio.brand_page.stove_rating_guide': '提供每款遊戲相當約100萬韓元的審查費用，以及為期一個月的審查申請及補充資料協助。',
  'studio.brand_page.stove_marketing_title': '與STOVE Studio一起宣傳我的遊戲',
  'studio.brand_page.stove_marketing_guide': '協助您透過關鍵字廣告、報導資料及廣告媒體宣傳遊戲。',
  'studio.brand_page.stove_event_title': '可以和遊玩我的遊戲的使用者相見',
  'studio.brand_page.stove_event_guide': '透過協助線下遊戲活動，享受更多樣化的機會。',
  'studio.brand_page.game_indicator_title': '匯集各遊戲指標於一處',
  'studio.brand_page.game_indicator_guide': '提供銷售、銷量、訪問人數等遊戲績效分析服務。',
  'studio.brand_page.game_review_title':
    '可以將我的遊戲的<br /><span class="text-on-surface-elevation-1 md:text-brand-primary">心得和意見</span>分開管理！',
  'studio.brand_page.game_review_guide':
    'Lounge是可以和所有暢玩遊戲的玩家<br class="sm:hidden">交流的空間。<br>標上#標籤，<span class="md:font-bold">查看玩家的各種想法，<br class="sm:hidden">並在遊戲更新時當作參考吧！</span>',
  'studio.direct_stove_lounge_btn': '立即前往STOVE Lounge',
  'studio.brand_page.full_service_title1': '其他的都交給STOVE Studio吧',
  'studio.brand_page.full_service_title2': '心無旁鶩地專注遊戲創作',
  'studio.brand_page.full_service_guide': '提供PC客戶端SDK、登入認證、商品付款、遊戲支援等各種平台開發工具。',
  'studio.direct_dev_guide_page_btn': '查看開發者指南',
  'studio.lnb.common_2depth_tutorial_video': '教學影片',
  'login.redirect-login-page': '前往登入頁面',
  'login.studio-redirect-brand-site': '前往官方網站',
  'studio.gnb.common_language_setting': '語言設定',
  'studio.common.lang_setting.invalid_char_val_msg': "無法使用除了- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。，以外的特殊符號。",
  'studio.redirect_prod_home_btn': '前往商品首頁',
  'studio.common.language_settings.pro_pg_ai_trans_badge': '顯示AI翻譯徽章',
  'studio.common.language_settings.pro_pg_ai_trans_tooltip': '請選擇欲使用AI翻譯的語言。<br/>商品頁面會顯示「AI翻譯」徽章。',
  'studio.registration.redirect-login-page': '前往登入頁面',
  'studio.pro_prj_mgmt.prod_name_translating_guide': '商品創建中。',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_tiltle': '前往商品首頁！ ',
  'studio.prj_prod_mngmt.prj_prod_reg_done.release_prep_tooltip_msg': '點擊列表就會回商品首頁！<br/>可以在商品首頁準備上市。',
  'studio.event_period_settings.case1_pp_open_after_pre_purchase_start': '不能晚於預購開始日期。',
  'studio.event_period_settings.case2_pp_open_after_pre_purchase_end': '不能晚於預購結束日期。',
  'studio.event_period_settings.case3_pp_open_after_official_release': '不能晚於正式上市日期。',
  'studio.event_period_settings.case4_pp_open_after_limited_sale_end': '不能晚於限定販售結束日期。',
  'studio.event_period_settings.case5_pre_purchase_start_before_pp_open': '不能早於商品頁面開放日期。',
  'studio.event_period_settings.case6_pre_purchase_start_after_pre_purchase_end': '不能晚於預購結束日期。',
  'studio.event_period_settings.case7_pre_purchase_start_after_official_release': '不能晚於正式上市日期。',
  'studio.event_period_settings.case8_pre_purchase_start_after_limited_sale_end': '不能晚於限定販售結束日期。',
  'studio.event_period_settings.case9_pre_purchase_end_before_pp_open': '不能早於商品頁面開放日期。',
  'studio.event_period_settings.case10_pre_purchase_end_before_pre_purchase_start': '不能早於預購開始日期。',
  'studio.event_period_settings.case11_pre_purchase_end_after_official_release': '不能晚於正式上市日期。',
  'studio.event_period_settings.case12_pre_purchase_end_after_limited_sale_end': '不能晚於限定販售結束日期。',
  'studio.event_period_settings.case13_official_release_before_pp_open': '不能早於商品頁面開放日期。',
  'studio.event_period_settings.case14_official_release_before_pre_purchase_start': '不能早於預購開始日期。',
  'studio.event_period_settings.case15_official_release_before_pre_purchase_end': '不能早於預購結束日期。',
  'studio.event_period_settings.case16_official_release_after_limited_sale_end': '不能晚於限定販售結束日期。',
  'studio.event_period_settings.case17_limited_sale_end_before_pp_open': '不能早於商品頁面開放日期。',
  'studio.event_period_settings.case18_limited_sale_end_before_pre_purchase_start': '不能早於預購開始日期。',
  'studio.event_period_settings.case19_limited_sale_end_before_pre_purchase_end': '不能早於預購結束日期。',
  'studio.event_period_settings.case20_limited_sale_end_before_official_release': '不能早於正式上市日期。',
  'studio.calendar_event_period.val_msg_start_time_before_current_time': '請將開放日期設定為目前日期後。',
  'studio.group.collection.register_product_none_to_select': '尚未登錄商品。',
  'studio.group.collection.collection_info': '精選商品資訊',
  'studio.group.collection.collection_basic_info': '基本資訊',
  'studio.group.collection.collection_basic_info1_prod_name': '商品名稱',
  'studio.group.collection.collection_basic_info1_prod_name_place_holder': '請輸入商品名稱',
  'studio.group.collection.collection_basic_info1_prod_name_required': '請輸入商品名稱。',
  'studio.group.collection.collection_basic_info1_prod_name_duplicate': '已有相同名稱的商品。請輸入其他商品名稱。',
  'studio.group.collection.collection_basic_info1_prod_name_invalid':
    "無法使用除了- : [ ] . TM ® # ( ) ' ! ? • {'|'} & _ \"   ~ , < > * / 、。，以外的特殊符號。",
  'studio.group.collection.collection_basic_info2_publisher_name': '創作者名',
  'studio.group.collection.collection_basic_info2_publisher_name_place_holder': '請輸入創作者名稱',
  'studio.group.collection.collection_basic_info2_publisher_name_required': '請輸入創作者名稱。',
  'studio.group.collection.collection_basic_info3_distributor_name': '發行商名',
  'studio.group.collection.collection_basic_info3_distributor_name_place_holder': '請輸入發行公司名稱',
  'studio.group.collection.collection_basic_info3_distributor_name_required': '請輸入發行公司名稱。',
  'studio.group.collection.register_btn': '登錄精選商品',
  'studio.group.collection.register_product_config_select_none_available_msg': '無載入的商品資訊<br/>請確認商品頁面的狀態。',
  'studio.group.collection.register_product_page_list_dir_btn': '商品頁面',
  'studio.supported_features.single_player': '單人遊戲',
  'studio.supported_features.multi_player': '多人遊戲',
  'studio.supported_features.pvp': 'PvP',
  'studio.supported_features.cooperative': '合作',
  'studio.supported_features.vr_support': '支援VR',
  'studio.supported_features.controller_some_support': '部分控制器支援',
  'studio.supported_features.controller_perfect_support': '完整控制器支援',
  'studio.supported_features.cloud_saving': '雲端儲存',
  'studio.supported_features.user_stat': '玩家統計值',
  'studio.supported_features.challenge': '挑戰課題',
  'studio.supported_features.match_making': '配對',
  'studio.supported_features.leader_board': '排行榜',
  'studio.supported_features.ingame_payment': '遊戲內付款',
  'studio.tooltip.product_count': '商品數',
  'studio.group.collection_list.filter_all': '全部',
  'studio.group.collection_list.filter_prod_pg_only': '商品頁面',
  'studio.group.collection_list.filter_official_release': '正式發布',
  'studio.group.collection_list.filter_suspended_or_deleted': '中斷／刪除',
  'studio.group.collection.storage_select_popup_guide': '欲在精選商品中使用儲存空間時，須選擇專案。',
  'studio.group.collection.storage_select_prj_dropbox': '請選擇專案',
  'studio.group.collection.storage_select_prj_cf_btn': '選擇',
  'studio.group.collection.storage_select_prj_required_msg': '請選擇專案。',
  'studio.group.collection.storage_select_prj_none_popup': '沒有可以使用的儲存空間。',
  'studio.group.collection.storage_search_no_result': '搜尋結果不存在。',
  'studio.group.collection.discount_case_registration_impossible': '上市前無法新增折扣選項。<br/>請上市後再重新嘗試。',
  'studio.member_manage.role_manage_reg_modified_date': '登錄／修改日',
  'studio.member_manage.role_manage_create_role_msg4': '賦予上市權限的成員需賦予所有權限。',
  'studio.common.search_place_holder': '搜尋',
  'studio.business_bank_setting.individual.review_officer_info_guide1': '請輸入負責審查遊戲發布資訊的團體內部聯絡人資訊。',
  'studio.prj_prod_mngmt.rating_build_review.self_review.biz_info_not_set_msg': '未完成企業設定而無法審查。<br/><br/>請進行企業資訊設定。',
  'studio.business_info_redirect_btn': '企業資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.prod_setting_not_completed_guide_popup':
    '未完成商品設定而無法審查。<br/><br/>請進行商品設定。',
  'studio.direct_prod_setting_pg_btn': '設定商品',
  'studio.prj_prod.this_prod.home_product_setting_basic_msg3_duplicate': '已有相同名稱的商品。請輸入其他商品名稱。請確認多語言設置。',
  'studio.prj_prod.this_prod.home_product_setting_linked_product_exist_popup': '有重複連接的商品。<br/>請重新整理後再次連接。',
  'studio.product_setting.under_review_info_genre_representative': '主要',
  'studio.prj_prod.this_prod.edit_gamepreview_import_this_media_alert1': '請確認圖片長*寬 尺寸。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_thumbnail_required_msg': '新增縮圖後，請輸入影片URL。',
  'studio.pro_pg_edit.gamepreview_spotlights_video_link_guide': '影片連結僅可套用Youtube連結。',
  'studio.prj_prod.this_prod.edit_gamepreview_spotlights_video_thumbnail_file': '縮圖860x483px（選擇）',
  'studio.prj_prod.this_prod.edit_additional_links_stove_cs': 'STOVE客服中心',
  'studio.rating_build_review.self_review_req.qtn1_guide8': '使用者間的對決要素',
  'studio.rating_build_review.self_review_req.qtn1_guide8_1': '單純水準：<br/>可以對決，但沒有損失情況下不會搶奪財物',
  'studio.rating_build_review.self_review_req.qtn1_guide8_2': '輕微水準：<br/>對決有一些獎勵與損失的情況下，可能獲得或失去點數',
  'studio.rating_build_review.self_review_req.qtn1_guide8_3': '限制水準：<br/>使用者間可以對決，但有另設PvP區或者對決功能有等級限制',
  'studio.rating_build_review.self_review_req.qtn1_guide8_4': '過度水準：<br/>PvP沒有限制，落敗的人會被奪走經驗值、道具，或是損失財物',
  'studio.rating_build_review.self_review_req.qtn3_guide2': '其他賭博性質',
  'studio.rating_build_review.self_review_req.qtn3_guide2_1': '有現金或持有跟現金性質類似的Cash，在拍賣場、交易所等內跟玩家交易或販售財物的場所',
  'studio.rating_build_review.self_review_req.qtn6_guide': '毒品類的表現方式',
  'studio.rating_build_review.self_review_req.qtn6_guide_1': '包含毒品類、黏著劑、毒氣、幻覺劑及幻覺作用<br/>包含暗示毒品交易的現場、文章、用詞',
  'studio.rating_build_review.self_review.under_review_stt_2_verifying': '審查中',
  'studio.rating_build_review.self_review.under_review_stt_3_verify_rejected': '審查駁回',
  'studio.rating_build_review.self_review.under_review_stt_4_verify_passed': '審查完畢',
  'studio.rating_build_review.self_review.under_review_stt_5_reg_completed': '登錄完成',
  'studio.prj_prod_mngmt.rating_build_review.edit_cf_msg1': '遊戲已經上市時，將立即套用修正後的年齡分級資訊。',
  'studio.prj_prod_mngmt.rating_build_review.type_self_review': 'GRAC STOVE審議分級分類',
  'studio.prj_prod_mngmt.rating_build_review.type_direct_input': '韓國等級編號',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_cancelled': '使用等級取消等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_rejected': '使用等級拒絕等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_passed': '使用等級異議申請',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_rejected': '使用等級異議申請遭駁回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_register': '登錄使用等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_modify': '修改使用等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete_msg': '已刪除使用等級資訊。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete_msg': '已刪除國際年齡分級編號。',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_verify_rejected': '使用等級遭駁回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_pass': '使用等級內容修改申報',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_revision_reject': '使用等級內容修改申報遭駁回',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_delete': '刪除使用等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_adjusted': '使用等級調整等級',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.rating_reclassification_committee_adjusted': '使用等級職權重新分類',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_register': '登錄國際等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_modify': '修改國際等級分類編號',
  'studio.prj_prod_mngmt.rating_build_review.rating_history.global_rating_delete': '刪除國際等級分類編號',
  'studio.prj_prod.this_prod.product_data.build.home_guide1_1': '完成上傳後請重新整理列表。',
  'studio.build_mgmt.list_reload_btn': '重新整理列表',
  'studio.build_mgmt.uploader_running_alert': 'Studio上傳工具執行中',
  'studio.build_mgmt.uploader_running_alert_msg1': '若尚未安裝上傳工具，請下載並安裝後再進行。',
  'studio.build_mgmt.uploader_running_alert_msg2': '完成上傳後若沒有看到組建，請重新整理。',
  'studio.build_mgmt.uploader_download_btn': '下載上傳工具',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_title': 'STOVE Studio Uploader安裝說明',
  'studio.prj_prod.this_prod.product_data.build.uploader_installation_guide_msg': '已安裝STOVE Studio Uploader。<br/>將刪除原程式並重新安裝。',
  'studio.common.btn_yes': '是',
  'studio.build_mgmt.uploader_update_guide_popup_msg': '新版本已更新。<br/>必須完成更新才能運行上傳器。',
  'studio.build_mgmt.uploader_update_btn': '立即更新',
  'studio.build_mgmt.uploader_update_ver_check_msg': '正在檢查上傳者版本。<br>可能需要最多5分鐘，請稍等！',
  'studio.build_mgmt.uploader_update_in_prog_msg': '更新中。。。',
  'studio.build_mgmt.uploader_update_error_msg': '更新過程中發生錯誤。<br/>請重新執行上傳工具。<br/>※ 持續發生問題時，請手動安裝。',
  'studio.build_mgmt.uploader_update_error.manual_run_btn': '手動安裝',
  'studio.build_mgmt.uploader_update_complete_msg': '更新完成。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step1_file_upload_guide4': '若組建列表中沒有看到上傳完成的組建，請重新整理列表。',
  'studio.build_mgmt.uploader_build_no_change_msg': 'LIVE版本組建沒有變更事項。<br/>請確認檔案後再重新嘗試。',
  'studio.prj_prod.this_prod.product_data.build.uploader_step2_file_transfer_completed_msg': '檔案完成上傳！<br/>審查完成後請進行測試。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide1_1':
    '同步STOVE平台所ˋ提供之STOVE PC SDK，可用於統計值、排名、挑戰課題、配對等遊戲支援服務，可以確認玩家的遊戲時間。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide2_1': '上傳組建後，請在上市前透過STOVE PC客戶端確認產品（遊戲）是否正常執行。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide3_1':
    '統計值是將玩家的活動數據儲存並數據化後，提供排名及挑戰課題，支援其用於統計功能。',
  'studio.prj_prod.this_prod.product_data.build.uploader_guide5_1': '此服務是支援遊戲玩家不管在哪個區域登入，都能在低延遲、舒適遊戲環境下暢玩遊戲。',
  'studio.prj_prod.this_prod.product_data.build_msg': '請完成組建測試及上市前的執行設定。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg2': '上傳時發生錯誤。<br/>請刪除紀錄後再次上傳。',
  'studio.prj_prod.this_prod.product_data.build.home_upload_status_failed_pop_msg3': '已被使用者取消。<br/>請刪除紀錄後再次上傳。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg1':
    '若不同步STOVE PC SDK，請在正式上市前套用DRM Maker以保護遊戲著作權。<br/>已同步STOVE PC SDK時，則不須套用DRM Maker，同步SDK狀態下欲套用DRM Maker時，可能無法正常安裝遊戲。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg2': '套用DRM Maker須1～3分鐘的時間。套用失敗時，請解除後再次套用。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg3': '如因執行驗證導致逾時，請修改計時器。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg4': '套用DRM Maker後，安裝時發生錯誤時，請重新套用後再執行。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_msg5': '為了套用DRM Maker，請選擇exe檔案後儲存。',
  'studio.prj_prod.this_prod.product_data.build.details_drm_maker_timeout_sec': '秒',
  'studio.prj_prod.build_mgmt.build_detail.post_release_build_update.run_option_invalid_msg': '請重新輸入執行選項，<br/>測試後再進行組建更新。',
  'studio.run_setting_pg_redirect_btn': '前往執行設定',
  'studio.prj_prod_mngmt.prod_home.prod_terms_detail.term_apply_date_required_msg': '請設定條款實施日。',
  'studio.prj_prod_mngmt.prod_home.create_term.type1_detailed_guide':
    '輸入的軟體使用者同意條款(EULA)內容會在安裝商品時，於客戶端以下列方式顯示給玩家！',
  'studio.member_manage.history_status_declined_details': '{nickName}拒絕加入。',
  'studio.member_manage.history_status_edit_depth_details_added_msg1': '已賦予{roleName}職務。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2': '已新增{perName}。',
  'studio.member_manage.history_status_edit_depth_details_added_msg2_2': '已新增{perName1}、{perName2}。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg1': '已刪除{roleName}職務。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2': '已刪除{perName}。',
  'studio.member_manage.history_status_edit_depth_details_removed_msg2_2': '已刪除{perName1}、{perName2}。',
  'studio.prj_prod.this_prod.home_search_recent': '最近的關鍵字',
  'studio.client_exe_in_prog.popup_title': 'PC客戶端執行中',
  'studio.client_exe_in_prog.popup_msg': '尚未安裝客戶端時，<br/>請下載並安裝後進行。',
  'studio.client_download_btn': '客戶端下載',
  'studio.prj_prod.this_prod.release_stt_filter_none_check_guide': '必選',
  'studio.prj_prod.this_prod.release_details_product_page_info_product_page_required_msg': '請選擇商品頁面。',
  'studio.prj_prod.this_prod.release_details_with_build_title': '正式上市商品頁面及組建。',
  'studio.prj_prod.this_prod.review_status_pbar_msg2': '正在申請審查。在營運人員審查前不得取消審查。',
  'studio.prj_prod.this_prod.release_details_release_plan_product_page_open_msg':
    '商品頁面開放日考量審查期間，可以設定為一週後的日期。商品頁面開放前可以自由修改。',
  'studio.release_details.period_settings.end_before_start_val_msg1': '結束日期須晚於開始日期。請重新設定開始日期及結束日期。',
  'studio.release_details.period_settings.end_date_input_n_val_msg3': '請設定結束日期。',
  'studio.release_details.period_settings.end_date_after_official_release_val_msg4': '請將結束日期設定為正式發布日期前。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_y_guide': '遊戲內商店已登錄。',
  'studio.prj_prod.this_prod.release_details_studio_support_in_app_shop_n_guide': '尚未登錄遊戲內商店。',
  'studio.release_details.build_prep.no_build_list_display_guide': '執行設定中以Web套用平台時，將不會顯示組建列表。',
  'studio.event_period_settings.limit_sale_end_before_release_val_msg': '請將限定販售結束日期設定為正式發布日期後。',
  'studio.prj_prod.this_prod.release_details_plan_release_schedule_setting_release_date_msg':
    '請輸入使用者可購買或下載遊玩遊戲組建的正式上市日期。正式上市日期可於自由修改到上市前。 ',
  'studio.event_period_settings.case_pp_open_after_official_release': '正式上市日期不能早於商品頁面開放日期。',
  'studio.release_info_settings.cannot_set_pre_purchase_msg': '商品頁面開放日期跟正式上市日期同一天時，將無法設定預購。',
  'studio.release_info_settings.cannot_set_early_access_msg': '商品頁面開放日期跟正式上市日期同一天時，將無法設定搶先體驗的文字。',
  'studio.home.release_timeline.prod_pg_item.release_plan_download_install_allow_n': '不允許下載及安裝',
  'studio.home.release_timeline.prod_pg_item.release_plan_exe_allow_n': '不允許執行',
  'studio.member_manage.member_details_group_owner_menu_permission_title': '選擇群組選單權限',
  'studio.member_manage.member_details_owner_product_permission_title': '選擇商品權限',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_required_msg': '請輸入轉移對象的電子信箱。 ',
  'studio.grp_prj_transfer.transfer_apply.receiver_email_not_added_msg': '請新增轉移對象的電子信箱。',
  'studio.prod_home.pur_cond.pur_cond_prod_none': '上市後可以新增到有購買條件的商品。',
  'studio.common.tutorial_video.tooltip': '教學',
  'studio.common.tutorial_video.first_entry_guide1': 'Studio教學影片',
  'studio.common.tutorial_video.first_entry_guide2': '觀看各個選單的教學影片，<br />簡單快速地登錄遊戲吧！',
  'studio.brand_page.mobile_app_sign_up_alert': '請於PC環境下註冊。',
  'studio.brand_page.feature1_main_title': '查看改版後的所有Studio功能',
  'studio.brand_page.feature1_sub_title': '來看看跟原先的Studio有哪些不同之處吧？',
  'studio.brand_page.feature2_main_title': '註冊、建立專案與商品',
  'studio.brand_page.feature2_sub_title': '註冊並建立專案與商品',
  'studio.brand_page.feature3_main_title': '設定商品首頁、商品',
  'studio.brand_page.feature3_sub_title': '了解商品首頁功能，以及設定商品的相關內容。',
  'studio.brand_page.feature4_main_title': '搶先開放商品頁面',
  'studio.brand_page.feature4_sub_title': '搶先開放商品頁面，跟玩家們交流吧 !',
  'studio.brand_page.feature5_main_title': '上傳組建並進行執行設定',
  'studio.brand_page.feature5_sub_title': '一次為您說明上傳組建、執行設定到PC客戶端測試！',
  'studio.brand_page.feature6_main_title': '登錄事業者銀行資訊、獲得自行審議等級',
  'studio.brand_page.feature6_sub_title': '登錄事業者銀行資訊，並告訴您免費獲得自行審議等級的方法！',
  'studio.brand_page.feature7_main_title': '在正式上市前設定價格及條款',
  'studio.brand_page.feature7_sub_title': '為您說明如何設定商品售價及服務所需條款。',
  'studio.brand_page.feature8_main_title': '連同組建將商品上市',
  'studio.brand_page.feature8_sub_title': '若上市準備就緒，連同組建一起正式上市吧 !',
  'studio.brand_page.feature9_main_title': '正式上市後，設定折扣及更新各功能',
  'studio.brand_page.feature9_sub_title': '為你說明正式上市後，更新商品頁面、折扣等的方法。',
  'studio.discount.register_sales_quantity_req_msg': '請輸入販售數量。',
  'studio.prj_prod.this_prod.edit_gamepreview_add_img_required msg': '請登錄圖片。',
  'studio.prod_pg_edit.additional_info_item_name_required_msg': '請輸入話題。 ',
  'studio.prod_pg_edit.additional_info_item_name_length_msg': '項目名稱請輸入15個字以內。',
  'studio.prod_pg_edit.additional_info_min_spec_length_msg': '最低規格請輸入80個字以內。',
  'studio.prod_pg_edit.additional_info_recommended_spec_length_msg': '建議規格請輸入80個字以內。',
  'studio.prj_prod.this_proj.this_prod.registered_edited_date_tooltip': '登錄日（編輯日）',
  'studio.build_run_test.operator_review_pg.select_group': '選擇群組',
  'studio.build_run_test.operator_review_pg.pre_search_def_guide': '請搜尋商品編號或組建編號。',
  'studio.prj_prod.this_prod.execution_setting_basic_option_title': '基本執行選項',
  'studio.prj_prod.this_prod.execution_setting.option_change_guide':
    '以Web平台儲存時，將刪除登錄的組建及自行審議等級。<br/>確定要變更為選擇的選項嗎？',
  'studio.common.popup_case_change_short_btn': '變更',
  'studio.prj_prod.this_prod.execution_setting.option_change_to_pc_guide': '以PC平台儲存時，<br/>可以上傳組建。',
  'studio.prj_prod.this_prod.execution_setting.build_not_uploaded_msg': '尚無完成上傳的組建。<br/>請上傳組建後再嘗試。',
  'studio.build_upload_btn': '變更',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file': '最終執行檔',
  'studio.prj_prod.this_prod.execution_setting_option_final_run_file_place_holder': '請輸入最終執行檔。',
  'studio.prj_prod.execution_setting_option_delete_pop_msg': '刪除後儲存時將無法復原。<br/>確定要刪除選擇的選項嗎？',
  'studio.prj_prod.execution_install_set_enabled_guide2_1':
    '商品上市前，可以自由修改安裝資料夾名稱。輸入的安裝資料夾名稱是玩家安裝商品時，會安裝於C:\\Program Files\\Smilegate\\Games\\(安裝資料夾名稱)路徑。',
  'studio.prj_prod.execution_install_set_enabled_guide2_2':
    '商品上市後，修改安裝資料夾名稱時，已安裝的玩家會維持原路徑，僅新安裝的玩家會套用修改的安裝資料夾名稱。',
  'studio.prj_prod.execution_exe_opt_enabled_guide4': 'PC平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide4_1_2': '- 請輸入exe檔名以上傳版本的遊戲或程式。請注意，名稱不同時將無法執行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide5': 'Web平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide6': 'Mobile平台',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name': '執行選項名稱',
  'studio.prj_prod.execution_exe_opt_enabled_guide_opt_name_content': '- 有2個以上的選項時，請詳細輸入以便玩家可以選擇執行選項進行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file': '最終執行檔',
  'studio.prj_prod.execution_exe_opt_enabled_guide_final_run_file_content':
    '- 執行檔與實際提供遊玩的最終執行檔不同時，請輸入實際可以遊玩的exe檔名（包含子路徑）。',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name': '執行選項名稱',
  'studio.prj_prod.execution_exe_opt_enabled_guide_web_opt_name_content': '- 有2個以上的選項時，請詳細輸入以便玩家可以選擇執行選項進行。',
  'studio.build_mgmt_pg_redirect_btn': '前往組建管理',
  'studio.build_run_test.search_place_holder': '輸入關鍵字',
  'studio.build_run_test.no_build_uploaded_msg2': '若看不到上傳完成的組建，<br />請確認Studio的執行設定中是否登錄PC執行選項。',
  'studio.build_run_test.dlc_guide_1': '安裝完成後執行主程式時，將包含選擇的DLC。',
  'studio.build_run_test.dlc_guide_2': '每款商品只能選擇1個組建ID。<br />（DLC非必選）',
  'studio.build_run_test.dlc_list_filter.header1_select': '選擇',
  'studio.build_run_test.dlc_list_filter.header2_prod_name': '商品名稱',
  'studio.build_run_test.dlc_list_filter.header3_build_no': '組建編號',
  'studio.build_run_test.dlc_list_filter.header4_install_yn': '是否安裝',
  'studio.build_run_test.dlc_intall_y': '安裝完成',
  'studio.build_run_test.dlc_intall_n': '未安裝',
  'studio.build_run_test.dlc_select_completed': '選擇完成',
  'studio.build_run_test.dlc_run_option': '執行選項',
  'studio.build_run_test.dlc_run_option_num': '共{totalOptNum}個',
  'studio.build_run_test.dlc_run_option_set_def_checkbox': '總是用這個選項遊玩',
  'studio.build_run_test.dlc_run_option_set_def_guide1': '只要維持此設定，下次遊玩時就不會再詢問。',
  'studio.build_run_test.dlc_run_option_set_def_guide2': '隨時可在遊戲設定中變更此設定。',
  'studio.play_btn': '遊玩',
  'studio.prj_prod.execution_install_set_enabled_guide1': '安裝設定',
  'studio.prj_prod.execution_install_set_enabled_guide1_1': '在STOVE PC客戶端上下載商品時，<br/>請設定安裝路徑。',
  'studio.lnb.prj_prod_mgmt.view_all_btn': '查看所有商品',
  'studio.ai_translation.guide1':
    "商品上市時<span class='text-[#1355FF]'>務必使用AI翻譯，以便讓世界各地的玩家都能查看</span>。<br/>AI翻譯過程中，可能會出現部分文字遺漏或無法準確翻譯的情況，因此請檢查依分頁區分的各翻譯結果後儲存！",
  'studio.stu_logged_in.pre_grp_join.guide': '製作人，<br/>開始使用Studio吧！',
  'studio.stu_logged_in.pre_grp_join.create_grp_msg3':
    '首次使用Studio時，須創建團隊。<br/>團隊是一個創作空間，也是準備遊戲上市的地方。<br/>如為代表人，請創建團隊後邀請成員。',
  'studio.prj_prod.this_prod.edit_gamepreview_import_pop_image_editor_save_storage_btn_toast': '已儲存至儲存空間！',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_1':
    '將依照選擇的平台套用於STOVE PC客戶端及商店頁面。<br />上市後預設執行設定的平台無法變更，不過可以變更詳細設定。請注意，將錯誤資訊套用至LIVE時，有可能不會正常執行。<br />請輸入所有必填項目，並測試是否能在STOVE PC客戶端上正常執行。',
  'studio.prj_prod.execution_exe_opt_enabled_guide2_2': '※PC平台請新增到預設執行選項。僅在Web平台輸入時，須登錄GRAC自評分級才可以上市。',
  'studio.prj_prod.this_prod.execution_setting_option_msg1':
    '若為PC平台，則必須在預設執行選項中正確輸入必填項目，才能在測試STOVE PC客戶端時顯示於組建列表中。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n_to_go': '前往執行設定',
  'studio.prj_prod_mngmt.rating_build_review.self_review.execution_setting_not_completed_guide_popup':
    '未完成執行設定而無法審查。<br/><br/>請進行執行設定。',
  'studio.direct_Execution_setting_pg_btn': '執行設定',
  'studio.prj_prod_mngmt.rating_build_review.self_review.parent_game_exe_setting_not_completed_guide_popup':
    '未完成遊戲本體的執行設定而無法審查。<br/><br/>請進行執行設定。',
  'studio.redirect_build_mgmt_btn': '前往組建管理',
  'studio.prj_prod_mngmt.rating_build_review.content_modify_completed_guide_msg': '已審查完畢。<br/>請在組建管理中更新組建。',
  'studio.prj_prod.this_prod.home_in_app_pur_cond_type_pc_set_n': '在執行設定中若預設執行選項為<br/>PC平台時支援的選單。',
  'studio.prj_prod.execution_install_new_guide_title1': '執行設定',
  'studio.prj_prod.execution_install_new_guide_main_des': 'Studio支援PC、Web平台。 ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_1': 'PC ',
  'studio.prj_prod.execution_install_new_guide_sub_des2_1': 'Web ',
  'studio.prj_prod.execution_install_new_guide_sub_des3_1': 'Mobile ',
  'studio.prj_prod.execution_install_new_guide_sub_des4_1': '跨平台 ',
  'studio.prj_prod.execution_install_new_guide_sub_des1_2': '請設定與STOVE PC客戶端相容的組建執行選項。',
  'studio.prj_prod.execution_install_new_guide_sub_des2_2': '選擇Web時，請輸入<br/>可以登入並遊玩網頁遊戲的URL。',
  'studio.prj_prod.execution_install_new_guide_sub_des3_2': '請輸入可從Google Play或App Store下載的URL。',
  'studio.prj_prod.execution_install_new_guide_sub_des4_2': '將預設平台設定為PC後，請點擊新增選項以將Web加入其中。',
  'studio.prj_prod.execution_install_new_guide_pc_title': '平台：PC',
  'studio.prj_prod.execution_install_new_guide_pc_main_title1': '執行檔案',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des1': '請輸入exe檔名，以在PC客戶端上執行組建。（範例：執行檔.exe）',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des2': '如子目錄路徑中有執行檔，請連同資料夾路徑在內準確輸入。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des3': '範例：上層資料夾\\執行檔.exe',
  'studio.prj_prod.execution_install_new_guide_pc_main_title2': '最終執行檔',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des1': '如PC客戶端執行檔與組建預設執行檔不同，請輸入最終執行的檔名。',
  'studio.prj_prod.execution_install_new_guide_pc_sub1_des2': '輸入時與預設執行檔相同，請包含執行檔名或子目錄路徑。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title3': '參數值',
  'studio.prj_prod.execution_install_new_guide_pc_sub2_des1': '透過命令列執行相關執行檔時，如有任何可以傳遞的參數值，請輸入該值。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title4': '工作路徑',
  'studio.prj_prod.execution_install_new_guide_pc_sub3_des1': '如執行相關執行檔時所需的檔案位置不同，請輸入該檔案的路徑。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title5': '流程檔案',
  'studio.prj_prod.execution_install_new_guide_pc_sub4_des1': '如組建的安裝檔與執行檔分開，請輸入實際執行檔名。',
  'studio.prj_prod.execution_install_new_guide_pc_main_title6': '必備程式',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des1': '請選擇在PC客戶端上執行遊戲時所需的必備程式。 ',
  'studio.prj_prod.execution_install_new_guide_pc_sub5_des2': '如不選擇必備程式，可能導致組建無法正常執行。',
  'studio.prj_prod.execution_install_new_guide_set_title': '安裝設定',
  'studio.prj_prod.execution_install_new_guide_set_main_title1': '安裝資料夾',
  'studio.prj_prod.execution_install_new_guide_set_sub_des1': '在STOVE PC客戶端上下載組建後，請輸入預計在使用者PC上安裝的路徑。',
  'studio.prj_prod.execution_install_new_guide_set_sub_des2':
    '預設安裝路徑為<br/> C:\\Program Files\\Smilegate\\Games\\（安裝資料夾名稱），只需輸入安裝資料夾名稱即可。',
  'studio.prj_prod.execution_install_new_guide_client_title': 'STOVE PC客戶端設定',
  'studio.prj_prod.execution_install_new_guide_client_main_title1': '安裝後的Windows商品啟動圖示',
  'studio.prj_prod.execution_install_new_guide_client_sub_des1': '使用者安裝遊戲時，設定為Windows桌面捷徑圖示的圖片。',
  'studio.prj_prod.execution_install_new_guide_client_sub_des2': 'ICO圖示請參閱下方指南。',
  'studio.prj_prod.execution_install_new_guide_client_main_title2': 'PC客戶端商品縮略圖',
  'studio.prj_prod.execution_install_new_guide_client_sub1_des1':
    '在使用者的STOVE PC客戶端左側的STOVE遊戲選單或我的最愛選單中，將顯示登錄的商品標誌。',
  'studio.prj_prod.execution_install_new_guide_client_main_title3': 'STOVE PC客戶端代表推薦圖片',
  'studio.prj_prod.execution_install_new_guide_client_sub2_des1': '若商店營運人員選擇您的遊戲置於首頁宣傳，請登錄欲顯示的圖片。 ',
  'studio.prj_prod.execution_install_new_guide_web_title': '平台：Web',
  'studio.prj_prod.execution_install_new_guide_web_main_title1': '執行URL ',
  'studio.prj_prod.execution_install_new_guide_web_sub_des1': '請輸入可以執行Web遊戲的URL或Web遊戲官網的URL。',
  'studio.prj_prod.execution_install_new_guide_web_sub_des2': '點擊STOVE PC客戶端面板下方的遊玩鍵時，將在網頁瀏覽器中呼叫Web遊戲。',
  'studio.prj_prod.execution_install_new_guide_mobile_title': '平台：Mobile',
  'studio.prj_prod.execution_install_new_guide_mobile_main_title1': '執行URL',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des1': '請輸入可以執行Web遊戲的URL或Web遊戲官網的URL。',
  'studio.prj_prod.execution_install_new_guide_mobile_sub_des2': '商品頁面上會顯示商城圖片，點擊後將前往輸入的商城頁面，可在該頁面下載遊戲。',
  'studio.prj_prod.execution_install_new_guide_pc_2_opt_name':
    '若已將預設執行選項設定為PC，並額外設定了PC執行選項，請輸入點擊遊玩鍵後用來選擇執行檔的執行選項名稱。',
  'studio.prj_prod_mngmt.guide1': '要讓商品上市，必須先創建專案和商品。',
  'studio.prj_prod_mngmt.guide2': '專案用於同時管理多個商品，以及簽約和結算。',
  'studio.prj_prod_mngmt.guide3': "選擇類型登錄商品後，將<span class='text-brand-primary font-medium'>創建商品首頁</span>。",
  'studio.prj_prod_mngmt.guide4': '登錄專案及商品後，請在商品首頁上開始準備販售！',
  'studio.prj_prod.this_prod.home_sales_title_type_msg': 'DEMO不提供價格及折扣。',
  'studio.prj_prod.this_prod.stt_build_live': '組建套用至LIVE ',
  'studio.prj_prod.restriction_criteria_operation_error': '動作錯誤',
  'studio.prj_prod.restriction_criteria_other': '其他',
  'studio.prod_home.release_option_select_guide': '請選擇上市方式。',
  'studio.prod_home.release_option1_official_rel':
    "<span class='text-brand-primary font-bold'>商品頁面及組建</span><span class='text-on-surface-elevation-1 font-bold'>一起正式上市。</span>",
  'studio.prod_home.release_option1_descr': '上市所需內容都準備完畢了嗎？<br/>可制定預先上市、搶先體驗等計畫並販售商品。',
  'studio.prod_home.release_option2_prod_pg_only':
    "<span class='text-on-surface-elevation-1 font-bold'>只開放</span><span class='text-brand-primary font-bold'>商品頁面</span>。",
  'studio.prod_home.release_option2_descr': '提前曝光、宣傳即將發布的商品，<br/>透過社群與使用者溝通。',
  'studio.release_status.view_btn': '查看上市現況',
  'studio.release_status.release_prep_btn': '準備上市',
  'studio.prod_page.immediate_apply_msg': '確定要立刻套用商品頁面嗎？',
  'studio.prod_page.scheduled_apply_msg': '確定要預約套用商品頁面嗎？',
  'studio.prod_page.live_page_duplicate_completed_alert': '已複製商品頁面。<br/>編輯完修改項目後，請輸入起始日並點擊儲存鍵，以套用至LIVE。',
  'studio.prod_page.under_review_page_edit_alert_msg': '複製正在審查的商品頁面即可編輯。<br/>確定要在複製的商品頁面進行編輯嗎？',
  'studio.prod_page.suspended_page_edit_alert_msg': '複製已終止的商品頁面即可編輯。<br/>確定要在複製的商品頁面進行編輯嗎？',
  'studio.business_bank_setting.account.btn_save_alert3': '正在審查銀行資訊中。<br/>請再次確認申請審查內容。',
  'studio.reject_type.product_setting': '設定商品',
  'studio.reject_type.product_page': '商品頁面',
  'studio.reject_type.price': '價格',
  'studio.reject_type.build_rating': '組建/使用等級',
  'studio.reject_type.etc': '其他',
  'studio.rating_review.included_content_none': '無',
  'studio.rating_build_review.rating_teenager_restricted': '未成年禁止使用',
  'studio.prod_home.release_price_info.discount_plan': '預計上市折扣',
  'studio.grp_home.direct_prj_reg_page': '前往登錄專案',
  'studio.prj_prod_mngmt.product_reg_tooltip_title': '請登錄商品！',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg1': '登錄商品後<br/>將創建商品首頁！',
  'studio.prj_prod_mngmt.product_reg_tooltip_msg2': '可以在商品首頁準備上市。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_title': '已創建商品！',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg1': '點擊創建的商品就會前往商品首頁。',
  'studio.prj_prod_mngmt.product_reg_completed_tooltip_msg2': '可以在商品首頁準備上市。',
  'studio.prj_prod_mngmt.storage_header_limit_guide': "<p class='text-center'>若超出提供的容量，檔案上傳將受到限制。<br>請刪除不使用的檔案。</p>",
  'studio.file_upload.name_max_length_exceed_msg': '檔名必須設為50字以內（不包含副檔名）<br/>才能上傳。',
  'studio.prod_page.live_page_edit_guide': '為{releaseStatus}狀態商品頁面。點擊編輯按鍵即可編輯複製的商品頁面。',
  'studio.edit.btn': '編輯',
  'studio.prod_page.live_page_edit_alert_msg': '複製正套用於LIVE的商品頁面即可編輯。<br/>確定要在複製的商品頁面進行編輯嗎？',
  'studio.release_list.no_record_msg1': '可以在行事曆上同時查看上市時審查現況和歷史紀錄。',
  'studio.release_list.no_record_msg2': '正式上市後，折扣、組建等更新日程將自動反映於排程上，可以輕鬆確認！',
  'studio.release_details_product_page_community_opened_msg': '已開放論壇。',
  'studio.prj_prod.this_prod.stt_pre_release': '上市前',
  'studio.release_case_parent_product_verify_pass_n.cannot_request_review_msg':
    '主商品未能通過審查。<br/>主商品必須先通過審查，才能請求附屬相關商品（DLC、Utility、Demo）。',
  'studio.event_period_settings.case_a_child_before_parent_pre_purchase_alert':
    '請將主商品（Game）的預購日期設定為等於或早於附屬商品（{prodName}）的預購日期（{prePurchaseStartTime}）。',
  'studio.event_period_settings.case_a_child_before_parent_official_release_alert':
    '請將主商品（Game）的正式上市日期設定為等於或早於附屬商品（{prodName}）的正式上市日期（{releaseStartTime}）。',
  'studio.event_period_settings.case_b_child_before_parent_pre_purchase_alert':
    '請將其設定為等於或晚於主商品（{prodName}）的預購日期（{prePurchaseStartTime}）。',
  'studio.event_period_settings.case_b_child_before_parent_official_release_alert':
    '請將其設定為等於或晚於主商品（{prodName}）的正式上市日期（{releaseStartTime}）。',
  'studio.release_stt_pbar.sale_suspended_guide.case_page_build': '已暫停販售。可重新恢復販售或將其從專案及商品管理中刪除。',
  'studio.release_stt_pbar.release_info_del_requested': '在STOVE營運人員批准刪除後，上市資訊將被刪除。',
  'studio.release_stt_pbar.user_report_release_suspended_msg': '因<span>{reportedReason}</span>原因導致暫停上市。',
  'studio.release_stt_pbar.restrict_case_cs_contact_guide':
    '確認限制原因後，請修改該功能並點擊套用於LIVE按鈕進行更新！<br/>在商店中生效後，可以透過<a class="underline" href="https://cs.onstove.com/service/STOVE_INDIE_CS/contact" target="_blank">客服中心（點擊）</a><a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.release_stt_pbar.operator_restrict_release_suspended_msg': '因<span>營運人員{restrictType}</span>原因導致暫停上市。',
  'studio.release_details.build_prep.rating_input_n_guide':
    '若在執行設定中將平台登錄為Web，請在審查年齡分級及版本選單中查詢年齡分級編號後再進行登錄。',
  'studio.prj_prod_mngmt.case_transfer_in_progress.cannot_delete_alert': '團隊處於轉移狀態時，<br/>無法刪除專案或商品。',
  'studio.transfer.mgmt_history.case_transfer_in_progress_alert': '正在進行團隊轉移。<br/>無法提出轉移申請。',
  'studio.early_access.popup_case_lang_setting_input_required': '輸入搶先體驗的說明後，<br/>即可設定多國語言。<br/>請輸入內容後再重新嘗試。',
  'studio.file_upload.case_unsupported_format_msg': '不支援的檔案類型。請確認檔案的副檔名後再上傳。',
  'studio.group.collection.register_plan_official_release_date_guide':
    '請輸入使用者可購買或下載遊玩遊戲組建的正式上市日期。<br/>正式上市日期在上市之前可以自由修改。',
  'studio.prj_prod_mngmt.del_req_x_on_sale_guide2':
    '請變更為<span class="text-[3B3D45] font-bold">停止販售</span>及<span class="text-[3B3D45] font-bold">停止開放商品頁面</span>的狀態後再申請刪除！',
  'studio.prj_prod_mngmt.prod_stt_page_and_sale_suspended': '停止開放商品頁面',
  'studio.prj_prod_mngmt.suspend_to_delete_guide_msg':
    "請變更為<span class = 'text-on-surface-elevation-2 font-medium'>停止開放商品頁面</span>的狀態後<br/>再申請刪除！",
  'studio.prj_prod_mngmt.rating_product_review.content_modify_completed_guide_msg': '審查完成。<br/>商品資訊已更新。',
  'studio.group.home.board_metrics_no data_msg': '尚無商品數據。',
  'studio.file_upload.count': '{fileName}及其他{remainingFileNum}個',
  'studio.early_access.no_change_msg': '搶先體驗文字與先前一致。<br/>修改後請按下儲存。',
  'studio.build_rating_review.details_edit_btn': '修改',
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg1':
    "<span class = 'text-on-surface-elevation-1 font-bold'>雖然您選擇的是{changRequestRating}，<br/>但依照問卷的回覆結果，</span><span class = 'text-on-surface-elevation-1 font-bold'>預估為</span><span class = 'text-tint-red-a400 font-bold'>{surveyExpectedRating}</span>。",
  'studio.rating_build_review.self_review.appeal_rating_request_not_equal_expected_msg2':
    '申請的年齡分級和預估年齡分級相異時，無法申請審查，<br/>請確認問卷後再重新申請。',
  'studio.prj_prod.this_prod.release_details_product_page_option_store_community_msg3': '已開放論壇。',
  'studio.rating_build_review.case_launch_setting_web.cannot_request_self_review_msg':
    '執行設定為WEB時，無法進行自行審議。<br/>請在詳細資訊中修改年齡分級資訊。',
  'studio.group.collection.apply_prod_info_to_collection_popup': '要將此商品的商品頁面資訊套用至組合嗎？',
  'studio.transfer.mgmt_history.case_no_product_registered_alert': '必須有1個以上的商品上市<br/>才能轉移團隊及專案。',
  'studio.prj_prod_mngmt.child_prod_exist_cannot_del': '有連結的子商品。<br/>請解除子商品的連結後再進行！',
  'studio.prj_prod_mngmt.popup_suspend_sale_guide': '欲停止販售，請輸入「SUSPEND」。<br/>停止後商店中將顯示為停止販售的狀態。',
  'studio.prj_prod.this_prod.stt_release_sale_suspended_guide': '欲停止販售，請輸入「SUSPEND」。<br/>停止後商店中將顯示為停止販售的狀態。',
  'studio.prj_prod_mngmt.page_open_cannot_del_msg': '請變更為<span class="text-[3B3D45] font-bold">停止開放商品頁面</span>的狀態後再申請刪除！',
  'studio.prj_prod_mngmt.on_sale_cannot_del_msg':
    '商品仍在販售中。<br/>請變更為<span class="text-[3B3D45] font-bold">停止販售</span>的狀態後再申請刪除！',
  'studio.prj_prod_mngmt.transfer_in_progress_cannot_del_msg': '目前有商品正在轉移中，<br/>已停止販售。<br/>請完成轉移後再重新嘗試。',
  'studio.group.home.select_product.guide': '可選擇已開放商品頁面或正式上市的商品並套用於儀表板。<br/>拖曳選擇的商品即可自由變更顯示的順序！',
  'studio.group.home.board_type3_no_data1': '商品上市後，可查看商品的累積販售數量及購買轉換率！',
  'studio.group.home.board_type6_no_data1_before': '商品上市後，可查看購買商品之 使用者的心得及留言！',
  'studio.group.home.board_type7_no_data1_before': ' 商品上市後，可查看論壇中的貼文及留言！',
  'studio.group.home.board_type8_no_data1_before': '當商品名稱被設為代表標籤並在Lounge中被提及時即可查看！',
  'studio.group.home.board_type9_no_data1_before': '商品上市後，可查看商店內的珍藏次數！',
  'studio.group.home.board_type10_no_data1': '商品上市後，可查看商品頁面的造訪人數及登入遊戲的玩家數！',
  'studio.group.home.board_type5_no_data1': '商品上市後，',
  'studio.group.home.board_type5_no_data2': '將依照上市計畫顯示日程！',
  'studio.prod_page.ready_page_edit_alert_msg': '可複製即將套用的商品頁面並進行編輯。<br/>確定要在複製的商品頁面中進行編輯嗎？',
  'studio.group_transfer_in_progress.no_action_allowed_msg': '轉移團隊時<br/>無法使用所有功能。<br/>請向團隊代表確認。',
  'login.studio-login-title': '登入STOVE Studio',
  'login.studio-login-contents': '您可以使用STOVE帳戶登入STOVE Studio。<br/>如果是初次造訪，請先註冊STOVE會員。',
  'login.studio-login-id-placeholder': '請輸入電子信箱地址。',
  'login.studio-login-pw-placeholder': '請輸入密碼。',
  'login.studio-login-signup': '註冊STOVE會員',
  'verification.need-check-age-title': '須確認年齡。',
  'verification.start-verify-age': '為了確認年齡，請進行本人驗證。',
  'verification.use-studio-verification': 'Studio服務限完成本人驗證的會員使用。',
  'verification.enter-birth-date': '請輸入出生日期。',
  'verification.service-limit-for-age': '輸入出日後，使用服務時可能會根據年齡而受到限制。',
  'studio.not-use-service': '無法使用服務。',
  'login.no-stove-account': '找不到已加入STOVE的帳戶資訊。<br/>請前往STOVE註冊頁面並完成註冊再登入。',
  'login.incorrect-stove-account': 'STOVE帳戶不一致。<br/>請重新輸入電子信箱或密碼。',
  'login.cancel-studio-signup': '確定要取消註冊Studio嗎？<br/>取消時，輸入的內容皆會消失。',
  'verification.age-restriction': '很抱歉。<br/>未滿14歲時無法使用Studio服務。',
  'login.already-studio-account': '您有帳戶已經加入Studio了。<br/>請透過電子信箱或簡易登入重新進行登入。',
  'studio.page.index.transfer_member.invalid_member_email_contents':
    '您登入了其他帳戶。<br><br>您登入的帳戶與收到轉移申請的電子信箱資訊不一致。<br>請登出並以收到轉移申請的電子信箱資訊進行登入。',
  'studio.page.index.transfer_member.invalid_link':
    '電子信箱無效。<br><br>您收到的電子郵件有效期限已過，<br>或是已完成驗證，找不到您要的頁面。<br>請重新確認。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg1': '已有等待中的年齡分級資訊。',
  'studio.build_rating_review.awaiting_rating_info_exist_msg2': '進行內容修改申報時，將會刪除等待中的年齡分級資訊。',
  'studio.group_transfer.transfer_impossible_items_exist_msg': '有無法轉交的專案及商品，無法申請轉交。',
  'studio.group_transfer.transfer_requested_prj_exist_msg': '有接受轉交研討請求的專案。<br/>轉交完成或轉交拒絕後即可申請團隊轉交。',
  'studio.group_transfer.prj_transfer_in_progress_4958_msg': '轉移專案時無法使用所有功能。<br/>請向團隊代表確認。',
  'studio.release_stt_pbar.operator_review_restrict':
    '因營運人員<span>{restrictionType}</span>導致暫停上市。請前往審查年齡分級及版本確認詳情後申請審查。',
  'studio.release_checklist.early_access_setting': '顯示搶先體驗字句',
  'studio.common.preview_btn': '預覽',
  'studio.release_info.discount_setting_title': '設定折扣',
  'studio.release_info.discount_setting_guide': '完成正式上市審查後，將會啟用折扣選單。若在上市計畫內設定了預購，將在相同期間套用登錄的折扣。',
  'studio.pre_purchase_settings.case_child_used_parent_set_unused_msg':
    '連接在主商品（Game）的商品已設定預購。<br/>將連接商品的預購設定關閉後就可以修正！',
  'studio.pre_purchase_settings.case_parent_unused_child_set_used_msg': '主商品（Game）需開啟預購設定，連接的商品也才能開啟預購設定！',
  'studio.release_info_del_requested.cannot_resume_sale_msg': '在申請刪除商品的狀態下無法使用該功能。<br/>請取消刪除申請後再使用！',
  'studio.product_page.gamepreview_my_home': '我的頁面',
  'studio.product_page.gamepreview_my_home_game_list': '擁有的遊戲',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.changed_info_other': '商品資訊',
  'studio.prj_prod_mngmt.rating_build_review.self_review.report_change.bug_fix': '修改版本',
  'studio.discount.verify_not_passed.cannot_access_msg': '跟組建一起正式上市後，若營運人員審查完成即可使用折扣選單。',
  'studio.grp_home.release_step1_prj_prod_reg': '請登錄專案及商品',
  'studio.grp_home.release_step2_release_prep': '請製作欲在商店上市的商品頁面',
  'studio.grp_home.release_step3_build_upload': '請上傳製作的組建',
  'studio.grp_home.release_step4_release': '上市商品並進行販售',
  'studio.prj_prod_mngmt.rating_build_review.edit_no_change_msg': '無變更事項。<br/>已儲存目前內容。',
  'studio.registration.close': '關閉',
  'studio.registration.do-later': '下次再說',
  'studio.prj_prod.this_prod.home_build_case_web_mobile_msg': 'Web不提供組建。',
  'studio.build_rating_review.revision_already_in_progress_msg':
    '當內容修改申報或提出異議正在審查中，或職權重新分類或等級調整措施正在進行時，您無法提交請求。<br/>請在處理完成後再提交請求！',
  'studio.prj_prod.execution_setting_option_requirements_title': '執行組建的必備程式',
  'studio.event_period_settings.case_earlier_than_current_time_msg': '上市計畫日程比目前時間還要早。<br/>請變更成晚於目前時間後儲存！',
  'studio.prj_prod_mngmt.review_restricted_case_display': '限制審議（顯示）',
  'studio.prj_prod_mngmt.review_restricted_case_run': '限制審議（執行）',
  'studio.post_release_exe_opt_update.drm_not_applied_msg': '未套用DRM。<br/>請在該組建詳情中套用DRM！',
  'studio.post_release_exe_opt_update.invalid_exe_file_msg': '執行檔（或最終執行檔）請輸入包含在DRM列表的EXE檔案路徑！',
  'studio.home_early_access_cs_contact_alert':
    '正式上市後無法顯示搶先體驗的字句。<br/>若想顯示，請透過<a class="underline" href="https://discord.com/invite/jdRFRQJrHa" target="_blank">Discord向Studio營運人員</a>詢問。',
  'studio.group.home.label_group_mem_count': '團隊成員 {grMemCount}',
  'studio.execution_setting_option.exe_file_invalid_msg': '請輸入包含在DRM列表的EXE檔案路徑。 ',
  'studio.group.collection.register_product_config_guide':
    "上市後新增組合商品時，<span class='text-on-surface-elevation-2'>在商店生效最多需要10分鐘</span>。",
  'studio.prod_page.once.language_sample_tooltip_box': '請嘗試登錄各語言的圖片！',
  'studio.prj_prod_mngmt.rating_build_review.tooltipbox_info': '請確認用於PC SDK同步的商品金鑰！',
  'studio.transfer_not_available.admin_contact_guide_msg': "轉移功能現正準備中。<br/>如需轉移，請向stove.support{'@'}smilegate.com詢問！",
  'studio.transfer_in_progress.all_features_unavailable_msg':
    "進行轉移時無法使用所有功能。<br/>請於翌日0時(UTC+9)起再確認！<br/>若有疑問請向store.support{'@'}smilegate.com詢問！",
  'studio.product_page.page_display_date_duplicate_msg': '已登錄的預約日期，請重新選擇預約日期。',
  'studio.prod_home.pur_cond.pur_cond_type2_tooltip': 'OR條件尚在準備中。',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage': '群組存儲容量',
  'studio.prj_prod.this_prod.product_data.build.home_build_storage_tooltip': '只有與先前版本不同的文件會被上傳！',
  'studio.build_run_option.exe_file_invalid_msg':
    '你已設置 DRM Maker，但可執行文件名不匹配。<br/>請在執行設置中輸入包含在 DRM 清單中的可執行文件名！',
  'studio.release_plan.drm_not_applied_msg':
    '為了保護遊戲版權，建議在構建詳細信息中應用 DRM。<br/>如果已輸入可執行文件名或最終可執行文件名，最好與 DRM Maker 保持一致！',
  'studio.release_plan.drm_applied_exe_not_matched_msg':
    'DRM 已應用。如果在執行設置中輸入了可執行文件名或最終可執行文件名，<br/>為了版權保護，它必須與 DRM Maker 清單中已應用的文件一致。',
  'studio.prod_page.one_page_only.cannot_del_msg': '僅有一個待應用的商品頁面時，無法刪除。',
  'studio.prod_page.tooltip_go_to_store_page': '移動到商店頁面。',
  'studio.storage.no_folder_available.cannot_move_file_msg': '沒有可用於移動文件的文件夾。',
  'studio.uploader.launching_in_progress_msg': '可能需要最多 5 分钟。请稍等！',
  'studio.event_period_settings.sel_discount_immediate_apply.possible_delay_msg': '選擇「立即」應用折扣後，折扣將在1-5分鐘內反映到商店。',
  'studio.execution_setting.review_in_progress.cannot_edit_msg': '在檢查進行中時無法進行修改。<br/>請確認檢查結果後再試一次。',
  'studio.live_test_page.guide_title': '我們正在準備新的STOVE Studio。',
  'studio.live_test_page.guide_msg': '更新完成後，您將能夠使用STOVE Studio。<br/><br/>請稍等片刻！',
  'studio.live_test_page.guide_info_service_name': '服務名稱',
  'studio.live_test_page.guide_info_test_period': '維護時間',
  'studio.live_test_page.guide_info_test_details': '維護內容',
  'studio.product_page.save_complete_popup': '儲存完成。<br/>現在請在商品主頁準備發行。',
  'studio.supported_lang.ms': '馬來語',
  'studio.supported_lang.ar': '阿拉伯語',
  'studio.supported_lang.nl': '荷蘭語',
  'studio.supported_lang.pl': '波蘭語',
  'studio.supported_lang.cs': '捷克語',
  'studio.supported_lang.tr': '土耳其語',
  'studio.supported_lang.etc': '其他',
  'studio.member_manage.invite_link_activate_guide': '需要啟用邀請連結，才能顯示連結！',
  'studio.product_page_resumed_msg': '商品頁面已重新開放。<br/>請在商品首頁 > 商品頁面選單中將顯示設定更改為開啟（ON）。',
  'studio.prj_prod.this_prod.product_data.build.uploader_file_failed_dll_msg':
    '由於包含 DRMChecker.dll 或 DRMCheckerV3.dll，上傳已被中斷。請刪除該文件後重新上傳。<br/>[%ErrorCode%]',
  'studio.discount.discount_rate_min_payment_range_val_msg': '支付金額可儲存為折扣後的價格，即 USD 0 或 0.99 以上，或 KRW 0 或 10 韓元以上。',
  'studio.build_test.guide_popup.client_latest_ver_download_msg': '為了進行 Studio 建置測試，請退出 STOVE PC客戶端，重新啟動並更新至最新版本。',
  'studio.verification_code.check_btn': '驗證碼驗證',
  'studio.prj_prod.this_prod.edit_gamepreview_lang_setting_not': '請確認未註冊的語言。',
  'studio.prj_prod.this_prod.edit_gamepreview_file_register_guide': '最多可添加 20 张图片！<br/>如果未添加图片，将显示基准语言中注册的图片！',
  'studio.drm_intergrity_check.not_available_for_v2_build_msg':
    '2025年3月27日之前登錄的建置無法應用DRM製作工具與完整性檢查選項。<br/>若要更新，請先登錄新的建置，然後修改相關選項。',
  'studio.game_build_upload_complete.one_time_popup_msg':
    '如果包含支援DRM製作器與完整性檢查的檔案，將自動套用這些功能。<br/>上傳組建後，請重新整理頁面以修改DRM與完整性設定。<br/><br/>是否要現在檢查執行設定？',
  'studio.run_settings_dir_btn': '前往執行設定',
  'studio.dlc_build_upload_complete.one_time_popup_msg':
    '如果包含支援完整性檢查的檔案，將自動套用。<br/>上傳組建後，請重新整理頁面以修改完整性設定。',
  'studio.build_manage.execution_settings_not_entered.cannot_revise_popup':
    '尚未輸入執行設定，因此無法提交內容修改申報。<br/><br/>請先輸入執行設定並儲存。',
  'studio.post_release_build_upd.requirements_by_change_category_guide1': '與當前應用的組建相比，所選組建有哪些變更？',
  'studio.post_release_build_upd.requirements_by_change_category_guide2':
    '如果只是進行錯誤修正，可以無需申報直接更新組建。<br/>其他變更則需要提交內容修改申報。',
  'studio.back_to_previous_page_btn': '上一頁',
  'studio.build_upd_review_not_required.set_live_schedule_guide':
    '更新資訊已儲存。<br/>請在執行設定選單中設定LIVE應用的日期與時間。<br/>必須完成LIVE應用，組建才會實際生效。<br/>若未應用，則無法反映，請務必注意。',
  'studio.build_rating_review_dir_btn.go_to_submit_request': '進行使用等級及組建審查',
  'studio.build_review_complete.set_live_schedule_guide':
    '建置審查已完成。<br/>現在，請前往執行設定菜單並設置LIVE應用日期和時間。<br/>您需要完成LIVE應用，才能使建置和執行設定生效。',
  'studio.build_rating_review_dir_btn.go_to_view_result': '查看使用等級及組建審查',
  'studio.execution_setting.page_title': 'PC 客戶端執行設定',
  'studio.execution_setting.settings_saved_no_build_guide':
    '執行設定已保存。<br/>當您上傳建置後，對應的執行設定將被應用，讓您可以在PC客戶端上進行執行測試。',
  'studio.build_mgmt_dir_btn': '建置上傳',
  'studio.execution_setting.test_package_tab_tooltip_title': '<b>執行設定已創建。</b>',
  'studio.execution_setting.test_package_tab_tooltip_msg':
    '對於其他上傳的建置，您可以在此更改執行設定。<br/>修改後的設定可以應用於LIVE建置或正在審查中的建置並進行更新。',
  'studio.execution_setting.test_package_guide1':
    '<span class="text-brand-primary font-medium">此設定適用於所有測試建置，</span> <span class="text-on-surface-elevation-2 font-medium">除LIVE狀態、內容修改申報、提出異議、職權重新分類或分級調整處理中的建置外。</span>',
  'studio.execution_setting.test_package_guide2': '更改新創建的設定中的執行選項並進行測試。<br/>保存後，點擊LIVE應用按鈕，該設定將應用於LIVE建置。',
  'studio.execution_setting.fetch_live_package_data_btn': '加載LIVE執行設定',
  'studio.execution_setting.fetch_live_data_confirm_popup': '您是否要自動加載LIVE執行設定？<br/>如果加載，您可以修改設定值並進行測試。',
  'studio.execution_setting.fetch_live_data_cf_btn': '載入',
  'studio.common.case_save_btn': '儲存',
  'studio.execution_setting.test_package_added.save_tooltip': '可以將執行設定應用於除LIVE或已完成審查的建置外的建置。<br/>儲存後，請進行工作室測試。',
  'studio.execution_setting.test_package_added.live_apply_tooltip': '可以將執行設定應用於LIVE或已完成審查的建置。<br/>請在充分測試後應用於LIVE。',
  'studio.execution_setting.live_apply_popup_title': '套用至LIVE',
  'studio.execution_setting.live_apply_popup_select_build': '選擇建置',
  'studio.execution_setting.live_apply_popup_build_required_msg': '請選擇要應用的建置。',
  'studio.execution_setting.live_apply_date_title': 'LIVE應用日期',
  'studio.execution_setting.live_apply_popup_immediate': '立刻',
  'studio.execution_setting.live_apply_popup_scheduled': '預約',
  'studio.event_period_settings.execution_setting.before_current_time_invalid_msg': '請選擇當前時間之後的日期。',
  'studio.execution_setting.select_build.build_category_live': '[LIVE應用中]',
  'studio.execution_setting.select_build.build_category_under_review': '[審查中]',
  'studio.execution_setting.select_build.build_category_review_passed': '[審查完成]',
  'studio.execution_setting.select_build.build_category_fix_bug': '[錯誤修正]',
  'studio.execution_setting.select_build.build_category_direct_input': '[使用等級直接輸入]',
  'studio.execution_setting.select_build.build_scheduled': '[預約]',
  'studio.execution_setting.test_tab': '執行設定',
  'studio.execution_setting.scheduled_tab': '執行設定預約',
  'studio.execution_setting.live_tab': 'LIVE執行設定',
  'studio.execution_setting.scheduled_info_guide': '建置和執行設定將應用於LIVE。',
  'studio.execution_setting.build_info': '建置資訊',
  'studio.build_exe_test_ok.popup_title': '測試確認',
  'studio.build_exe_test_ok.popup_guide': '若您已完成測試，請輸入「TESTOK」。<br/>若未經測試就進行，可能會在遊戲執行時發生問題。',
  'studio.common.popup_case_next_btn': '繼續 ',
  'studio.execution_setting.scheduled_pack_cancel_btn': '取消排程',
  'studio.execution_setting.scheduled_pack_cancel_confirm_popup': 'LIVE執行設定已排定。取消後需要重新設定。<br/>是否要繼續？',
  'studio.brand_page.feature2-1_main_title': '嘗試邀請成員並管理角色',
  'studio.brand_page.feature2-1_sub_title': '將成員邀請至群組並分配角色。',
  'studio.execution_setting.select_scheduled_build.warning_msg': '原先排程的建置將會被取消，並由新的建置取代。',
  'studio.execution_setting.exe_file_extension_required_msg': '請在執行檔名稱中包含「.exe」。',
  'studio.execution_setting.final_exe_entered.exe_file_required_msg': '如已輸入最終執行檔，也請一併輸入執行檔。',
  'studio.prj_prod.execution_install_new_guide_pc_sub_des4': '工具類產品可不含執行檔註冊，這種情況下，STOVE PC客戶端會開啟安裝資料夾。',
  'studio.member_manage.new_join_request_guide': '目前有{requestNum}位成員申請加入。<br/>請點擊下方的［等待加入］按鈕查看！',
  'studio.business_bank_setting.checkbox_use_representative_info': '與代表人資訊相同。',
  'studio.business_bank_setting.non_kr_postal_code_place_holder': '郵遞區號（選填）',
  'studio.business_bank_setting.jp_address_place_holder': '請輸入地址（選填）',
  'studio.business_bank_setting.non_kr_detailed_address_place_holder': '請輸入詳細地址（選填）',
  'studio.business_bank_setting.usa_building_name_place_holder': '請輸入建築物名稱（選填）',
  'studio.business_bank_setting.usa_street_name_place_holder': '請輸入街道名稱（選填）',
  'studio.business_bank_setting.usa_city_name_place_holder': '請輸入城市名稱（選填）',
  'studio.business_bank_setting.usa_district_name_place_holder': '請輸入州名（選填）',
  'studio.build_manage.upload_description_required_msg': '請輸入建置說明。',
  'studio.common.def_key.emoji_n': '請勿使用表情符號。'
};
